const messages = {

    en: {
        util: {
            home_2: "Home",
            exit_2: "exit",
            session: "Log out",
            new_proyect: "Create new project",
            admin_contract: "manage contract",
            prest_academy_new: "PREST Academy",
            development_plans: "Development Plans",
            improvement_plans: "Improvement Plans",
            my_profile: "My profile",
            student_population: "1 student population",
            graduates: "1.1 Graduates",
            admitted: "1.2 Admitted",
            student_supports: "1.3 Student supports",
            slots: "1.4 Slots",
            articulation_students: "1.5 Articulation Students",
            first_course_students: "1.6 First Course Students",
            enrolled_program: "1.7 Enrolled in Program",
            enrolled: "1.8 Enrolled",
            registered: "1.9 Registered",
            disciplinary_withdrawals: "1.10 Disciplinary Withdrawals",
            population_tracking: "1.11 Population Tracking",


            extension: "2 Extension",
            extension_services: "2.1 Extension Services",
            extension_services_item: "2.1.1 Extension Services",
            work_area: "2.1.2 Work Area",
            life_cycle: "2.1.3 Life Cycle",
            national_entity: "2.1.4 National Entity",
            international_source: "2.1.5 International Source",
            national_source: "2.1.6 National Source",
            other_entities: "2.1.7 Other Entities",
            population_condition: "2.1.8 Population Condition",
            population_group: "2.1.9 Population Group",


            extension_project: "2.2 Extension Project",
            project_extension: "2.2.1 Extension Project",
            work_area_2: "2.2.2 Work Area",
            life_cycle_2: "2.2.3 Life Cycle",
            national_entity_2: "2.2.4 National Entity",
            international_source_2: "2.2.5 International Source",
            national_source_2: "2.2.6 National Source",
            other_entities_2: "2.2.7 Other Entities",
            population_condition_2: "2.2.8 Population Condition",
            population_group_2: "2.2.9 Population Group",

            continuing_education: "2.3 Continuing Education",
            continuing_education_item: "2.3.1 Continuing Education",
            continuing_education_teachers: "2.3.2 Continuing Education Teachers",
            continuing_education_beneficiaries: "2.3.3 Continuing Education Beneficiaries",

            event_cultural: "2.4 Cultural Event",
            event_cultural_item: "2.4.1 Cultural Event",
            national_source_4: "2.4.2 National Source",
            international_source_4: "2.4.3 International Source",
            human_resource: "2.4.4 Human Resource",
            beneficiaries: "2.4.5 Beneficiaries",

            courses: "2.5 Courses",
            course: "2.5.1 Course",

            menu_consulting: "2.6 Consulting",
            menu_consulting_item: "2.6.1 Consulting",
            menu_human_resource: "2.6.2 Human Resource",

            menu_cultural_activity: "2.7 Cultural Activity",
            menu_cultural_activity_item: "2.7.1 Cultural Activity",
            menu_cultural_human_resource: "2.7.2 Human Resource",

            wellness: "3. Wellness",
            wellness_activity: "3.1 Wellness Activity",
            wellness_2: "3.1.1 Wellness",
            beneficiaries_2: "3.1.2 beneficiaries",
            human_resource_2: "3.1.3 human resources",

            investigation: "4 Investigation",
            research_networks: "4.1 research networks",
            networks: "4.1.1 networks",
            Ies_network: "4.1.2 Ies network",
            network_members: "4.1.3 Network Members",

            // 4.3 Research Products
            research_products: "4.3 Research Products",
            research_products_item: "4.3.1 Products",

            // 4.4 Other Research Activities
            other_research_activities: "4.4 Other Research Activities",
            research_activity: "4.4.1 Research Activity",
            research_activity_national: "4.4.2 Research Activity National Source",
            research_activity_international: "4.4.3 Research Activity International Source",
            research_activity_expense: "4.4.4 Research Activity Expenses",

            // 4.5 Research Groups
            research_groups: "4.5 Research Groups",
            research_group: "4.5.1 Research Group",
            research_group_internal: "4.5.2 Research Internal IES",
            research_group_external: "4.5.3 Research External IES",

            // 4.6 Research Centers
            research_centers: "4.6 Research Centers",
            research_center: "4.6.1 Research Center",
            research_center_group: "4.6.2 Research Center Group",


            projects_investigation: "4.2 Research Projects",
            project_investigation: "4.2.1 Research Project",
            project_investigation_center: "4.2.2 Research Project Center",
            project_investigation_group: "4.2.3 Research Project Group",
            project_investigation_network: "4.2.4 Research Project Network",
            project_investigation_product: "4.2.5 Research Project Product",
            project_investigation_national: "4.2.6 Research Project National Source",
            project_investigation_international: "4.2.7 Research Project International Source",
            project_investigation_expense: "4.2.8 Research Project Expense",
            project_investigation_internal: "4.2.9 Internal IES",
            project_investigation_external: "4.2.10 External IES",

            // 5 Internationalization
            internationalization: "5 Internationalization",
            international_programs: "5.1 Programs Abroad",
            student_mobility_colombia: "5.2 Student Mobility in Colombia",
            student_mobility_abroad: "5.3 Student Mobility Abroad",
            teacher_mobility_abroad: "5.4 Teacher Mobility Abroad",
            teacher_mobility_colombia: "5.5 Teacher Mobility to Colombia",
            admin_mobility_colombia: "5.6 Administrative Staff Mobility in Colombia",
            admin_mobility_abroad: "5.7 Administrative Staff Mobility Abroad",
            international_agreements: "5.8 International Agreements",
            international_agreements_general: "5.8.1 International Agreements",
            international_agreements_institutions: "5.8.2 International Agreements with Institutions",

            // 6 Human Resources
            human_resources: "6 Human Resources",
            focused_teachers: "6.1 Focused Teachers",
            integration_government: "6.2 Integration with Governing Body",
            vaccination: "6.3 Vaccination",
            teachers: "6.4 Teachers",
            teachers_item: "6.4.1 Teachers",
            teachers_training: "6.4.2 Training",
            teachers_contract: "6.4.3 Contract",
            directory: "6.5 Directory",
            executives: "6.6 Executives",
            authorities: "6.7 Authorities",
            administrative_staff: "6.8 Administrative Staff",

            // 7 Institutional Information
            institutional_information: "7 Institutional Information",
            organizational_unit: "7.1 Organizational Unit",
            historical_resource: "7.2 Historical Resource",
            complementary_info: "7.3 Complementary IES Information",
            complementary_info_item: "7.3.1 IES Complementary Information",
            regulations: "7.3.2 Regulations",
            calendar: "7.4 Calendar",

            // 8 Participants
            participants: "8 Participants",
            participants_companies: "8.1 IES Companies",

            year: "Year",
            semester: "Semester",
            search_2: "Search",
            snies_tables: "SNIES Table",


            load: "We're preparing everything for you. we just need a second.",
            my_calendar: "My calendar",
            download_format_mail: ' Download email format',
            closed_session: 'The sesion was closed by inactivity',
            page_not_found: 'Page dont found',
            return_home: 'Return home',
            empty: 'Theres no registers',
            table_filter: {
                label: 'Filter',
                input_placeholder: 'Type to search...',
                button_label: 'Clear',
                checkbox_label: 'Filter by:',
                checkbox_description: 'To filter the entire database dont select any fields'
            },
            table_pagination: {
                label: 'Per page'
            },
            loading: 'Loading...',
            valid_select: 'Select an option',
            select_placeholder: 'Select one option',
            multiselect: {
                searching: 'Search: %{field}',
                no_option: 'Theres no registers'
            },
            document: {
                no_support: 'File type not supported for viewing'
            },
            tree: {
                add_all: 'Add all',
                remove_all: 'remove all',
                restore: 'Restore',
            },
            treeselect: {
                matrix: 'Select one element from the matrix'
            },
            card_component: {
                add: "Register added",
                edit: "Register edited",
                delete: "Register deleted",
                no_edit: "The record cannot be edited because it is already in use in other parts of the system",
                no_delete: "The record cannot be deleted because it is already in use in other parts of the system",
            },
            soon: 'Coming soon',
        },
        password_change: {
            title: 'Change password',
            subtitle: {
                send: 'Enter your email to receive the password reset email',
                change: 'Type a new password'
            },
            placeholder: "Enter you're email",
            submit: 'Send',
            alert: {
                validation: {
                    message: "The link to change you're password has expired!",
                    message_strong: 'Request a new one.'
                },

                message_sent: 'The message was sent successfully!, please check your email to continue',
                comparation: 'Passwords do not match. Please check.'
            },
            new_password: {
                placeholder: 'Enter a new password',
                confirmation_placeholder: 'Enter the password again',
                show: "Show",
                hide: "Hide"
            },
            email: {
                validator_message: 'Please enter a valid email'
            }
        },
        general: {
            edit_process: 'Edit project',
            contract: 'Contract',
            program_label: 'Program',
            programs: 'Programs',
            process_label: 'Project',
            process_change: 'You have selected the project &process. Remember that from now on, any changes you make on the platform will apply to this project. If you wish to change the project, you can do so at any time from the top menu',
            select_process: 'Select a project',
            select_process_desc: "Select the project that you'll work",
            no_process: 'There are no projects in this contract',
            current_process: 'current project: ',
            processes: 'Projects',
            process: 'Current project details',
            select: 'Select',
            cancel: 'Cancel',
            code: 'Code',
            name: 'Name',
            status: 'Status',
            valid: 'Valid',
            no_valid: "Not valid",
            target: 'Project goals',
            dates: 'Dates',
            supports: 'Supports',
            no_supports: 'No supports',
            change_process: 'Change project',
            change_contract: 'Change contract',
            cycles: 'Project cycles',
            current_cycle: 'Current cycle',
            policy: {
                title: 'Current Terms and Conditions',
                validity: 'Valid since: ',
                checkbox_before: ' I accept the terms and conditions of PREST',
                checkbox_after: 'I accept the terms and conditions of: ',
                checkbox_link: ' My institution, which can be viewed here',
                accept: 'Accept',
                cancel: 'Cancel',
                accept_toast: 'Thank you',
                cancel_toast: 'To enter the platform you must accept ,  We look forward to seeing you another time.',
            },

        },
        home: {
            title_h: 'PREST - Evalua',
            title_init: 'Welcome',
            title_configuration: '<b>Institutional configuration</b>',
            message_init: 'Start with your initial setup by selecting the option you want to begin with.',
            process_button_label: 'Projects',
            schedule_button_label: 'schedule configuration'
        },
        process: {
            title_h: 'Projects',
            title: 'Projects',
            title_asociated: 'Associated projects',
            description: 'Project list',
            show_all: 'Show all projects',
            process_label: 'Project',
            process_cont: 'Project count',
            description_label: 'Description',
            report_label: 'Report',
            date: 'Duration time',
            date_expire: 'Record expiration date',
            progress: 'Project progress',
            process: 'Project',
            status: 'Status',
            target: 'SNIES project goal',
            person_in_charge: 'Person in charge',
            no_procces: 'No results found. Please check your filter.',
            standard: 'Project type',
            no_standard: 'No project types were found in your contract. Please contact the provider.',
            view_process: 'view active projects',
            view_process_prospect: 'View prospect projects',
            view_process_asociated: 'View asociated projects',
            create: {
                title_alert_start_date: 'Warning',
                accpet_current_date: 'Acept',
                close_current_date: 'Close',
                alert_current_date: 'The start date should not be earlier than the current date.',
                note_collaborator: 'Remember that your user will be added as a collaborator by default.',
                title: 'New project',
                title_asociated: 'attach project',
                process: 'Project',
                processes: 'Linked projects',
                type_process: 'Type project',
                start_date: 'Project start',
                settlement_date: 'Submission date',
                end_date: 'Project end',
                target: 'SNIES Project goal',
                number_cycles: 'Number of cycles',
                period: 'Period',
                name: 'Project name',
                description: 'Please fill out the following form. Fields marked with <span style="color: red">*</span> are required.',
                send: 'Save',
                close_cycle: 'Self-evaluation report',
                evaluation_cycle: 'Evaluation cycle',
                indication_info: 'Monitoring',
                date: 'Dates',
                indication: {
                    status: 'Status',
                    detail: 'Detail',
                    reported_percentage: 'Progress',
                    support_type: 'Support'
                },
                start: 'Start date',
                end: 'End Date',
                title_h: 'Project creation',
                description_label: 'Project description',
                report_label: 'Report name',
                created: 'The project &code has been created successfully, continue with the cycles setup',
                continue: 'Continue',
                back: 'Back',
                add_collaborator: 'Add collaborator',
                name_invaled_cicle: {
                    more_500: 'The name exceeded 500 characters.',
                    zero: 'The cycle must have a name',
                },
                remove_self_collaborator: "You can't delete yourself as a collaborator",
                collaborator: 'Collaborator',
                remove: 'Remove',
                action: 'Action',
                add_program: ' Add program',
            },
            update_collaborators_message: 'The proyect has been update',
            update_collaborators_modal: {
                title: 'Update collaborators',
                alert_message: 'If you remove the person in charge of the project and/or a collaborator, they will be disabled from the project and all activities they may be responsible for.',
                save_button: 'Send',
                cancel_button: 'Cancel'
            },

            validation: 'The objective %{code} - %{targetLabel} is currently in the %{processLabel} process. Please remove it or change the project type you are associating it with.'
        },
        activity: {
            tittle_h: 'Activities - Evalua',
            title: 'Activities',
            description: 'List of activities for an upcoming course',
            show_all: 'Show all activities',
            activity_label: 'Activity',
            description_label: ' Description',
            date: 'Length of time',
            progress: 'Activity progress',
            person_in_charge: 'Person in charge',
            q: 'Label',
            stage: 'Stage',
            cycle: 'Cycle',
            status: 'Status',
            process: 'Project',
            code: 'Code',
            valid: 'Valid',
            no_valid: 'No valid',
            return: 'Return',
            no_activities: 'No results found, Please check your filter',
            action: 'Action',
            pm: 'Improvement plan',
            create: {
                title_h: 'Create activity',
                title: 'New activity',
                description: '',
                submit: 'Send',
                save: 'Add',
                valid: 'Validate',
                cancel: 'Cancel',
                cycle_input: 'Project and cycle',
                stage_input: 'Stage',
                activity_name_input: 'Activity',
                activity_name_placeholder: 'Name of the activity',
                dates_input_start: 'Start date',
                dates_input_end: 'End date',
                description_input: 'Description',
                description_placeholder: 'Summary',
                dates_cards: {
                    name: 'Dates',
                    inputs: {
                        input_additional_date_name: {
                            on_edit_label: 'Name date',
                            to_show_label: 'Name date'
                        },
                        input_additional_date: {
                            on_edit_label: 'Date',
                            to_show_label: 'Date'
                        }
                    }
                },
                collaborators_card: {
                    name: 'Collaborators',
                    inputs: {
                        input_name: {
                            on_edit_label: 'Username',
                            to_show_label: 'User',
                            optionA: 'Select a collaborator',
                        },
                        input_role: {
                            on_edit_label: 'Role',
                            to_show_label: 'Role',
                            optionA: 'Collaborator role',
                            optionB: 'Main responsible person',
                            optionC: 'Collaborator'
                        }
                    }
                },
                objectives_cards: {
                    name: 'Objectives',
                    inputs: {
                        input_name: {
                            on_edit_label: 'Objective name',
                            to_show_label: 'Objective',
                        },
                        input_format_type: {
                            on_edit_label: 'Format type',
                            optionA: 'Select a format',
                            optionB: 'PDF',
                            optionC: 'Word',
                            optionD: 'Excel',
                            optionE: 'PowerPoint',
                            optionF: 'Other',
                        },
                        input_type: {
                            on_edit_label: 'Type',
                            to_show_label: 'Type',
                            optionA: 'Select a objective',
                            optionB: 'Objective',
                            optionC: 'Goal',
                            optionD: 'deliverable',
                        },
                        input_number: {
                            on_edit_label: 'Duration',
                            to_show_label: ''
                        },
                        input_description: {
                            on_edit_label: 'Description',
                            to_show_label: '',
                        },
                        input_route: {
                            on_edit_label: 'URL',
                            to_show_label: '',
                        },
                    },
                    no_objectives: 'There are no objectives'
                },
                resources_cards: {
                    name: 'Resources',
                    inputs: {
                        input_name: {
                            on_edit_label: 'Resource name',
                            to_show_label: 'Resource',
                        },
                        input_type: {
                            on_edit_label: 'Type',
                            to_show_label: 'Type',
                            optionA: 'Module',
                            optionB: 'External resource (Image, Video, Guide, etc.)',
                        },
                        input_url_external_resource: {
                            on_edit_label: 'External resource URL',
                            to_show_label: 'External resource',
                        },
                        input_router: {
                            on_edit_label: 'Module',
                            to_show_label: 'Module',
                            optionA: 'Select resource'
                        },
                        input_description: {
                            on_edit_label: 'Description',
                            to_show_label: ''
                        }
                    },
                    no_resources: 'there are no resources',
                    resource_creation_alert_message: 'Added resource',
                    resource_update_alert_message: 'Updated resource',
                    resource_delete_alert_message: 'Deleted resource',
                },
                success_creation_alert_message: 'Activity added successfully.',
                success_update_alert_message: 'Activity updated successfully.',
                success_delete_alert_message: 'Activity deleted successfully.',
                error_creation_alert_message: 'There was a problem creating the activity.',
                error_resources_alert_message: 'You cannot add a module resource type without a module, or select an external resource type without an external address.',
                success_error_alert_message: 'Some data is missing.'
            },
            advance: {
                title_follow_up: 'View activity follow-ups',
                follow_up: 'View follow-up',
                title_register: 'Record activity progress ',
                register: 'Record progress',
                save: 'Save progress',
                add: 'Add',
                cancel: 'Cancel',
                select_standard: 'Select standart',
                delete: 'Delete',
                process_not_equal: 'To view the follow-up, make sure you are inside the project: %{field}',
                status: {
                    text: 'Status',
                    option_a: 'Starding',
                    option_b: 'In progress',
                    option_c: 'completed',
                    option_d: 'Cancelled',
                    option_e: 'Postponed'
                },
                follow_up_date: 'Date',
                expected_advance: 'Expected progress',
                reported_advance: 'Reported progress',
                milestone_expected: 'Expected goal percentage',
                milestone_date: 'Delivery date',
                detail: 'Detail',
                support_type: {
                    option_a: 'Percentage',
                    option_b: 'Money in pesos',
                    option_c: 'Whole number',
                    option_d: 'Decimal number',
                    option_e: 'New documents',
                    option_f: 'Link/URL',
                    option_g: 'No support',
                    option_h: 'Document repository',
                },
                support: 'Support',
                supports: 'Supporting documents',
                create_user: 'Loaded',
                decimals: {
                    text: 'Decimals',
                    option_a: 'One decimal',
                    option_b: 'Two decimals',
                    option_c: 'Three decimals',
                    option_0: '0',
                    option_1: '1',
                    option_2: '2',
                    option_3: '3'
                },
                util: {
                    detail_placeholder: 'Describe the progress achieved',
                    select_placeholder: 'Select an option',
                    accept_toast: 'Progress saved in the activity: %{field}',
                    milestone_not_set: 'Not set',
                },
            },
            edit: {
                title: 'Edit activity'
            }
        },
        timeline: {
            configuration: {
                title: 'Schedule Configuration',
                subtitle: 'Schedule activity configuration. In this section, you can create the necessary activities for the schedule.<br>A stage is a set of related activities that are carried out within a type of project.<br/>An activity is a specific task that contributes to the progress of a stage.<br/>To do this, follow these steps:<ul><li>To create a stage, click the <strong>“Add stage”</strong> button and enter its name and description.</li><li>To create an activity, first select the stage to which the activity will belong. Then, click the <strong>“Add activity”</strong> button and fill in the name, description, objectives, and resources.</li></ul>Remember that standard activities will be automatically generated for the schedule of the selected cycle, and date ranges will be suggested for their execution.',
                valid: 'Validate',
                edit: 'Edit',
                delete: 'Delete',
                add: 'Add activity',
                start_date: 'Start date',
                end_date: 'End date',
                settlement_date: 'Filing date',
                activity: 'Activity',
                activities: 'Activities',
                stages: 'Stages',
                stage: 'Stage',
                stage_label: 'Stage name',
                manager: 'Responsible',
                action: 'Action',
                cycle: 'Cycle',
                process: 'Selected project',
                other_cycle: 'Select another cycle',
                save_stage: 'Save stage',
                required: 'Required activity',
                yes: 'Yes',
                cancel: 'Cancel',
                delete_valid: 'Delete the activity:',
                delete_confirmation_modal: 'Delete activity',
                delete_stage_confirmation_modal: 'Delete stage',
                delete_stage_confirmation_label: 'Do you want to delete the stage: <strong>%{stage}</strong>?',
                edit_stage: 'Edit stage',
                remove_stage: 'Remove stage',
                confirm: 'Confirm',
                save: 'Save',
                description: 'Description',
                description_label: 'Stage description',
                add_stage: 'Add stage',
                add_activity: 'Add activity',
                add_activity_button: 'Add activity',
                created: 'The stage and its activities were successfully created. Continue with the configuration.',
                continue: 'Continue',
                end_cycle: 'The stage and its activities were successfully created, and all stages of this cycle have been configured. Continue with the configuration.'
            },
            alert: {
                remove_stage_alert: 'For security reasons, you must delete each activity before deleting the stage',
                delete_activity: 'Activity deleted.',
                sucess_deleete_stage_message: 'Stage deleted',
                error_delete_activity: 'Error while trying to delete the activity'
            },
            configuration_standard: {
                title: 'Schedule Template Configuration',
                subtitle: 'In this schedule template configuration section, you can create stages and activities to organize your project.<br/>A stage is a set of related activities that are carried out within a type of project.<br/>An activity is a specific task that contributes to the progress of a stage.<br/>To do this, follow these steps:<ul><li>To create a stage, click the <strong>“Add stage”</strong> button and enter its name and description.</li><li>To create an activity, first select the stage the activity will belong to. Then click the <strong>“Add activity”</strong> button and enter the name, description, objectives, and resources.</li></ul>You can create as many stages and activities as needed to define your project template.<br/>Dates will be assigned when a project is created from this template.',
                no_process: 'The template has no associated base process. Please contact the administrator to resolve the issue.'
            }
        },
        timeline_dashboard: {
            title: 'Dashboard timeline',
            subtitle: 'Here you can view the timeline and progress of your projects'
        },
        login: {
            username: 'Username',
            email: 'Email',
            password: 'Password',
            submit: 'Login',
            forgot_password: 'Forgot your password?',
            rebember: 'Remember me',
            title: 'Strengthening educational quality',
            subtitle: 'Evaluation system'
        },
        user_profile: {
            name_input: "First Name",
            lastname_input: "Last Name",
            phone_input: "Phone Number",
            email_input: "Email Address",
            success_edit_profile_alert_message: "The profile has been successfully updated.",
            send_email: {
                check_input: "Enable email sending",
                checked_message: "The user is enabled to send emails.",
                unchecked_message: "The user is not enabled to send emails."
            }
        },
        error: {
            '401_title': 'Incorrect Data',
            '401_message': 'Email or password is incorrect.',
            '500_title': 'System Error',
            '500_message': 'Please try again or contact an administrator.'
        },

        calendar_timeline_view: {
            alternative_title: 'My schedule',
            title: 'schedule',
            subtitle: 'Schedule of activities displayed in calendar/Gantt chart view',
            subscription: {
                button: 'Subscribe to calendar',
                modal_title: 'Calendar Subscription',
                description: 'Subscribe to your PREST activities calendar in your favorite calendar app (Google Calendar, Outlook, Apple Calendar, etc.)',
                url_label: 'Subscription URL',
                webcal_url_label: 'Webcal URL (One-click subscription)',
                webcal_url_help: 'Click this URL in most calendar apps to subscribe automatically',
                http_url_label: 'HTTP URL (Manual paste)',
                http_url_help: 'Use this URL if webcal:// doesn\'t work or for manual download',
                copy_button: 'Copy URL',
                copied_message: 'URL copied to clipboard',
                instructions_title: 'Instructions',
                google_calendar: {
                    title: 'Google Calendar',
                    step1: '1. Click the "+" button next to "Other calendars"',
                    step2: '2. Select "From URL"',
                    step3: '3. Paste the subscription URL',
                    step4: '4. Done! It will sync automatically'
                },
                outlook: {
                    title: 'Outlook / Office 365',
                    step1: '1. Click "Add calendar" → "Subscribe from web"',
                    step2: '2. Paste the subscription URL',
                    step3: '3. Done!'
                },
                apple_calendar: {
                    title: 'Apple Calendar (Mac/iPhone)',
                    step1: '1. File → New Calendar Subscription (or Settings → Accounts on iPhone)',
                    step2: '2. Paste the subscription URL',
                    step3: '3. Done!'
                },
                note_title: 'Important note',
                note_text: 'Your calendar will automatically update whenever your activities change. You don\'t need to subscribe again.',
                security_note: 'This URL is personal and private. Do not share it with anyone.',
                generate_button: 'Generate new subscription',
                regenerate_button: 'Regenerate subscription',
                regenerate_confirm: 'Are you sure you want to regenerate your subscription? The current URL will stop working and you will need to update it in your calendar apps.',
                revoke_button: 'Revoke subscription',
                close_button: 'Close',
                no_subscription_message: 'Create a subscription to automatically sync your activities.',
                error_generating: 'Error generating subscription. Please try again.',
                error_checking: 'Error checking subscription status. Please try again.',
                success_generating: 'Subscription generated successfully',
                success_revoking: 'Subscription revoked successfully',
                loading: 'Loading...'
            }
        },
        filter: {
            apply_filter: 'Apply filter',
            tooltip_list: 'List view',
            filters: 'Filters',
            filter_action: 'Filter',
            select_one_option: 'Select one option'
        },

        collaborator: {
            alternative_title: 'Collaborators',
            title: 'Add Collaborator',
            subtitle: 'Search or Create a collaborator for the project',
            user_filter_card_title: 'Search collaborator',
            info_card_title: 'Collaborator information',
            role_card_title: 'Collaborator role',
            not_found: 'Collaborator does not exist.',
            no_in_contract: 'This collaborator is not part of this contract. Would you like to invite them?',
            participant_collaborator_card_title: 'Search collaborator by participant',

            user_filter: {
                label: 'Search collaborator by ID number or email address',
                placeholder: 'ID number or email address',
                not_valid_filter: 'You can only filter by a valid ID number or email address',
                search_button: 'Search',
                search_participant_button: 'Search participant',
                load_participant_button: 'Load participants',
                clear_participant_button: 'Back to contract collaborators',
                not_allowed_participant_filter: "The participant does not exist in the current participant list. If you want to search for a profile that is not in the current list, please use the contract collaborators search instead.",
            },

            dni: {
                label: 'Document number',
                placeholder: 'Type document number'
            },

            name: {
                label: 'First name',
                placeholder: 'Type your name'
            },

            last_name: {
                label: 'Last Name',
                placeholder: 'Enter your last name'
            },

            email: {
                label: 'Email Address',
                placeholder: 'Enter your email address',
                not_valid_email: 'The %{field} field must be a valid email address'
            },

            phone: {
                label: 'Phone Number',
                placeholder: 'Enter your phone number'
            },

            charge: {
                label: 'Position',
                placeholder: 'Enter your position'
            },

            role: 'Role',

            button_action: {
                register: 'Register',
                invite: 'Invite to contract',
                modify: 'Modify',
                add: 'Add',
                delete: 'Delete',
                massive_assign: 'Mass Assignment'
            },

            massive: {
                method: 'Assignment level',
                met_one: 'Cycles',
                met_two: 'Stages',
                cycle: 'Cycle',
                collaborator: 'Collaborator',
                assign: 'Assign',
                assigned: 'Mass assignment completed',
                not_selected: 'Please select the collaborator, their role, and at least one activity',
                no_cycle: 'Select a cycle to assign it to its stages.'
            },

            user_registration: {
                not_found_alert: 'No profile was found with the provided email or ID number. You can register a new user for that email or ID, or register a user from the SNIES participant list. Would you like to view the list of available users from the participant list?',
                success_message: 'The profile has been created. An email has been sent to user %{username} for confirmation and activation.',
                already_exists_message: 'A profile with this email or ID already exists.',
                error_message: 'An error occurred while creating the user:',
                participant_collaborator_confirmation_modal: {
                    ok_button: 'Accept',
                    cancel_button: 'Cancel'
                }
            },
            user_modification: {
                success_message: 'The user profile has been updated'
            },
            user_collaborator_invitation: {
                success_message: 'The user has been added to the contract as a collaborator'
            },
            contract_state: {
                activate: 'Activate',
                deactivate: 'Deactivate',
                title: 'Collaborator affiliation to the contract',
                end_date_label: 'Affiliation end date',
                modal_title: 'Affiliation',
                modal_activation_body: "Do you want to enable the collaborator's affiliation?",
                modal_deactivation_body: "Do you want to disable the collaborator's affiliation?",
                ok_button: 'Accept',
                cancel_button: 'Cancel',
                update_end_date_button: "Update date",
                activate_success_message: "The user's affiliation has been activated",
                deactivate_success_message: "The user's affiliation has been deactivated"
            }
        },
        muniment_history_process: {
            title_h: 'Final Process Documents History',
            title: 'Final Process Documents History',
            subtitle: 'Here you will find the folder containing the final documents and supporting files that support the processes of: "%{field}".',
        },
        muniment: {
            title_h: 'Project Documents and Supporting Files',
            title: 'Project Documents and Supporting Files',
            subtitle: 'Here you will find the folder containing the documents and supporting files that justify the creation and due process of the project.',

            button: {
                new: 'New',
                search: 'Repository',
                link: 'Link',
                file: 'Select file',
                addFile: 'Add version',
                return: 'Back',
            },

            origin: {
                type: 'Document Relation',
                support: 'General Evidence',
                link: 'Link',
                evidence: 'Evidence',
                annex: 'Annex',
            },

            upload_modal: {
                title: 'Upload supporting documents for the project',
                input_file: {
                    placeholder: 'Choose a file or drag and drop it here...',
                    drop_placeholder: 'Drag and drop the file here...',
                    browser: 'Browse',
                },
                label_placeholder: 'Enter the document name...',
                description_placeholder: 'Enter a description or note...',
                source_placeholder: 'Enter the document source...',
                source_help: 'The source where the information originates. Example: Well-being Office, Ministry of Education, etc.',
                template_header_question: 'Is this document a "Template for Header"?',
                template_header_help: 'Mark this option if this document serves as a header template for iterations.',
                save_button: 'Save documents'
            },

            existing_modal: {
                title: 'Link existing support files'
            },

            data: {
                action: 'Action',
                type: 'Type',
                no_type: 'Type is missing',
                label: 'Name',
                no_label: 'Name is missing',
                description: 'Description and notes',
                no_description: 'Description and notes are missing',
                source: 'Source',
                no_source: 'Source is missing',
                version: 'Version',
                date: 'Date',
                start_date: 'Start date',
                end_date: 'End date',
                file: 'File',
                creation_user: 'User',
                change: 'Reason for change',

                util: {
                    change_placeholder: 'Reason for support file change',
                    row_iterator: ' from row ',
                    evidence_delete: 'The evidence can only be deleted from the evidence definition module.'
                },

                type_options: {
                    empty: 'Select an option...',
                    policy: 'Policy (Regulation)',
                    plan: 'Plan',
                    research: 'Study',
                    report: 'Report',
                    process: 'Project / Procedure',
                    other: 'Other',
                    statistic: 'Statistic',
                    review: 'Review',
                    act: 'Minutes',
                    agreement: 'Agreement',
                    contract: 'Contract',
                    resolution: 'Resolution',
                    annex: 'Annex',
                    gage: 'Indicators',
                    documental: 'Documentary',
                    appreciate: 'Assessment',
                    self_assessment_report: 'Self-assessment report',
                    self_assessment_matrix: 'Self-assessment matrix',
                    improvement_plan: 'Improvement plan',
                    administrative_act: 'Administrative act',
                    master_document: 'Master document',
                    improvement_plan_tracking: 'Improvement plan tracking'
                }
            },

            delete_confirm_message: 'Are you sure you want to delete the record?',

            link_modal: {
                title: 'Upload supporting documents for the project using links',
                text_area_placeholder: 'Enter the links separated by commas (,)...',
                alert_duplicate: 'Duplicate links will be ignored.',
                alert_info: 'Please enter the name and description after adding all the links.',
            },

            not_valid_alert: {
                before: 'The following links: ',
                after: '; are not valid. Please review them before continuing or they will not be included in the record.'
            },

            version: {
                link: 'Link',
                link_placeholder: 'Enter a new link',
                validation: {
                    link: 'The %{field} field is not valid, it must start with https://',
                }
            },

            quantity: {
                singular: 'more file',
                plural: 'more files'
            },

            error: {
                '409_message': 'The file name is too long. Please choose a shorter name and try again.'
            }
        },
        matrix: {
            title: 'Matrix Configuration',
            alternative_title: 'SNIES Configuration',
            subtitle: 'Add and validate each level of the matrix',
            add: 'Add',
            edit: 'Edit',
            delete: 'Delete',
            save: 'Save',
            save_matrix: 'Save Matrix',
            cancel: 'Cancel',
            code: 'Code',
            matrixCode: 'Matrix Code',
            name: 'Name',
            required: 'Required',
            detail: 'Detail',
            select_other: 'Switch from',
            change: 'Change',
            created: 'Matrix elements created.',
            end: 'All matrix elements have been created.',
            last_weigh: 'Remember that once you save the strategy, the already established parameters cannot be edited. Are you sure you want to save the matrix?',
            evidence_weigh: 'Are you sure you want to save the defined groups for evidence setup and upload?',
            valid_save_level: 'The matrix in view has not yet been saved. To create new elements in it, make sure to validate the base elements generated by the template, save them, and then create any additional elements you want.',
            already_valid: 'Have you already validated the selected matrix?',
            next: 'Next',
            prev: 'Previous',
            dashboard: {
                title: 'Matrix Tracking Dashboard',
                subtitle: '',
                no_matrix: 'The current cycle does not have a configured evidence matrix',
                config_matrix: 'You can configure it here',
                advance: 'Progress',

                matrix: 'Evidence matrix configured for this cycle',
                weighing_initial: 'Initial weighting',
                weighing_final: 'Final weighting',
                evidence: 'Evidence definition',
                evidence_charge: 'Evidence upload',
                evidence_valoration: 'Evaluation',
                no_weighing_initial: 'No initial weighting',
                no_weighing_final: 'No final weighting',
                no_evidence: 'No evidence defined',
                no_evidence_charge: 'No evidence uploaded',
                no_evidence_valoration: 'No evaluation'
            },
            alert: {
                no_delete: 'To delete the element "%{field}", you must first delete the dependent elements linked to it.'
            },
            custom: {
                title: 'Matrix Template Configuration',
                subtitle: 'Here you can customize the self-assessment matrix template by adding, editing, or deleting elements. To do so, follow these steps:<br/><ul><li>To add an element, click the <strong>«Add ...»</strong> button and enter its code, name, and description.</li><li>To edit an element, click the <strong>«<icon class="fa-solid fa-pencil" ></icon>»</strong> button next to the element you want to modify.</li><li>To delete an element, click the <strong>«Delete»</strong> button next to the element you want to remove.</li></ul>You can create as many elements as you need to define your matrix template.',
            }
        },
        exogenous: {
            title_h: 'Exogenous Sources',
            title: 'Exogenous Sources',
            subtitle: 'Statistics from external regulatory sources',
            total: 'Number of records: ',
            show_all: 'Show all exogenous sources',
            create: {
                title: 'Add Source'
            },
            fields: {
                source: 'Source',
                type: 'Type',
                label: 'Name',
                detail: 'Detail',
                date: 'Date',
                file: 'File',
            },
            options: {
                saces: 'SACES',
                snies: 'SNIES-PERTINENCE',
                spadies: 'SPADIES',
                scienti: 'SCIENTI',
                ole: 'OLE',
            },
            options_snies: {
                students_admitted: 'ADMITTED STUDENTS',
                students_enrolled: 'ENROLLED STUDENTS',
                students_matriculate: 'REGISTERED STUDENTS',
                teachers: 'TEACHERS',
                administrative: 'ADMINISTRATIVE STAFF',
            },
            util: {
                select_placeholder: 'Select an option',
                label_placeholder: 'Display name',
                detail_placeholder: 'Details of the exogenous source'
            },
            button: {
                new: 'New',
                suggest: 'Add Suggested',
                search: 'Repository',
                file: 'Select file',
                template: 'Download template',
                addFile: 'Add Supporting Document',
                link: 'Link',
                continue: 'Finish Task',
                add: 'Add',
                back: 'Back',
            },
            graph: {
                title_h: 'Exogenous Sources Chart',
                number_records: 'Number of records: ',
                snies_adm: 'Number of admitted: ',
                back: 'Back',
            }
        },
        weighing: {
            title: 'Weighting',
            subtitle: 'Welcome to the weighting process, an essential component of the Quality Assurance System, where each of you—as valuable members of the academic community (students, faculty, graduates, administrators, and representatives from the productive sector)—will play a key role. We invite you to determine the level of importance of the quality Factors and Characteristics by assigning a specific weight to each, on a scale from 10 to 100, where 10 represents the least importance and 100 the greatest. You are also required to justify the reasons behind each assigned weighting. If the importance level assigned by members of the different weighting groups varies by more than 20%, it will be necessary to analyze and reach a consensus among participants. Your participation is vital in this comprehensive exercise of evaluation and continuous improvement. We appreciate your commitment and collaboration!',
            find: 'Search',
            valid_met_three: 'By selecting this level of the matrix, you must weight %{count} elements. Are you sure you want to select this matrix level?',
            valid_met_four: 'By selecting this percentage average option, the system calculates the result based on the values given by participants in each group and assigns the result to the item subject to final weighting.',
            valid_met_delete_weighing: 'Changing the matrix level will affect the groups assigned for evidence weighting. These groups must be adjusted to match the newly selected matrix level. Do you confirm this action?',
            met_one: 'Initial weighting.',
            met_two: 'Weighting by importance levels.',
            met_three: 'Final weighting.',
            met_consult: 'View weighting',
            no_weigh: 'Unweighted',
            weighing: 'Weight',
            consult: 'Consult',
            assign_w_one: 'Assign the initial weighting of %{element}',
            assign_w_two: 'Assign a level of importance between %{minimum} and %{maximum} that indicates how important %{element} is to the self-assessment project',
            assign_w_three: 'Assign the final weighting of %{element}',
            w_one: 'Initial weighting given by the responsible party: ',
            w_two: 'Average rating given by the group: ',
            w_notes: 'Justify the weighting or importance level assigned to %{element}',
            w_value: 'Importance level',
            w_decimal: 'Decimal value',
            w_see_notes: 'Justification of the importance level or weighting assigned to %{element} by the group',
            available_percent: 'Available percentage ',
            valid_weigh: 'Assign an importance level for the weighting.',
            save_weigh: 'Weighting for %{element} in the matrix saved successfully.',
            end_weigh: 'Matrix weighting has been completed.',
            last_weigh: 'This is the last %{element} to be weighted in the matrix. Once saved, the weighting will be closed and cannot be edited. Are you sure you want to finish? If you respond “NO”, you may return to verify elements without losing progress. When ready, reweight this element to complete the task. If you have already validated it, respond “YES” to submit the final results.',
            save: 'Save',
            save_all: 'Generate weighting automatically',
            save_all_group: 'Generate weighting based on importance level weighting',
            saved_all: 'Weighting generated automatically',
            error_saved_all: 'Error generating automatic weighting, please try again.',
            confirm_save_all: 'Are you sure you want to generate the weighting automatically? Once saved, it will be finalized and cannot be edited.',
            accept: 'Accept',
            yes: 'Yes',
            no: 'No',
            ok: 'Understood',
            no_matrix: 'There is no matrix configured for this project cycle.',
            ext_weighing_end: 'Thank you, your assigned weighting has been completed.',
            equal: ' which equals ',
            without_value: 'Check the weighting of the other elements in the matrix, as 100% has already been assigned',
            config: {
                title: 'Weighting Strategy',
                edit_tab: 'Edit Strategy',
                copy_tab: 'Inherit Weighting',
                group_title: 'Group Assignment',
                level: 'Matrix Level',
                method: 'Assignment Method',
                met_one: '1. Initial weighting assigned by the Technical Directorate of Planning and Quality.',
                met_two: '2. Weighting assigned by the self-assessment team according to the importance of the elements.',
                met_three: '3. Final weighting assigned by the Technical Directorate of Planning and Quality.',
                met_four: '2.1. Manage final weighting based on the average percentage of the self-assessment team',
                scale_list: 'Weighting Scale',
                scale_weighing: 'Decimal precision',
                groups: 'Assigned Groups',
                assign_group: 'Assign Group',
                no_groups: 'At least one group must be assigned for weighting',
                fail_method: 'Error creating weighting method, please try again.',
                success_method: 'Weighting method was successfully created.',
                term: 'Deadline',
                term_start: 'Start Date',
                term_end: 'End Date',
                group_name: 'Group',
                groups_list: 'Select a group',
                objective: 'Objectives',
                add_all: 'Select All',
                edit_config: 'Edit Weighting Strategy',
                see_advance: 'View Weighting Progress',
                advance_title: 'Weighting Progress',
                weighing_one_advance_card_title: 'Initial Weighting',
                weighing_two_advance_card_title: 'Group Weighting',
                weighing_three_advance_card_title: 'Final Weighting',
                participants: 'Participants',
                participant: 'Participant',
                repeat: 'Participant added to another group',
                advance: 'Progress',
                assign: 'Assign',
                advance_total: 'Total Progress',
                file: 'Upload list of participant emails',
                add_participants: 'Add Participant',
                registration_participants: 'Participant Registration',
                registered_participants: 'Registered Participants',
                remove_participants: 'Remove Participants',
                not_valid_format: 'Invalid file format. Make sure it contains only one column titled "Emails".',
                invalid_file_type: 'The selected file is not a valid XLSX file.',
                file_read_error: 'File reading error.',
                no_file_selected: 'No file selected. Please select a file.',
                missing_email: 'Email field is missing in one or more rows.',
                no_group_select: 'Please select a group to assign.',
                no_end_date: 'Please select an end date for the weighting period.',
                no_participants: 'At least one participant is required.',
                no_targets: 'At least one objective must be selected for weighting.',
                scale_list_option: {
                    scale_1: '0 to 100',
                    description_1: 'The scale ranges from 0 to 100 in increments of 10',
                    scale_2: '1 to 10',
                    description_2: 'The scale ranges from 1 to 10 in increments of 1',
                    scale_3: '0 to 10',
                    description_3: 'The scale ranges from 0 to 10 in increments of 1'
                },
                copy_weighing: {
                    select_label: 'Inherit weighting from cycle / matrix',
                    copy_button: 'Inherit Weighting',
                    origin_level_label: 'Source Level',
                    destiny_level_label: 'Target Level',
                    final_weight: 'Inherited Weight',
                    confirmation_description: 'The current cycle will inherit the final weighting percentages from the selected cycle up to the completed level and will be saved as the completed final weighting, which cannot be edited again.',
                    confirmation_label: 'Do you want to copy the weighting?'
                },
                weighing_two_advance_table: {
                    matrix_level: 'Matrix Level',
                    average: 'Consolidated Weight',
                    std_dev: 'Standard Deviation',
                    variance: 'Variance',
                    var_coef: 'Coeff. of Variation',
                    no_weigh: 'Unweighted',
                    total_invitations: 'Number of Participants'
                }
            }
        },
        evidence: {
            support_modal: 'Evidence upload from supporting documents',
            charge_by_support: 'Upload evidence from supporting files',
            matrix: 'Assigned matrix elements',
            append_annex: 'Add annex',
            yes: 'Yes',
            no: 'No',
            valid_met_three_evidence: 'By selecting this matrix level, you will need to upload evidence for &count elements. Are you sure you want to select this level?',
            valid_met_three_valoration: 'By selecting this matrix level, you will need to assess &count elements. Are you sure you want to proceed?',
            valid_met_delete_evidence: 'Changing the matrix level will affect the groups assigned for Definition and Upload of evidence. These must be adjusted to match the selected matrix level. Do you wish to continue?',
            title: 'Evidence Matrix',
            title_evidence: 'Definition and Upload of Evidence',
            title_valoration: 'Assessment',
            valid_met_delete_valoration: 'Changing the matrix level will affect the groups assigned for the Assessment of evidence. These must be adjusted to match the new matrix level. Do you wish to continue?',
            subtitle: '',
            no_matrix: 'There is no matrix configured for this project cycle.',
            no_matrix_valoration: 'There is no matrix configured for this cycle, or evidence upload has not been configured. Please verify and return when requirements are met.',
            evidence: 'Evidence',
            met_one: 'Evidence definition',
            met_two: 'Evidence upload',
            met_three: 'Assessment',
            met_one_v: 'Define the evidence',
            define_evidence: 'Defined evidence <span>%{size}</span>',
            define_evidence_count: 'Defined evidence <span>%{size} of %{total}</span>',
            met_two_v: 'Upload evidence',
            charge_evidence: 'Uploaded evidence <span>%{charge} of %{size}</span>',
            all_evidence: 'All evidence uploaded',
            met_three_v: 'Assess evidence',
            valoration_v: 'Assess from %{can}',
            value_evidence: 'Assessed evidence <span>%{charge} - %{size}</span>',
            count_evidence: 'Evidence assessed %{charge} of %{size}',
            no_evidence: 'No evidence',
            no_evidence_define: 'No evidence defined',
            no_evidence_charge: 'No evidence uploaded',
            no_evidence_value: 'No evidence assessed',
            no_valoration: 'No assessment',
            no_value: 'No value',
            valoration_next: 'Assessment cannot be performed from "%{matriz}". It can only be done from %{can}.',
            met_consult_one: 'Consult evidence definition.',
            met_consult_two: 'Consult uploaded evidence',
            consult: 'View evidence',
            w_notes: 'Comments or recommendations / value judgments',
            register_dof: 'DOF content record',
            improvement_opportunity: 'Opportunities for improvement',
            weakness: 'Weaknesses',
            strength: 'Strengths',
            support_type: 'Type of evidence',
            support_name: 'Filter: evidence name',
            support_new: 'New support file',
            support_process: 'Project supporting documents',
            support_all: 'All evidence',
            save_evidence: 'Evidence saved',
            save_evidence_support: 'Support file uploaded',
            save_success: 'Evidence saved successfully',
            upload_success: 'Evidence uploaded successfully',
            save: 'Save',
            saving: 'Saving...',
            cancel: 'Cancel',
            see: 'View evidence',
            no_support: 'No file',
            add: 'Create evidence',
            edit: 'Edit support',
            edit_support_button: 'Edit',
            delete_support_button: 'Delete',
            delete_support_label: 'If you delete this support file, all definitions made for it in each matrix level will also be deleted. Do you want to proceed?',
            success_edit_message: 'Support updated successfully',
            success_delete_message: 'Support deleted successfully',
            assign: 'Define evidence',
            my_supports: 'Matrix evidence',
            my_supports_child: 'Evidence from lower levels of the matrix',
            see_matrix: 'View matrix details',
            valid_evidence: 'Assign at least one piece of evidence',
            no_assign: 'No evidence has been defined for this matrix element. Before uploading, please verify the evidence definition.',
            valid_charge: 'Upload the evidence',
            inherit_title: 'Evidence for the elements below',
            inherit_question: 'You are saving from a characteristic or factor. This list includes the evidence of all its aspects. Do you want to add every item to every aspect, or only the new items?',
            inherit_all: 'Add all to every aspect',
            inherit_new_only: 'Only the new items',
            valid_assessment: 'Not assessed',
            end_evidence: 'Evidence assessment for this matrix has been completed.',
            last_evidence: 'This is the last matrix element to define evidence for. Once saved, the matrix will be locked and cannot be edited. Are you sure you want to finish?',
            create_support: 'Create support',
            charge_file: 'Upload support',
            charge_new: 'Upload new file',
            charge_new_version: 'Upload new version of file',
            delete_muniment: 'Delete file',
            save_permanently: 'Save permanently',
            uploaded_by: 'Uploaded by',
            support_date: 'Date',
            ext_evidence_end: 'Thank you. The evidence upload has been completed.',
            ext_valoration_end: 'Thank you. The assessment has been completed.',
            assessment: 'Assessment',
            assessment_level: 'Rate %{element} on a scale from 0 to 5',
            appreciate: 'Evaluate',
            value_1_documental: 'Not met',
            value_2_documental: 'Poorly met',
            value_3_documental: 'Acceptably met',
            value_4_documental: 'Highly met',
            value_5_documental: 'Fully met',
            value_1: 'Not met',
            value_2: 'Poorly met',
            value_3: 'Acceptably met',
            value_4: 'Highly met',
            value_5: 'Fully met',
            value_insert: 'Enter a value from 0 to 5',
            copy_evidence: {
                select_label: 'Inherit evidence from cycle / matrix',
                copy_button: 'Inherit evidence',
                origin_level_label: 'Source level',
                destiny_level_label: 'Target level',
                final_weight: 'Inherited weight',
                confirmation_description: 'The current cycle will inherit the final weighting percentages from the selected cycle, up to the completed level, and will be saved as a completed weighting process that cannot be edited.',
                confirmation_label: 'Do you want to copy the weighting?',
                general_title: 'General Inheritance',
                specific_title: 'Specific Inheritance',
                label_origin: 'Source matrix',
                label_destiny: 'Destination matrix',
                code: 'Code',
                label: 'Name',
                matrix_evidence: 'Support document',
                number_evidence: 'Number of Evidence: ',
                evidence_origin: 'Source Evidence',
                evidence_destiny: 'Target Evidence',
                cancel: 'Cancel',
                save: 'Inherit',
                success_evidence: 'Evidence inheritance completed',
                error: 'An error occurred during inheritance'
            },
            charge_type: {
                tab1: 'File',
                tab2: 'Link',
            },
            config: {
                title_evidence: 'Evidence Definition and Upload Strategy',
                title_valoration: 'Assessment Strategy',
                group_title: 'Group assignment',
                edit_tab: 'Edit strategy',
                copy_tab: 'Inherit definitions',
                level: 'Matrix level',
                rubrics: 'Rubrics per support',
                matrix_rubrics: 'Rubrics to be used',
                method: 'Definition method',
                method_valoration: 'Assessment method',
                met_one: '1. Define evidence',
                met_two: '2. Upload evidence',
                met_three: '3. Assess evidence',
                scale_evidence: 'Assessment scale',
                groups_assign: 'Groups assigned to evidence definition',
                groups: 'Groups assigned to evidence upload',
                groups2: 'Groups assigned to assessment',
                assign_group: 'Assign group',
                no_groups: 'You must assign at least one group to the evidence upload strategy',
                no_groups_valoration: 'You must assign at least one group to the assessment strategy',
                fail_method: 'Error creating evidence upload strategy, please try again.',
                fail_method_valoration: 'Error creating assessment strategy, please try again.',
                success_method: 'Evidence upload strategy created successfully.',
                success_method_valoration: 'Assessment strategy created successfully.',
                term: 'Deadline',
                term_start: 'Start date',
                term_end: 'End date',
                group_name: 'Group',
                groups_list: 'Select a group',
                objective: 'Objectives',
                participants: 'Participants',
                participant: 'Participant',
                registration_participants: 'Participant registration',
                registered_participants: 'Registered participants',
                remove_participants: 'Remove participants',
                advance: 'Progress',
                assign: 'Assign',
                advance_total: 'Total progress',
                file: 'Upload list of participant emails',
                add_participants: 'Add participant',
                not_valid_format: 'Invalid file format. Make sure it has only one column titled "Emails".',
                no_group_select: 'Select a group to assign.',
                no_end_date: 'Select an end date for the evidence upload and assessment strategy',
                no_participants: 'Register at least one participant',
                no_old_participants: 'At least one registered participant must remain',
                no_targets: 'You must select an objective to upload and assess evidence',
                no_rubrics_message: 'No rubrics configured in the current process standard',
                no_cycle_selected: 'No cycle selected. Please select a cycle first.',
                see_advance: 'View definition and upload progress',
                inheritance: 'Inherit definition',
                advance_title: 'Definition and upload progress',
                see_advance_valoration: 'View assessment progress',
                advance_title_valoration: 'Assessment progress',
                specific_advance: {
                    participant_valoration: 'Assessment by participant',
                    valoration_advance_tab: 'Progress per participant',
                    level_valoration: 'Assessment by level',
                    valoration_graphic_advance: 'Assessment progress chart',
                    valoration_graphic_table_tab: 'Table',
                    valoration_graphic_table: 'Current assessment table',
                    valorated_percentage: 'Assessed percentage',
                    average_assessment: 'Average assessment',
                    valuator: 'Evaluator',
                    assessment: 'Assessment'
                },
                edit_config: 'Edit evidence definition and upload strategy',
                edit_config_valoration: 'Edit assessment strategy',
                invalid_value: 'Invalid value. Must be between 0 and 5.',
                valoration_options: {
                    method_one: {
                        label: 'Low objectivity level',
                        description: 'Assessment is performed by directly assigning a score to the evaluated level.'
                    },
                    method_two: {
                        label: 'High objectivity level',
                        description: 'At this level, the assessment is not directly on the level, but on the supporting documents. These are scored using specific rubrics.'
                    },
                    method_three: {
                        label: 'Medium objectivity level',
                        description: 'Assessment is assigned to the evaluated level using a rubric, providing a more structured evaluation.'
                    },
                },
            },
            valoration_rubric: {
                more_info: 'Here you can find more information related to the question.',
                decimals_number: 'The field value must have at most %{decimal} decimals.'
            }
        },
        instrument: {
            title_h: 'Instruments list',
            title: 'Instruments',
            subtitle: 'Instruments list',
            show_all: 'Show all instruments',
            instrument_label: 'Instruments',
            description_label: 'Detail',
            instrument_code_and_title: 'Code / Instrument Title',
            publication_date: 'Publication Date',
            close_date: 'Close date',
            popover: {
                publication_date: 'Date when the survey was published',
                close_date: 'Date when the survey was closed or unpublished',
            },
            create_instrument_option_modal: {
                title: 'Create instrument',
                body: 'Create a new instrument from a template, or a new empty instrument',
                create_instrument_from_template_button: 'Create from template',
                create_new_instrument_button: 'Create a new instrument',
            },
            create: {
                title_h: 'Create instrument',
                title: 'New instrument',
            },
            update: {
                title_h: 'Edit instrument',
                title: 'instruments edit',
            },
            readonly: {
                title_h: 'View instrument',
                title: 'Instrument <b>%{instrument}</b>'
            },
            code: 'Code',
            state: 'State',
            presentation_mode: 'Presentation mode',
            instrument_title: 'Title',
            description: 'Purpose of the instrument',
            instrument_cycle: 'Instrument Cycle',
            random: 'Display questions in random order',
            answer_range: 'Value range for the questions',
            manage_sections: 'Add section',
            save_instrument_button: 'Save',
            publish_instrument_button: 'Publish instrument',
            inivite_instrument_button: 'Invite participants to the instrument',
            set_template_instrumet_button: 'Assign instrument as template',
            set_groups_sample_button: 'Expected sample',
            config_instrument_matrix: 'Config matrix',
            delete_instrument_button: 'Delete instrument',
            exit_instrument_button: 'Return',
            publish_instrument_modal: {
                title: 'Publish instrument',
                publication_date: 'Aplication date',
                current_date_button: 'Today',
                end_of_day_button: 'End of day',
                close_date: 'Close date',
                welcome_message_label: 'Welcome message',
                ferewell_message_label: 'Farewell message',
                welcome_message: 'Welcome',
                ferewell_message: 'Thanks for your participation',
                welcome_message_placeholder: 'Welcome message',
                ferewell_message_placeholder: 'Farewell message',
                empty_message_feedback: 'The %{field} field is required',
                max_length_message_feedback: 'The maximum number of items in the text has been exceeded',
                ferewell_message_feedback_message: 'The Farewell Message field is required',
                justification: {
                    not_published: 'Instrument opening',
                    published: 'Instrument closing date update',
                    reopen: 'Instrument reopening request (change of closing date)',
                },
                reopen_justification_label: 'Justification for the request',
                reopen_justification_placeholder: 'Enter the justification for the instrument reopening request ',
                publish_button: 'Publish',
                cancel_button: 'Cancel',
                reopen_button: 'Reopen instrument',
                reopen_checkbox: 'Reopen instrument',
                close_date_button: 'Acept',
                publish_dates_validation_message: 'You cannot publish the instrument without a publication date and a closing date',
                publish_success_message: 'The instrument has been published successfully',
                update_close_date_succes_message: 'The closing date has been successfully updated',
                reopen_success_message: 'The reopening request has been successfully submitted',
                publish_error_message: 'An error occurred while publishing the instrument: ',
            },
            set_template_instrument: {
                title: "Assign instrument as template",
                body: "Remember that by enabling this instrument as a template, any changes you make to it will only affect instruments created after the change. Additionally, this template will be available across the different standards used by your institution. If a standard does not match in matrix codes and target groups, the question will require configuration of these two elements on the new destination standard. Do you want to assign this instrument as a template?",
                body_note: "Note: The instrument must be created in order to be assigned as a template.",
                ok_button: "Accept",
                cancel_button: "Cancel"
            },
            delete_instrument_modal: {
                title: 'Delete instrument',
                warning_message: 'All sections and questions associated with the instrument will be deleted. Do you want to delete the instrument?',
                delete_button: 'Delete',
                cancel_button: 'Cancel',
            },
            set_groups_sample_modal: {
                title: 'Assign expected sample',
                ok_button: 'Acept',
            },
            config_instrument_matrix_label: 'Associate matrix level to the instrument',
            config_instrument_matrix_modal: {
                title: 'Configure matrix levels',
                iteration_matrix_card: {
                    title: 'Evidence matrix',
                    body: 'Select the matrix levels',
                },
                cross_cutting_matrix_card: {
                    title: 'Configure cross-cutting matrices',
                    add_button: 'Use matrix',
                    already_exist_warning_message: 'TYou must select a matrix before it can be added'
                },
                typeLevels: 'Matrix levels',
                ok_button: 'Accept',
                cancel_button: 'Cancel',
            },
            no_config_instrument_matrix_message: 'There is no matrix configuration saved for the current project',
            state_options: {
                optionA: 'Select a status',
                optionB: 'Active',
                optionC: 'Inactive'
            },
            presentation_options: {
                optionA: 'Select a presentation method',
                optionB: 'Allow only one opportunity to submit responses',
                optionC: 'Allow multiple opportunities to submit responses',
            },
            cycle_select_options: {
                default: 'Select cycle',
            },
            answer_range_options: {
                default: 'Select range',
                optionA: '[%{min} - %{max}]',
                optionB: '[%{min} - %{max}]'
            },
            confirmation_alert: {
                go_instrument_section_button: 'Complete the current instrument',
                close_button: 'Close',
                succes_message: 'Instrument created successfully',
                error_message: 'A problem occurred while creating the instrument',
                dates_error_message: 'The end date is later than the publication date. Please update the dates'
            },
            add_section: {
                create: {
                    title_h: 'Create section',
                    title: 'New section'
                },
                update: {
                    title_h: 'View Section',
                    title: 'Section <b>%{section}</b>'
                },
                not_available_creation: 'It is not possible to create a section while the instrument is already open on its publication date.',
                code: 'Code',
                state: 'State',
                order: 'Order',
                section_title: 'Title',
                user_notes: {
                    label: 'Notes for the user',
                    default_text: 'Notes for te user',
                    max_lenght_message_feedback: 'The maximum number of elements in the text has been exceeded'
                },
                description: 'Section purpose',
                buttons: {
                    save: 'Save',
                    add: 'add question',
                    delete_section: 'Delete section',
                    exit: 'Return'
                },
                delete_section_modal: {
                    title: 'Delete section',
                    warning_message: 'The questions associated with this section will be deleted. Do you want to delete the section?',
                    delete_button: 'Delete',
                    cancel_button: 'Cancel'
                },
                state_option: {
                    optionA: 'Select a status',
                    optionB: 'Active',
                    optionC: 'Inactive'
                },
                change_state_modal: {
                    warning_message: "<b>Nota:</b> If you change the section's state while the instrument is published, the section and its questions will no longer be required in the instrument and cannot be re-enabled.",
                    ok_button: 'Accept',
                    cancel_button: 'Cancel'
                },
                order_option: {
                    optionA: 'Select the order in the section'
                },
                confirmation_alert: {
                    add_new_section_button: 'New section',
                    close_button: 'Close',
                    success_message: 'The section was added successfully',
                    error_message: 'A problem occurred while the section was being added to the instrument',
                },
                add_question_validation_alert: {
                    section_data_validation_error_message: 'It is not possible to add a question to a section without a name'
                }
            },
            add_question: {
                create: {
                    title_h: 'Create a question',
                    title: 'New question',
                },
                update: {
                    title_h: 'Edit question',
                    title: 'Edit question',
                },
                readonly: {
                    title_h: 'View question',
                    title: 'Question <b>%{question}</b>'
                },
                not_available_creation: 'It is not possible to create a question while the instrument is already open within the publication period.',
                code: 'Code',
                state: 'State',
                order: 'Order',
                section: 'Section',
                question: 'Question',
                help: 'Help',
                group: 'Target group',
                type: 'Question type',
                no_type_allowed_description: 'No description available',
                default_value: 'Default value',
                is_required: 'Required question',
                require_justification: 'Answer requires justification',
                answer_decimals: 'Answer decimals',
                final_evaluation: 'Does not interfere with the final perception score',
                associate_matrix: {
                    label: 'Associate / consult matrix levels',
                    button: 'Associate levels',
                    button_subquestion: 'Associate levels to sub-question',
                    not_found_matrix: 'Matrix levels have not been configured yet for association.',
                    modal: {
                        parent_question_title: 'Assign matrix levels',
                        child_question_title: 'Assign matrix levels to sub-question',
                        ok_button: 'Accept',
                        close_button: 'Close'
                    }
                },
                delete_question_modal: {
                    title: 'Delete question',
                    warning_message: 'The question will be removed from the current instrument. Do you want to delete the question?',
                    delete_button: 'Delete',
                    cancel_button: 'Cancel'
                },
                change_type_modal: {
                    title: 'Change question type',
                    warning_message: 'This question already has a type and response options. If you change the question type, the options will be deleted once saved. Do you want to change the question type?',
                    accept_change_button: 'Accept',
                    cancel_button: 'Cancel'
                },
                state_options: {
                    optionA: 'Select the question status',
                    optionB: 'Active',
                    optionC: 'Inactive'
                },
                change_state_modal: {
                    warning_message: '<b>Note:</b> If you change the question status while the instrument is published, the question will no longer be required and cannot be re-enabled.',
                    ok_button: 'Accept',
                    cancel_button: 'Cancel'
                },
                order_options: {
                    optionA: 'Order'
                },
                section_options: {
                    optionA: 'Select the section'
                },
                type_options: {
                    optionA: 'Select the question type'
                },
                group_all_options: 'All',
                group_options: {
                    optionA: 'Specialized support group',
                    optionB: 'Graduates',
                    optionC: 'External',
                    optionD: 'Executives',
                    optionE: 'Administrative',
                    optionF: 'Teachers',
                    optionG: 'Students'
                },
                range: {
                    min: 'Minimum range',
                    max: 'Maximum range',
                    step: 'Step',
                    status: 'Visible?',
                    decimals: 'Decimals'
                },
                bool: {
                    option: {
                        title: 'Option %{index}',
                        label: 'Option',
                        weight: 'Weight'
                    }
                },
                validation: {
                    greater_than: 'This value must be greater than the value in the "%{field}" field.',
                    module_of: 'This value must be a divisor of the value in the "%{field}" field.',
                    in_range: 'This value must be between %{min} and %{max}',
                    decimals_number: 'This value must have at most %{decimal} decimals.'
                },
                assessment: {
                    positive: {
                        title: 'Positive',
                        label: 'Option',
                        default: 'Strengths'
                    },
                    negative: {
                        title: 'Negative',
                        label: 'Option',
                        default: 'Opportunities for improvement'
                    }
                },
                save_question_button: 'Save question',
                delete_question_button: 'Delete question',
                go_back_question_creation_button: 'Go back',
                confirmation_alert: {
                    add_new_question_button: 'New question',
                    go_section_button: 'Back to section',
                    close_button: 'Close',
                    error_message: 'A problem occurred while adding the question:',
                    group_error_message: 'You cannot add a question without target groups.'
                },
                selection: {
                    title: 'Options',
                    active: 'Active?',
                    option: 'Option %{index}',
                    weight: 'Weight %{index}',
                    help: 'Help %{index}',
                    add_option: 'Add option'
                },
                matrix: {
                    row: {
                        title: 'Rows',
                        active: 'Active?',
                        option: 'Row %{index}',
                        weight: 'Weight %{index}',
                        help: 'Help %{index}',
                        add_option: 'Add row'
                    },
                    column: {
                        title: 'Columns',
                        active: 'Active?',
                        option: 'Column %{index}',
                        weight: 'Weight %{index}',
                        help: 'Help %{index}',
                        add_option: 'Add column'
                    }
                },
                audiovisual: {
                    check_message: 'Add audiovisual resource URL?',
                    type: 'Resource type',
                    url: 'Resource URL',
                    audio: 'Audio (Soundcloud)',
                    image: 'Image (jpeg, jpg, gif, png)',
                    video: 'Video (YouTube)',
                    url_validation_message: 'The entered URL does not match the required format. Please enter a valid value.',
                    options: {
                        title: 'Options',
                        active: 'Active?',
                        type: 'Type %{index}',
                        url: 'URL %{index}',
                        weight: 'Weight %{index}',
                        add_option: 'Add option'
                    }
                },
                policy: {
                    question: 'Data policy acceptance question',
                    url: 'Institution\'s data policy URL',
                    info: 'A Data Policy type question will always be active, required, and shown first to all target groups before answering the instrument. You can create multiple policy questions for the same instrument, which will appear at the beginning.'
                },
                matrix_multiple: {
                    row: {
                        title: 'Item',
                        active: 'Active?',
                        question: 'Question %{index}',
                        help: 'Help',
                        add_row: 'Add item',
                        add_option: 'Option'
                    },
                    item: {
                        active: 'Active?',
                        option: 'Option %{index}',
                        weight: 'Weight %{index}'
                    }
                },
                reference_matrix: {
                    item: {
                        title: 'Response options',
                        active: 'Active?',
                        option: 'Option %{index}',
                        weight: 'Weight %{index}',
                        help: 'Help %{index}',
                        add_item: 'Add item'
                    },
                    question: {
                        title: 'Objective',
                        type: 'Objective type',
                        year: 'Year',
                        term: 'Term'
                    },
                    warning_year_message: 'Warning: When applying the question, the subquestions will be generated from the objective if one exists for the selected year and term. Please review the available years and terms carefully.'
                },
                conditional: {
                    title: 'Response options (Group)',
                    active: 'Active?',
                    option: 'Option %{index}',
                    weight: 'Weight %{index}',
                    help: 'Help %{index}',
                    add_option: 'Add option'
                },
                objective_type_options: {
                    default: 'Select the objective',
                    optionA: 'Teachers'
                },
                objective_years_options: {
                    default: 'Select the year'
                },
                objective_terms_options: {
                    default: 'Select the term'
                },
            },
            update_group_sample: {
                update_sample: 'Update sample',
                error_message: {
                    unknown_error: 'Unknown error',
                    request_failed: 'Error updating the sample',
                    null_data: 'The sample cannot be updated with null data',
                },
            },
        },
        instrument_preview: {
            instrument_menu_preview_button: 'Preview',
            instrument_menu_preview_button_hover: 'Instrument preview',
            title_h: 'Preview',
            title: 'Preview of instrument <b>%{instrument}</b>',
            not_available: 'The instrument has no preview or does not exist',
            next_section: 'Next section',
            not_available_section: 'No sections have been created for this instrument',
            not_available_question: 'No questions have been created for this section',
            groups_select_label: 'Filter questions by group',
            download_error: 'The instrument preview could not be downloaded. Please try again.',
            download_no_cycle: 'Select a cycle before downloading the instrument preview.',
            prev_section: 'Previous section',
            next_question: 'Next question',
            prev_question: 'Previous question',
            instrument_start: 'Instrument start',
            more_info: 'Here you can find more information related to the question.'
        },
        instrument_apply: {
            title_h: 'Instrument application',
            no_token: 'Please verify the URL to access the instrument application.',
            not_available: 'The instrument has expired or is not available',
            max_attempts_exceeded: 'You have already completed this survey. Your answers have been saved.',
            max_attempts_allowed_message: 'You are about to make an attempt on the survey.<br/> The maximum number of attempts allowed is <b>%{maxAttempts}</b>. <br/> You are currently on attempt <b>%{currentAttempt}</b>. <br/><br/><b>Note:</b> If you start a new attempt, the answers will be saved in a new group, and the last answers you filled in will be shown. If you continue with an already started attempt, remember it will only be completed when you click the <b>Finish attempt</b> button.',
            ok_button: 'Accept',
            cancel_button: 'Cancel',
            more_info: 'Here you can find more information related to the question.',
            end_attempt: 'Finish',
            next_section: 'Next section',
            prev_section: 'Previous section',
            next_question: 'Next question',
            prev_question: 'Previous question',
            no_section_pending_questions: 'There are no more pending questions to answer in this section.',
            no_last_section_pending_questions: 'There are no more pending questions to answer.',
            dependence_label: 'Depends on: ',

            question_validation: {
                is_required: 'You must answer all required options for this question',
                max_length: 'The maximum number of characters has been exceeded',
                decimals_number: 'This value must have a maximum of %{decimal} decimals.',
                between: 'The value must be between %{minValue} and %{maxValue}.'
            },

            data_policy_modal: {
                title: 'Data policy acceptance',
                body: 'Do you accept the following data policy conditions of your institution to complete the survey?',
                see_link: 'See link',
                ok_button: 'Accept',
                cancel_button: 'Cancel',
                warning_message: 'You must accept all terms to complete the instrument.'
            },
            message_modal_ok_button: 'Continue'
        },
        instrument_objective: {
            title_h: 'Target groups configuration for an instrument',
            subtitle: 'Assign people who will take the instrument depending on their target group.',
            add: 'Add participant',
            assign: 'Assign',
            email: 'Email:',
            advance: 'Progress:',
            users: 'Users',
            close_instrument: 'Instrument closed',
            forwarding: {
                button: 'Resend emails',
                button_modal: 'Resend',
                title_modal: 'Resend emails',
                no_user_message_modal: 'All users have already answered the instrument.'
            },
            tree: {
                add_all: 'Add all',
                started: 'Add started invitations',
                not_started: 'Add not started invitations',
                remove_all: 'Remove all'
            },
            not_sent_participants_notification: {
                title: 'Some invitations could not be sent',
                body: 'They are grouped by reason below. These emails remain pending: once the reason is resolved, assign the participants again and only the pending emails will be retried. You can also download the Excel file with these emails and upload it again.',
                summary: '{count} email was not sent | {count} emails were not sent',
                summary_of_total: '{count} of {total} emails were not sent',
                copy_button: 'Copy emails',
                copied_message: 'Emails copied to clipboard',
                copy_error_message: 'The emails could not be copied. Use the Excel download instead.',
                download_button: 'Download Excel',
                reason_column: 'Reason',
                file_name: 'emails_not_sent',
                reasons: {
                    INVALID_FORMAT: {
                        title: 'Misspelled email',
                        help: 'Check that the email is written correctly (it has an @ and a valid domain, with no spaces).'
                    },
                    INVALID_RECIPIENT: {
                        title: 'The email does not exist',
                        help: 'The recipient\'s mail server reported that this account does not exist. Confirm the email with the participant.'
                    },
                    RATE_LIMIT: {
                        title: 'The email provider asked to wait',
                        help: 'Too many emails were sent in a short time and the provider temporarily slowed down sending. Wait a few minutes and assign the participants again.'
                    },
                    DAILY_LIMIT: {
                        title: 'Daily sending limit reached',
                        help: 'The email account configured for the contract reached its daily sending quota. Assign the participants again tomorrow or request an additional account.'
                    },
                    INVALID_CREDENTIALS: {
                        title: 'Sending account error',
                        help: 'The username or password of the email account configured for the contract is not valid. Contact the administrator to review the email configuration.'
                    },
                    CONNECTION: {
                        title: 'Could not connect to the mail server',
                        help: 'The mail server could not be reached. Assign the participants again in a few minutes.'
                    },
                    GENERAL: {
                        title: 'The mail server rejected the email',
                        help: 'Assign the participants again. If the problem persists, contact support.'
                    },
                    UNKNOWN: {
                        title: 'The delivery could not be confirmed',
                        help: 'Assign the participants again. If the problem persists, contact support.'
                    }
                },
                ok_button: 'Accept'
            },
            assign_participants_confirmation: {
                title: 'Assign participants',
                label: 'Participants list summary',
                body: 'You are about to assign participants and send an email to the added addresses. It is recommended to review each email address. Do you want to proceed with the participant assignment?',
                cancel_button: 'Back',
                ok_button: 'Accept'
            },
            assign_participants_message: 'Invitations have been assigned to the entered participants',
            forwarding_participants_message: 'Invitations have been resent to the selected participants',
            instrument_without_access_title: 'No access to the instrument',
            instrument_without_access_message: 'The instrument you are trying to access is not associated with the current process.',
            instrument_without_access_recommendation: 'Please check the process and instrument, and try again.'
        },
        template_instrument: {
            title: 'Available templates',
            subtitle: ' Create an instrument from an existing template',
            template_instrument_select: 'Get templates by:',
            template_instrument_select_option: {
                optionA: 'All',
                optionB: 'Institutions',
                optionC: 'Publics'
            },
            template_table: {
                preview_button: 'Preview',
                create_button: 'Use template'
            },
            cycle_select_options: {
                default: 'Select cycle'
            },
            create_from_template_modal: {
                title: 'Create instrument',
                instrument_name_input: 'Name of the instrument',
                instrument_cycle: 'Cycle',
                create_button: 'Create',
                cancel_button: 'Cancel'
            }
        },
        instrument_chart: {
            button: 'Show Follow-up',
            version: {
                label: 'Version',
                option: 'Last version for invitation',
            },
            follow: {
                tab: 'Follow-up',
                daily: 'Daily Survey Application Follow-up - Completed',
                actor: 'Total results by actor: ',
                title_chart: 'Follow-up by actor',
                tooltip_unit: 'application(s)',
            },
            answers: {
                tab: 'Answers',
                empty_title: 'No results!',
                empty_body: 'There are currently no results for this question.',
                title_chart: 'Number of answers',
                subtitle_chart: 'Answers',
                label_table: 'Answer',
                tooltip_unit: 'Answer(s),'
            },
            export: {
                file_pdf: 'Download charts',
                file_csv: 'Download results (CSV)'
            }
        },
        target: {
            campus: 'Campus',
            faculty: 'Faculty',
            code: 'Code',
            label: 'Label',
            save: 'Save',
            cancel: 'Cancel',
            description: 'Description',
        },
        smtp_config: {
            title: 'SMTP Configuration',
            create: {
                title: 'New SMTP Configuration',
                sub_title: 'Fill out the following form. Fields marked with <span style="color: red">*</span> are required.'
            },
            button_config: 'Server Configuration %{index}',
            email: 'Email',
            password: 'Password',
            server: 'Server',
            port: 'Port',
            priority: 'Priority',
            size: 'Capacity',
            ssl: 'SSL',
            tls: 'TLS',
            status: 'Active',
            save: 'Save',
            delete: 'Delete',
            add: 'Add',
            edit: 'Edit',
            email_method: 'Email Sending Method',
            email_method_smtp: 'Send via SMTP',
            email_method_aws: 'Send via AWS SES',
            aws_section_title: 'AWS SES Configuration',
            aws_info_text: 'Configure AWS SES credentials to send emails with HTML templates rendered correctly.',
            aws_verified_email: 'Verified Email (Optional)',
            aws_verified_email_help: 'Leave blank to use default (prest.evalua@gmail.com). Must be verified in AWS SES Console.',
            aws_access_key: 'AWS Access Key ID',
            aws_access_key_help: 'IAM user access key with SES permissions.',
            aws_secret_key: 'AWS Secret Access Key',
            aws_secret_key_help: 'IAM user secret key (kept secure).',
            aws_region: 'AWS Region',
            aws_region_help: 'AWS region where SES is configured.',
            aws_credentials_info_title: 'Important: HTML Rendering',
            aws_credentials_info_text: 'AWS credentials are required for HTML emails to render correctly. Without them, emails will be sent as plain text via Evalua API.',
            aws_centralized_credentials_title: 'Centralized AWS Credentials',
            aws_centralized_credentials_info: 'AWS SES credentials are securely configured on the server. You only need to optionally specify a verified email in AWS SES different from the default one.',
            optional: '(optional)',
            aws_verified_email_placeholder: 'Leave empty to use the default system email',
            toast: {
                success: 'SMTP configuration was successful!',
                error: 'An error occurred while attempting to configure SMTP! Please contact the administrator.'
            }
        },
        aws_metrics: {
            dashboard_title: 'Email Metrics Dashboard',
            loading: 'Loading metrics...',
            monitoring_email: 'Monitoring email',
            total_sent: 'Total Sent',
            delivered: 'Delivered',
            bounced: 'Bounced',
            complaints: 'Spam Complaints',
            last_7_days: 'Last 7 days',
            last_30_days: 'Last 30 days',
            last_90_days: 'Last 90 days',
            daily_trend: 'Daily Trend',
            about_metrics: 'About These Metrics',
            metrics_description: 'These metrics are obtained directly from AWS CloudWatch and show the performance of emails sent from the configured verified email. Data updates may have a delay of up to 15 minutes.',
            no_data: 'No data available',
            error_loading_metrics: 'Error loading metrics. Please try again.',
            warning_high_rates: 'Warning: High bounce or complaint rates detected',
            high_bounce_rate: 'Bounce rate is {rate}% (recommended < 5%)',
            high_complaint_rate: 'Complaint rate is {rate}% (recommended < 0.5%)',
            ses_limits_warning: 'High rates may affect your AWS SES sending reputation and could result in account suspension. Please review your email list and content.',
            using_global_email_info: 'This contract does not have a specific verified email configured, so it is using the global system email. To use a specific email, configure it in AWS SES Settings.'
        },
        improvements_plan: {
            title_activity: 'improvements plan activities',
            title: 'Improvement plan',
            title_follow_up: 'Improvement Plan Follow-up',
            subtitle: '',
            code: 'Code',
            code_alt: 'Institutional Code',
            follow: 'Follow-up',
            cycle: 'Cycle',
            process: 'Project',
            name: 'Name',
            budget: 'Total budget',
            budget_desc_no_save: 'This value is informative. If not provided when assigning budgets to activities or actions, it will be automatically filled with their total sum.',
            label: 'Label',
            detail: 'Detail or Justification',
            source: 'Finding source',
            goal: 'Goal',
            description_goal: 'Description of %{name}',
            description_campus: 'Campus Description',
            description_description: 'Evidence Description',
            description_indicator: 'Indicator Description',
            description_plans: 'Select a %{name}',
            description_perception: 'Select a %{name}',
            description: 'Evidence',
            objectiveP: 'Strategic Objective',
            aspect: 'Aspects',
            transversal: 'Transversal',
            institutions: 'Programs and institutions',
            plan: 'Plans',
            documental: 'Supporting documents and evidence',
            statistic: 'Statistics',
            perception: 'Perception',
            indicator: 'Indicators',
            exogen: 'Exogenous',
            sic: 'Integrated Quality System',
            send: 'Create Improvement Plan',
            update: 'Save changes',
            back: 'Back',
            target_label_name: 'Objective',
            target_label_code: 'SNIES',
            support_label: 'Name',
            perception_label: 'Instrument',
            open_follow: 'Open',
            month_follow: 'Monthly',
            two_month_follow: 'Bimonthly',
            three_month_follow: 'Quarterly',
            four_month_follow: 'Four-monthly',
            six_month_follow: 'Semiannual',
            anual_follow: 'Annual',
            bianual_follow: 'Biannual',
            sic_modal: 'Integrated Quality System Assignment',
            tab1: 'Basic Information',
            tab2: 'Actions and Activities',
            tab3: 'External Services',
            tab4: 'Enable or Disable',
            create_action: 'Create Action',
            new_action: 'New Action',
            remove_activity: 'To disable this action, you must first delete all associated activities. It is not possible to delete an action that has linked activities.',
            delete_action: 'Are you sure you want to disable this action? Once disabled, it cannot be managed within the improvement plan.',
            reactive_action: 'Are you sure you want to enable this action? Once enabled, it can be managed within the improvement plan',
            state: 'State',
            update_action: 'Update Action',
            execution_short_term: 'Short term',
            execution_medium_term: 'Medium term',
            execution_long_term: 'Long term',
            execution_permanent: 'Permanent',
            execution_cyclic: 'Cyclic',
            execution: 'Execution',
            start_date: 'Start date',
            end_date: 'End date',
            lapse_date: 'Dates',
            advance: 'Progress',
            no_actions: 'No Actions',
            no_evidence_matrix: 'Evidence Matrix is missing',
            no_message_matriz: 'To continue with the Improvement Plan, it is necessary to implement the Evidence Matrix for delimiting and structuring the obtained information.',
            guidance_message: 'It is recommended to first create the Evidence Matrix.',
            success_creation_alert_message: 'Improvement Plan successfully added.',
            success_update_alert_message: 'Improvement Plan successfully updated',
            success_delete_alert_message: 'Improvement Plan successfully deleted',
            success_error_alert_message: 'Missing data to be added',
            action_message: {
                success_creation_alert_message: 'Action added successfully',
                success_update_alert_message: 'Action update successfully',
                success_delete_alert_message: 'Action deleted successfully',
            },
            action: 'Action',
            edit_action: 'Edit action',
            view_action: 'View action',
            disable_action: 'Disable action',
            enable_action: 'Enable action',
            action_name: 'Improvement action name',
            create_activity: 'Create activity',
            action_filter: 'Search by action name or codes',
            no_activities: 'No activities',
            new_activity: 'New activity',
            view_activity: 'View activity',
            disable_activity: 'Disable',
            enable_activity: 'Enable',
            matrix_level: 'Matrix level',
            circle_question: 'Indicate the matrix level at which you will create the actions.',
            no_recomendation: 'No recommendations',
            action_recomendation: 'Recommended actions',
            create: 'Create action towards',
            strength: 'the strength of ',
            oportunity: 'the opportunity for improvement of ',
            weakness: 'the weakness of ',
            matrix: 'Matrix',
            objective: 'Target group',
            origin: 'Why?',
            type: 'Action type',
            activity_title: 'Activity',
            edit_activity: 'Edit activity',
            expected_result: 'Expected result',
            select_type_origin: 'Select the data source',
            type_origin: 'Data source',
            internal_origin: 'Internal source',
            external_origin: 'External source',
            internal_origin_desc: 'The data from the PREST system process result will be used',
            external_origin_desc: 'The data will be used through the provided web services',
            accept: 'Accept',
            notes: 'Evaluator notes',
            external_col: 'Responsible',
            under_external_col: 'Enter the name and position',
            level_col: 'Responsibility level',
            under_level_col: 'Indicate whether it is institutional, faculty, or program',
            message_phva: 'The action is missing the activity type: ',
            messages_phva: 'The action is missing the activity types: ',
            indicator_PDI: 'PDI indicator',
            dimension_PDI: 'PDI strategic dimension',
            program: 'Program',
            object_PDI: 'PDI strategic objective',
            project: 'Project',
            budget_PDI: 'Budget',
            activity: {
                tittle: 'Activities',
                subtitle: '',
                code: 'Code',
                code_alt: 'Institutional Code',
                action: 'Action or group',
                plan: 'Improvement plan',
                campus: 'Campus',
                what: 'What?',
                strategicP: 'Strategic planning',
                name: 'Name of the activity',
                when: 'When?',
                start: 'Start',
                end: 'End',
                other_origin: 'Other target groups',
                where: '¿Dónde? <|> Where?',
                targets: 'Impacted Sectors (programs, faculties, campuses, institution)',
                groups: 'Impact',
                matrix: 'Evidence Matrix',
                who: 'Who?',
                collaborator: 'Collaborators',
                how_much: 'How Much?',
                resources: 'Resources',
                how: 'How?',
                action_type: 'Type of Activity',
                auto_indicator: 'Indicator',
                type_indicator: 'Type of Indicator',
                base_line: 'Baseline',
                indicator_option: {
                    move: 'Management',
                    impact: 'Impact',
                    result: 'Results'
                },
                at_plan: '(P) Plan',
                at_do: '(H) Do',
                at_verify: '(V) Check',
                at_act: '(A) Act',
                at_improvement: 'Improvement',
                at_strengthening: 'Strengthening',
                at_unknown: 'Unknown type',
                result: 'Result',
                result_kpi: 'KPI',
                result_quantity: 'Budget',
                result_document: 'Document or link',
                result_other: 'Other',
                result_1: '1. Social impact and regional outreach activities',
                result_2: '2. Institutional well-being of the educational community',
                result_3: '3. Teacher qualification',
                result_4: '4. Physical development and environmental sustainability',
                result_5: '5. Technological development',
                result_6: '6. Infrastructure',
                result_7: '7. Internationalization',
                result_8: '8. Physical plant investment',
                result_9: '9. Investments in furniture, equipment, machinery, and bibliographic resources',
                indicator_move: 'Management',
                indicator_impact: 'Impact',
                indicator_result: 'Result',
                indicator_arch: 'Achievement',
                why: 'Why?',
                plans: 'Plans',
                quantity: 'figures',
                sic: 'SIC',
                indicator: 'documentary indicators',
                notes: 'Evaluator notes',
                perception: 'Perception',
                exogen: 'Exogenous sources',
                other: 'Others',
                tags: 'Tags',
                add: 'Add activity',
                update: 'Update activity',
                delete: 'Delete activity',
                disable_activity: 'Disable activity',
                enable_activity: 'Enable activity',
                tags_placeholder: 'Enter items separated by commas',
                colab: 'Collaborator',
                rol: 'Role',
                add_colab: 'Add Collaborator',
                update_colab: 'Edit Collaborator',
                r_type: 'Resource type',
                r_detail: 'Resource detail',
                r_value: 'Unit value',
                r_scale_value: 'Value scale',
                r_quantity: 'Quantity',
                r_scale_quantity: 'Quantity scale',
                r_scale: 'No. of decimals',
                r_origin: 'Origin',
                r_url: 'URL',
                add_resource: 'Add Resource',
                update_resource: 'Update Resource',
                remove: 'Remove',
                escape: 'Back',
                follow_type: 'Follow-up type',
                url_follow: 'External follow-up URL',
                internal_follow: 'Internal Follow-up',
                external_follow: 'External Follow-up',
                remove_activity: 'To disable this activity, it is only allowed if it does not have follow-up in the Improvement Plan Activities.',
                delete_activity: 'Are you sure you want to disable this activity? Once disabled, it cannot be managed within the improvement plan.',
                reactive_activity: 'Are you sure you want to enable this activity? Once enabled, it can be managed within the improvement plan.',
                create: {
                    success: 'Activity created',
                    error: 'Error creating activity'
                },
                edit: {
                    success: 'Activity edited',
                    error: 'Error editing activity'
                }
            },
            file_load: {
                load_action: 'Load actions',
                load_action_file: 'Load actions file',
                load_activity: 'Load activity',
                load_activity_file: 'Load activity file',
                advanced: 'Advanced option',
                related_activity: 'Create default activity',
                download_format_activity: 'Download activity upload template',
                download_format_actions: 'Download actions upload template',
                format_alert: 'Alert! Please avoid modifying the headers of the template, as this may compromise the integrity of the data. If you have any questions, do not hesitate to contact an administrator for assistance.'
            },
            dashboard_improvement_plan: {
                title: 'Dashboard - Improvement Plan',
                subtitle: 'Comprehensive monitoring of improvement plans by academic program',
                pdf_button: 'PDF',
                excel_button: 'Excel',
                filter: {
                    title: 'Filters',
                    sede: 'Campus',
                    department: 'Faculty',
                    program: 'Program',
                    project: 'Project',
                    cycle: 'Cycle',
                    factor: 'CNA-Matrix Factor',
                    all_campuses: 'All campuses',
                    all_faculties: 'All faculties',
                    all_programs: 'All programs',
                    all_projects: 'All projects',
                    all_cycles: 'All cycles',
                    all_factors: 'All factors'
                },
                executives: {
                    ranking_title: 'Programs Ranking by Progress',
                    ranking_subtitle: 'Performance comparison between academic programs',
                    table: {
                        position: 'Position',
                        program: 'Program',
                        self_assessment_progress: 'Expected Progress',
                        general_progress: 'General Progress',
                        completed_activities: 'Completed Activities',
                        late_activities: 'Late Activities'
                    },
                    total_programs: 'Total programs',
                    autoevaluation_progress: 'Expected Progress',
                    general_progress: 'General Progress',
                    delayed_activities: 'Late Activities',
                    early_alerts: 'Early Alerts',
                    button_details: 'View details',
                    no_data: 'No data to display'
                },
                action_progress: {
                    program: 'Program',
                    responsible: 'Responsible',
                    advance: 'General Progress',
                    activities: 'Activities',
                    expected: 'Exp',
                    no_data: 'No actions available to display.',
                    page: 'Page',
                    of: 'of',
                    unassigned: 'Unassigned'
                },
                activities: {
                    state: 'Status',
                    activity: 'Activity',
                    program: 'Program',
                    factor_cna: 'CNA Factor',
                    responsible: 'Responsible',
                    end_date: 'End Date',
                    advance: 'Progress',
                    complete: 'Completed',
                    alert: 'Alert',
                    warning: 'Warning',
                    early_alert: 'Early Alert',
                    waited: 'Expected',
                    expected: 'Expected',
                    no_record: 'No record',
                    no_data: 'No data',
                    page: 'Page',
                    of: 'of',
                    filters: {
                        all: 'All',
                        completed: 'Completed',
                        late: 'Late',
                        warning: 'Warning',
                        early_alert: 'Early Alert',
                        in_progress: 'In progress'
                    },
                    table: {
                        status: 'Status',
                        activity: 'Activity',
                        program: 'Program',
                        factor_cna: 'CNA Factor',
                        responsible: 'Responsible',
                        end_date: 'End Date',
                        progress: 'Progress',
                        last_update: 'Last Update'
                    },
                    status: {
                        completed: 'Completed',
                        late: 'Late',
                        warning: 'Warning',
                        early_alert: 'Early Alert',
                        in_progress: 'In progress',
                        no_status: 'No status'
                    }
                },
                responsibles: {
                    activity_name: 'Activity Name',
                    subtitle: 'Current information for each activity with the latest progress record',
                    responsible: 'Responsible(s)',
                    last_date_register: 'Last Registration Date',
                    current_progress: 'Current Progress',
                    expected_progress: 'Expected Progress',
                    status_header: 'Status',
                    program: 'Program',
                    factor_cna: 'CNA Factor',
                    page: 'Page',
                    of: 'of',
                    no_record: 'No record',
                    status: {
                        completed: 'Completed',
                        late: 'Late',
                        warning: 'Warning',
                        early_alert: 'Early Alert',
                        in_progress: 'In progress',
                        no_status: 'No status'
                    }
                },
                traffic_light: {
                    complete: 'Completed',
                    caution: 'Warning (≤30 days)',
                    late: 'Late (>30 days)',
                    title: 'Early Warning System',
                    end: 'Activities finished at 100%',
                    description: 'Activities with less than 30 days to expire or with progress less than expected',
                    late_label: 'Late',
                    late_description: 'Activities that have exceeded their deadline without completion',
                    early_alerts: 'Early Alerts',
                    defeated: 'Overdue',
                    description_alerts: 'Generated when current progress is less than expected progress for the date, even if the activity has not expired. This allows taking corrective actions in time.'
                }
            }
        },
        review: {
            title: 'Final evaluation',
            sub_title: 'By standard levels',
            no_result: 'No result',
            dofa_button: 'SWOT Analysis',
            processing: 'Starting SWOT session...',

            popover_info: {
                average: 'Average',
                weight: 'Weight'
            },

            weighing: {
                see: 'View weighting',
                title: 'Weighting',
            },

            assessment: {
                title: 'Perception',
                sub_title: 'Average by category',
                no_info: "No instruments have been applied or no quantifiable results have been recorded.",
                no_groups_data_title: "No results by stakeholder group!",
                no_groups_data_sub_title: "The current level was not assigned in the perception instruments to display results by stakeholder group."
            },

            evidence: {
                title: 'Documentary',
                sub_title: 'Number of documents evaluated by type',
                no_info: ' No documents have been evaluated yet.',
                no_document_data_title: 'No results for this document type!',
                no_document_data_sub_title: 'The current level has no documents assigned to display results by type.'
            },

            statistical_evidence: {
                title: 'Statistical',
                sub_title: 'Number of statistical documents evaluated by type',
                no_info: 'No documents have been evaluated.',
                no_document_data_title: 'No results by document type!',
                no_document_data_sub_title: 'The current level has no assigned documents to display results by type.'
            },

            supports: {
                title: 'Documents',
                sub_title: 'List of Evaluated Documents'
            },

            improvvement_plan: {
                title: 'Recommendations for the Improvement Plan',
                button: 'View OF'
            },

            name_graph: {
                feature_1: 'Polar area',
                feature_2: 'Line',
                feature_3: 'Bars',
                feature_4: 'Radar',
                feature_5: 'Circular',
                feature_6: 'Ring',
            }
        },
        teacher_review: {
            title: 'Teacher Evaluation',
            no_result: 'No result!',
            config: 'Teacher evaluation settings',
            accept: 'Accept',
            applicant: 'Application for the instrument:',
            instrument: 'Select an instrument',
            version: 'Select an instrument application',
            add: 'Add',
            remove: 'Remove',
            percentage: 'Percentage in the evaluation',
            percentage_remaining: 'maximum available',
            open_config: 'Open configuration',
            close: 'Close',
            no_more_100: 'The evaluation percentages cannot exceed 100%'
        },
        add_standard: {
            title: '<b>Create New Standard</b>',
            subtitle: 'Creating a new standard for the contract',
            standard_name: 'Standard name',
            standard_description: 'Standard description',
            standard_min_target: 'Minimum Target Level',
            standard_max_target: 'Maximum Target Level',
            standard_type: 'Standard type',
            copy_matrix_standard: {
                header: 'Matrix Configuration',
                copy_label: 'Copy Matrix',
                default_option: 'Select standard'
            },
            copy_timeline_standard: {
                header: 'Timeline Configuration',
                copy_label: 'Copy Timeline'
            },
            custom_validation_messages: {
                not_valid_total_formula: 'The sum of the formula values must be equal to 100.',
                not_valid_target_levels: 'You must select a Maximum Target Level greater than the Minimum Target Level.'
            },
            success_creation_alert_message: 'The standard has been created successfully.',
            error_creation_alert_message: 'There was a problem creating the standard.',
            save_button: 'Save',
            back_button: 'Back'
        },
        contract: {
            alternative_title: 'Contract',
            section_one: {
                tab: 'Platform configuration and customization',
                title: 'Logos and homepage',
                logo_url: 'Main logo',
                logo_alt: 'Side logo',
                color_code: 'Institutional color',
                icon_lateral: 'Visible side icon',
                url_anexa: 'Side icon redirect URL',
                message: 'Text on homepage',
                alert_title_save: 'Save customization changes',
                alert_message_save: 'Warning: Saving customization changes will overwrite your institution\'s previous settings. Are you sure you want to continue?',
                icon_logo: 'Do not show bottom logo in emails',
                accept_url_support: 'Accept support links via URL'
            },
            section_two: {
                tab: 'Update data policy',
                title: 'Data policy',
                policy_url: 'Institutional data treatment policy URL',
                alert_title_save: 'Update institutional data treatment policy',
                alert_message_save: 'Do you want to update the data treatment policy? This change will require all users to accept it again.'
            },
            section_three: {
                tab: 'Standard customization',
                title: 'Custom standards',
                standard: 'Standard',
                status: 'Status',
                name: 'Standard name',
                description: 'Standard description',
                appreciation: 'Appreciation',
                statistics: 'Statistics',
                evidence: 'Documentary',
                modal_reports: {
                    title: 'Link reports to the standard'
                },
                system_reports: 'System reports',
                report_standard: 'Reports for the standard',
                groups_appreciation: 'Target Groups Instruments',
                groups_evidence: 'Specialized matrix groups',
                empty: 'No custom standards found',
                add_reports: 'Link reports',
                alert_title_save: 'Update standard',
                alert_message_save: 'Warning: Saving changes to the standard customization will overwrite previous settings. Are you sure you want to continue?',
                objectives_cards: {
                    name: 'Target groups',
                    inputs: {
                        input_name: {
                            on_edit_label: 'Target group name',
                            to_show_label: 'Target group'
                        },
                        input_description: {
                            on_edit_label: 'Description',
                            to_show_label: ''
                        }
                    },
                    no_objectives: 'No objectives'
                },
                buttons: {
                    scheduler_template_button: 'View and edit schedule template',
                    matrix_template_button: 'View and edit matrix template',
                    rubrics_button: 'View and edit evaluation rubrics'
                }
            },
            util: {
                message_placeholder: 'Enter the message that will appear on the homepage and on the back cover of the reports',
                save: 'Save changes',
                confirm: 'Confirm',
                cancel: 'Cancel',
                add_standard: 'Create standard',
                open_view: 'Open preview'
            }
        },
        rubric: {
            rubric_list: {
                title: 'Rubric',
                subtitle: 'Rubrics list by standard',
                table: {
                    code_col: 'Code',
                    rubric_col: 'Rubric',
                    type_col: 'Question type',
                },
                add_button: 'add rubric',
                no_edit_allowed: {
                    alert_header: 'No rubric access',
                    alert_message: ' It is not possible to view the rubrics of the selected standard'
                }
            },
            rubric_form: {
                add_title: 'Add Rubric',
                edit_title: 'Edit Rubric',
                rubric_name: 'Rubric Name',
                help: 'Help',
                question: 'Question',
                status: 'Status',
                code: 'Code',
                detail: 'Detail',
                question_type: 'Question Type',
                save_button: 'Save',
                return_button: 'Back',
                status_options: {
                    option_A: 'Select status',
                    option_B: 'Active',
                    option_C: 'Inactive'
                },
                type_default_option: 'Select type',
                change_type_modal: {
                    title: 'Change Question Type',
                    warning_message: 'This question currently has a type and response options assigned. If you change the type, the options will be deleted when the question is saved. Do you want to change the question type?',
                    accept_change_button: 'Accept',
                    cancel_button: 'Cancel'
                },
                max_length_message_feedback: 'The maximum number of characters has been exceeded',
                required_all_fields_message: 'There are still required fields left to complete',
                error_loading_rubric: 'Error loading rubric data'
            }
        },
        dashboard: {
            alternative_title: 'General dashboard',
            title: 'General Process Dashboard',
            subtitle: 'Here you can view the general control dashboard for all processes in your institution.',

            reports: {
                title: 'Reports',
                subtitle: 'Generate self-evaluation process reports for the current cycle.',
                success: 'The request to generate the report has been sent.',
                filters: 'Filters',
                iteration: 'Cycle',
                year: {
                    name: 'Year',
                    message: 'Enter the year from which you want to generate the information:',
                },
                period: {
                    name: 'Period',
                    message: 'Select the period from which you want to generate the information:',
                },

                weighing_card: {
                    header: 'Weighting'
                },

                documental_card: {
                    header: 'Documents'
                },

                format_modal: {
                    title: 'Format',
                    message: 'Please choose the format to request the report generation.',

                    excel: 'EXCEL',
                    pdf: 'PDF',
                    all: 'ALL FORMATS',
                    word: 'WORD'
                },

                fields: {
                    request_date: 'Request date',
                    format: 'Format',
                    label: 'Report',
                    buttons: 'Actions'
                },

                warning_message: 'There are no reports associated with the current self-evaluation process standard.',
                permissions_message: 'You do not have permission to request reports.'
            },

            templates: {
                title: 'Institutional Information Templates',
                subtitle: 'Institutional information stored in templates sent to the ministry.',

                new: {
                    button: 'Create Template',

                    modal: {
                        title: 'Add a New Template',
                    },
                    name: 'Name',
                    description: 'Description',

                    card: {
                        title: 'Fields',

                        fields: {
                            name: 'Name',
                            description: 'Description'
                        }
                    }
                }
            },
            templates_eva: {
                title: 'Teacher Evaluation Templates',
                subtitle: 'Institutional information stored for teacher evaluation and upload of institutional data on students, teachers, courses, and resources.',

                new: {
                    button: 'Create template',

                    modal: {
                        title: 'Add new template',
                    },
                    fields: {
                        name: 'Name',
                        description: 'Description'
                    }

                }

            }

        },
        notes: {
            title_h: 'Notes',
            subtitle: 'Here you will find the evaluation notes for this project: &data.',
            add: 'Add Note',
            create_conclusion: 'Create conclusion note',
            see_conclusion: 'View conclusion note',
            no_notes: 'No Notes',
            meets: 'Does it meet?',
            yes: 'Yes',
            no: 'No',
            observation_type: 'Observation type',
            type_one: 'Recognition',
            type_two: 'Nonconformity',
            type_three: 'Observation',
            type_four: 'Closed Note',
            type_five: 'Conclusion Note',
            objective: 'Objective',
            matrix: 'Matrix',
            note: 'Note',
            notes: 'Notes',
            creation_date: 'Creation date',
            term_date: 'Deadline date',
            actions: 'Actions',
            new_note: 'New note',
            see_note: 'View details',
            edit_note: 'Edit note',
            close_note: 'Close note',
            save: 'Save',
            term: 'Term',
            days: 'Days',
            weeks: 'Weeks',
            months: 'Months',
            years: 'Years',
            semesters: 'Semesters',
            weighing: 'Weighting',
            perception: 'Perception',
            valoration: 'Documentary',
            improvement: 'Improvement plan',
            process: 'Entire Project',
            see_notes: 'View notes',
            title: 'Title',
            level: 'Note level',
            high_level: 'Higher',
            low_level: 'Lower',
            activities_pm: 'Related improvement plan activities',
            no_activities_pm: 'No improvement plan activities',
            detail: 'Detail',
            ok: 'Accept',
            version: 'Version',
            versions: 'Versions',
            created: 'The note has been successfully created',
            updated: 'The note has been successfully updated',
            closed: 'The note has been successfully closed',
            user: 'Evaluator',
            my: {
                title: 'My notes',
                subtitle: 'Here you will find all your notes in all the projects you evaluate.'
            }
        },
        participants: {
            load_participants: 'Load participants',
            participants: 'participants',
            cancel: 'Cancel',
            ok: 'load',
            select_type: 'Select a participant group to upload',
            success: '&x participants will be uploaded.',
            warning: '&x participants were found, however the participant data is not updated to the current year and period. Do you want to continue with the upload?',
            danger: 'No participants were found registered in the selected group.',
        },
        artificial_intelligence: {
            title_panel: 'Welcome to the AI Agents section',
            sub_title_panel: 'The interactive space to enhance self-assessment and strengthen academic excellence.',
            reporting: 'Reports',
        },
        chat_bot: {
            conversation: 'Conversation',
            message_placeholder: 'Type a message...',
        },
        wrapper: {
            view_forbidden: 'Your role does not have access to PRESTV2.',
            user_not_found: 'We could not find your user in PRESTV2. Contact your administrator.',
            project_not_active: 'This project is no longer active and cannot be continued.',
            upstream_down: 'The project is not available to continue right now. Try again in a few minutes.',
            upstream_timeout: 'The project is not available to continue: it did not respond in time. Try again in a few minutes.',
            session_expired: 'Your PRESTV2 session has ended. Open the project again.',
            readonly: 'This action is not available from Academy.',
            project_mismatch: 'You opened another project in another tab. Reload this one to continue with the current project.',
            no_contract: 'The project is not available to continue: we could not find an active PRESTV2 contract linked to this project. Contact the administrator of your institution.',
            route_denied: 'This action is not allowed from Academy.',
            payload_too_large: 'What you sent exceeds the maximum size per upload. If they are files, send them in parts or reduce their size.',
            payload_too_large_max: 'What you sent exceeds the &max MB limit per upload. If they are files, send them in parts or reduce their size.',
            retry: 'Retry',
            projects_limit_notice: 'Showing the 200 projects with the nearest end date',
            dofa_unavailable: 'The SWOT module is not available in this environment.',
            dofa_readonly: 'The SWOT module is not available in a read-only project.',
            project_readonly: 'This project has ended and is read-only: you can view it and download reports and documents, but not create, edit or delete.',
            project_sheet: 'Project details',
            link_invalid: 'The saved link is not a valid web address, so it was not opened.',
            link_wrapper: 'This link opens PRESTV2 inside Academy. It is not opened in another tab so that this session is not closed.',
            kept_link: 'Leave it empty to keep the saved link, which is not shown inside Academy. Type a URL only if you want to change it.',
        },
        dashboard_action: {
            main: {
                title: 'Project Monitoring Dashboard',
                subtitle: 'Project Monitoring and Progress System',
                comparative_mode: 'Comparative Mode',
                configuration: 'Configuration',
                filters: 'Filters',
                filters_labels: {
                    sede: 'Campus',
                    faculty: 'Faculty',
                    program: 'Program',
                    cycle: 'Cycle',
                    matrix: 'Matrix'
                },
                filter_options: {
                    all_sedes: 'All campuses',
                    all_faculties: 'All faculties',
                    all_programs: 'All programs',
                    all_cycles: 'All cycles',
                    all_factors: 'All factors'
                },
                tabs: {
                    summary: 'Summary',
                    state: 'State',
                    progress: 'Progress',
                    activities: 'Evidence Matrix',
                    schedule: 'Schedule'
                },
                messages: {
                    tab_changed: 'Tab changed',
                    error_loading_data: 'Error loading dashboard data',
                    error_loading_filters: 'Error loading filters'
                }
            },
            activities: {
                title: 'Activities Dashboard',
                subtitle: 'Detailed tracking of activity development by category',
                completed_count: '{completed} of {total} completed',
                activities_of: 'Activities of {category}',
                responsible: 'Responsible',
                due_date: 'Due',
                progress: 'Progress',
                completed_by: 'Completed by {person}',
                on_date: 'on',
                tabs: {
                    weighting: 'Weighting',
                    definition: 'Definition',
                    evidences: 'Evidence',
                    assessment: 'Assessment'
                },
                status: {
                    completed: 'Completed',
                    in_progress: 'In progress',
                    in_development: 'In development'
                }
            },
            advance: {
                activities_progress: 'Activities Progress',
                activities_progress_subtitle: 'Current status of the main process activities',
                faculty_progress: 'Progress by Faculty',
                faculty_progress_subtitle: 'Comparison of completed vs in-progress programs',
                monthly_trend: 'Monthly Trend',
                monthly_trend_subtitle: 'Programs completed and started by month',
                process_distribution: 'Distribution by Process Type',
                process_distribution_subtitle: 'Percentage of programs by process type',
                chart_labels: {
                    completed: 'Completed',
                    in_progress: 'In progress',
                    started: 'Started'
                }
            },
            resume: {
                recent_programs: 'Recent Programs',
                recent_programs_subtitle: 'Latest programs updated in the system',
                expires: 'Expires',
                vs_previous_month: 'vs previous month',
                cards: {
                    active_programs: 'Active Programs',
                    active_programs_desc: 'Total programs in process',
                    completed: 'Completed',
                    completed_desc: 'Programs finished this month',
                    in_progress: 'In Progress',
                    in_progress_desc: 'Programs in development',
                    late: 'Late',
                    late_desc: 'Require immediate attention'
                }
            },
            scheduler: {
                title: 'Activity Schedule',
                subtitle: 'Progress tracking by program in the accreditation process',
                completed_by: 'Completed by',
                total_stages: 'Total Stages',
                total_activities: 'Total Activities',
                completed: 'Completed',
                general_progress: 'General Progress',
                programs: 'programs',
                no_programs_in_phase: 'No programs in this phase.',
                total_programs: 'Total Programs',
                no_programs: 'No programs registered',
                phase_breakdown: 'Progress by Accreditation Phase',
                phase_names: {
                    ponderacion: 'Weighting',
                    definicion: 'Evidence Definition',
                    evidencias: 'Evidence Upload',
                    valoracion: 'Assessment'
                },
                status: {
                    completed: 'Completed',
                    in_progress: 'In progress',
                    in_development: 'In development'
                }
            },
            state: {
                title: 'Program State',
                subtitle: 'Detailed tracking of dates and accreditation processes',
                ranking_title: 'Programs Ranking by Progress',
                ranking_subtitle: 'Performance comparison between academic programs',
                export: 'Export',
                search_placeholder: 'Search programs...',
                no_data: 'No programs match the search.',
                page: 'Page',
                of: 'of',
                table: {
                    program: 'Program',
                    faculty: 'Faculty',
                    sede: 'Campus',
                    cycle: 'Cycle',
                    development_date: 'Development Date',
                    filing_date: 'Filing Date',
                    resolution_date: 'Resolution Date',
                    status: 'Status',
                    progress: 'Progress',
                    actions: 'Actions'
                },
                modal: {
                    title: 'Program Detail',
                    general_info: 'General Information',
                    dates: 'Process Dates',
                    progress: 'Status & Progress',
                    close: 'Close'
                }
            },
            matrix_progress: {
                info_banner: {
                    title: 'Evidence Matrix Progress',
                    description: 'Visualize the progress by program in each phase of the self-assessment process: Weighting, Definition, Evidence Upload and Assessment.'
                },
                categories: {
                    all: 'All'
                },
                phases: {
                    ponderacion: 'Weighting',
                    definicion: 'Definition',
                    evidencias: 'Evidence',
                    valoracion: 'Assessment'
                },
                progress: 'Progress',
                of: 'of',
                no_activities: 'No activities to display with the selected filters.'
            }
        },
    },
    es: {
        util: {
            load: 'Estamos preparando las cosas para ti. Solo necesitamos un momento más.',
            download_format_mail: 'Descargar formato de correos',
            closed_session: 'Sesión cerrada por inactividad',
            prest_academy_new: 'PREST Academy',
            development_plans: 'Planes de Desarrollo',
            improvement_plans: 'Planes de Mejora',
            page_not_found: 'Página no encontrada',
            return_home: 'Volver al inicio',
            empty: 'No hay registros',
            table_filter: {
                label: 'Filtro',
                input_placeholder: 'Escriba para buscar...',
                button_label: 'Limpiar',
                checkbox_label: 'Filtrar por:',
                checkbox_description: 'Para filtrar en toda la base no seleccione campos.'
            },
            table_pagination: {
                label: 'Por página'
            },
            loading: 'Cargando ...',
            valid_select: 'Seleccione alguna opción',
            select_placeholder: 'Seleccione una opción',
            multiselect: {
                searching: 'Buscar: %{field}',
                no_options: 'No hay registros'
            },
            document: {
                no_support: 'Archivo no soportado para visualizar.',
            },
            tree: {
                add_all: 'Añadir todos',
                remove_all: 'Eliminar todos',
                restore: 'Restablecer',
            },
            treeselect: {
                matrix: 'Selecciona un elementos de la matriz'
            },
            card_component: {
                add: "Registro añadido",
                edit: "Registro editado",
                delete: "Registro eliminado",
                no_edit: "No se puede editar el registro, este ya se encuentra en uso en otras partes del sistema.",
                no_delete: "No se puede eliminar el registro, este ya se encuentra en uso en otras partes del sistema.",
            },
            soon: 'Próximamente',
        },
        password_change: {
            title: 'Cambio de contraseña',
            subtitle: {
                send: 'Dígite su correo para el envío del correo de restauración de la contraseña',
                change: 'Dígite una nueva contraseña'
            },
            placeholder: 'Ingrese su correo electrónico',
            submit: 'Enviar',
            alert: {
                validation: {
                    message: '¡Se venció el enlace para el cambio de contraseña!',
                    message_strong: 'Solicite uno nuevo.'
                },

                message_sent: '¡El mensaje fue enviado exitosamente! Por favor revise su correo para continuar.',
                comparation: 'Las contraseñas no coinciden, por favor verificar'
            },
            new_password: {
                placeholder: 'Ingrese una nueva contraseña',
                confirmation_placeholder: 'Ingrese nuevamente la contraseña',
                show: "Mostrar",
                hide: "Ocultar"
            },
            email: {
                validator_message: 'Por favor ingrese una dirección de correo válida'
            }
        },
        general: {
            edit_process: 'Editar proyecto',
            contract: 'Contrato',
            program_label: 'Programa',
            programs: 'Programas',
            process_label: 'Proyecto',
            process_change: 'Usted acaba de seleccionar el proyecto &process.  Recuerde que de ahora en adelante los cambios que realice en la plataforma será sobre este proyecto, en caso que desee cambiar de proyecto lo podrá hacer en cualquier momento desde la parte superior',
            select_process: 'Seleccione un proyecto',
            select_process_desc: 'Seleccione el proyecto sobre el cual va a trabajar',
            no_process: 'Sin Proyectos en este contrato',
            current_process: 'Proyecto actual:',
            processes: 'Proyectos',
            process: 'Ficha del proyecto actual',
            select: 'Seleccionar',
            cancel: 'Cancelar',
            code: 'Código',
            name: 'Nombre',
            status: 'Estado',
            valid: 'Vigente',
            no_valid: 'No vigente',
            target: 'Objetivos del proyecto',
            dates: 'Fechas',
            supports: 'Soportes',
            no_supports: 'Sin soportes',
            change_process: 'Cambiar proyecto',
            change_contract: 'Cambiar Contrato',
            cycles: 'Ciclos del proyecto:',
            current_cycle: 'Ciclo actual:',
            policy: {
                title: 'TÉRMINOS Y CONDICIONES VIGENTES',
                validity: 'Vigente desde: ',
                checkbox_before: 'Yo acepto los términos y condiciones de PREST',
                checkbox_after: 'Yo acepto los términos y condiciones de ',
                checkbox_link: 'mi institución que pueden ser consultados acá',
                accept: 'Aceptar',
                cancel: 'Cancelar',
                accept_toast: 'Gracias',
                cancel_toast: 'Para ingresar a la plataforma es necesario que acepte, lo esperamos en otra ocasión.',
            },

        },
        home: {
            title_h: 'PREST - Evalúa',
            title_init: 'Bienvenida/o a',
            title_configuration: '<b>Configuración Institucional</b>',
            message_init: 'Comienza con tu configuración inicial, selecciona la opción con la que deseas iniciar.',
            process_button_label: 'Proyectos',
            schedule_button_label: 'Configuración del cronograma'
        },
        process: {
            title_h: 'Proyectos',
            title: 'Proyectos',
            title_asociated: 'Proyectos asociados',
            description: 'Lista de proyectos',
            show_all: 'Mostrar todos los proyectos',
            process_label: 'Proyecto',
            process_cont: 'Cantidad de proyectos: ',
            description_label: 'Descripción',
            report_label: 'Reporte',
            date: 'Tiempo de duración',
            date_expire: 'Fecha de expiración de registro',
            progress: 'Avance del proyecto',
            process: 'Proyecto',
            status: 'Estado',
            target: 'SNIES Objetivo del proyecto',
            person_in_charge: 'Responsable',
            no_process: 'No se encontró ningún resultado, verifique el filtro.',
            standard: 'Tipo de proyecto',
            no_standard: 'No se encontraron tipos de proyectos en su contrato, contacte con el proveedor.',
            view_process: 'Ver proyecto activos',
            view_process_prospect: 'Ver proyectos prospecto',
            view_process_asociated: 'Ver proyectos asociados',
            create: {
                title_alert_start_date: 'Advertencia',
                accpet_current_date: 'Aceptar',
                close_current_date: 'Cerrar',
                alert_current_date: 'La fecha de inicio no deberia ser anterior a la fecha actual.',
                note_collaborator: 'Recuerde que su usuario sera agregado como colaborador de manera predeterminada.',
                title: 'Nuevo Proyecto',
                title_asociated: 'Asociar proyecto',
                process: 'Proyecto',
                processes: 'Proyectos asociados',
                type_process: 'Tipo proyecto',
                start_date: 'Inicio del proyecto',
                settlement_date: 'Fecha de radicación',
                end_date: 'Fin del proyecto',
                tooltip_end: 'Fecha de vencimiento de resolución',
                target: 'SNIES Objetivo del proyecto',
                number_cycles: 'Número de ciclos',
                period: 'Periodo',
                name: 'Nombre del proyecto',
                description: 'Diligencia el siguiente formulario. Los espacios con <span style="color: red">*</span> son obligatorios',
                send: 'Guardar',
                close_cycle: 'Informe de autoevaluación',
                evaluation_cycle: 'Ciclo de evaluación',
                indication_info: 'Seguimientos',
                date: 'Fechas',
                indication: {
                    status: 'Estado',
                    detail: 'Detalle',
                    reported_percentage: 'Avance',
                    support_type: 'Soporte'
                },
                start: 'Fecha inicio',
                end: 'Fecha fin',
                title_h: 'Creación de proyecto',
                description_label: 'Descripción del proyecto',
                report_label: 'Nombre del Reporte',
                created: 'El proyecto &code fue creado exitosamente, continue con la configuración de ciclos.',
                continue: 'Continuar',
                back: 'Volver',
                add_collaborator: 'Añadir colaborador',
                name_invaled_cicle: {
                    more_500: 'El nombre excedió los 500 caracteres',
                    zero: 'El ciclo debe tener un nombre'
                },
                remove_self_collaborator: 'No puede eliminarse usted mismo como colaborador',
                collaborator: 'Colaborador',
                remove: 'Remover',
                action: 'Acción',
                add_program: 'Adicionar programa',
            },
            update_collaborators_message: 'Se han actualizado el proyecto',
            update_collaborators_modal: {
                title: 'Actualizar colaboradores',
                alert_message: 'Si elimina al responsable del proyecto y/o a un colaborador, este sera inhabilitado del proyecto y de todas las actividades de las cuales pudiera responsable.',
                save_button: 'Enviar',
                cancel_button: 'Cancelar'
            },

            validation: 'El objetivo %{code} - %{targetLabel} se encuentra actualmente en el proceso %{processLabel}. Por favor retirelo, o cambie el tipo de proyecto al que lo está asociando.'
        },
        activity: {
            title_h: 'Actividades - Evalúa',
            title: 'Actividades',
            description: 'Lista de actividades en un curso próximo a iniciar.',
            show_all: 'Mostrar todas las actividades',
            activity_label: 'Actividad',
            description_label: 'Descripción',
            date: 'Tiempo de duración',
            progress: 'Avance de la actividad',
            person_in_charge: 'Responsable',
            q: 'Etiqueta',
            stage: 'Etapa',
            cycle: 'Ciclo',
            status: 'Estado',
            process: 'Proyecto',
            code: 'Código',
            valid: 'Vigente',
            no_valid: 'No vigente',
            return: 'Volver',
            new_advance: 'Adición',
            no_activities: 'No se encontró ningún resultado, verifique el filtro.',
            action: 'Acción',
            pm: 'Plan de mejora',
            create: {
                title_h: 'Crear Actividad',
                title: 'Nueva Actividad',
                description: '',
                submit: 'Enviar',
                save: 'Añadir',
                valid: 'Validar',
                cancel: 'Cancelar',
                cycle_input: 'Proyecto y ciclo',
                stage_input: 'Etapa',
                activity_name_input: 'Actividad',
                activity_name_placeholder: 'Nombre de la actividad',
                dates_input_start: 'Fecha inicial',
                dates_input_end: 'Fecha final',
                description_input: 'Descripción',
                description_placeholder: 'Resumen',
                dates_cards: {
                    name: 'Fechas',
                    inputs: {
                        input_additional_date_name: {
                            on_edit_label: 'Nombre fecha',
                            to_show_label: 'Nombre fecha'
                        },
                        input_additional_date: {
                            on_edit_label: 'Fecha',
                            to_show_label: 'Fecha'
                        }
                    }
                },
                collaborators_cards: {
                    name: 'Colaboradores',
                    inputs: {
                        input_name: {
                            on_edit_label: 'Nombre usuario',
                            to_show_label: 'Usuario',
                            optionA: 'Seleccione un colaborador',
                        },
                        input_role: {
                            on_edit_label: 'Rol',
                            to_show_label: 'Rol',
                            optionA: 'Rol del colaborador',
                            optionB: 'Responsable Principal',
                            optionC: 'Colaborador'
                        }
                    }
                },
                objectives_cards: {
                    name: 'Objetivos',
                    inputs: {
                        input_name: {
                            on_edit_label: 'Nombre del objetivo',
                            to_show_label: 'Objetivo',
                        },
                        input_format_type: {
                            on_edit_label: 'Tipo de formato',
                            optionA: 'Seleccionar un formato',
                            optionB: 'PDF',
                            optionC: 'Word',
                            optionD: 'Excel',
                            optionE: 'PowerPoint',
                            optionF: 'Otro',
                        },
                        input_type: {
                            on_edit_label: 'Tipo',
                            to_show_label: 'Tipo',
                            optionA: 'Seleccionar un objetivo',
                            optionB: 'Objetivo',
                            optionC: 'Meta',
                            optionD: 'Entregable'
                        },
                        input_number: {
                            on_edit_label: 'Duración',
                            to_show_label: ''
                        },
                        input_description: {
                            on_edit_label: 'Descripción',
                            to_show_label: '',
                        },
                        input_route: {
                            on_edit_label: 'URL',
                            to_show_label: '',
                        },
                    },
                    no_objectives: 'No hay objetivos'
                },
                resources_cards: {
                    name: 'Recursos',
                    inputs: {
                        input_name: {
                            on_edit_label: 'Nombre del recurso',
                            to_show_label: 'Recurso',
                        },
                        input_type: {
                            on_edit_label: 'Tipo',
                            to_show_label: 'Tipo',
                            optionA: 'Módulo',
                            optionB: 'Recurso externo (Imagen, Video, Instructivo, etc.)',
                        },
                        input_url_external_resource: {
                            on_edit_label: 'URL del recurso externo',
                            to_show_label: 'Recurso externo',
                        },
                        input_router: {
                            on_edit_label: 'Módulo',
                            to_show_label: 'Módulo',
                            optionA: 'Seleccionar Recurso'
                        },
                        input_description: {
                            on_edit_label: 'Descripción',
                            to_show_label: ''
                        }
                    },
                    no_resources: 'No hay recursos',
                    resource_creation_alert_message: 'Recurso añadido.',
                    resource_update_alert_message: 'Recurso actualizado.',
                    resource_delete_alert_message: 'Recurso eliminado.'
                },
                success_creation_alert_message: 'Actividad añadida exitosamente.',
                success_update_alert_message: 'Actividad actualizada exitosamente',
                success_delete_alert_message: 'Actividad eliminada exitosamente',
                error_creation_alert_message: 'Hubo un problema al crear la actividad.',
                error_resources_alert_message: 'No se puede añadir un tipo de recurso módulo sin un módulo, o seleccionar un tipo de recurso externo sin una dirección externa.',
                success_error_alert_message: 'Faltan datos por adicionar'
            },
            advance: {
                title_follow_up: 'Ver seguimientos de la actividad',
                follow_up: 'Ver seguimiento',
                title_register: 'Registrar avance de la actividad',
                register: 'Registrar Avance',
                save: 'Guardar Avance',
                add: 'Agregar',
                cancel: 'Cancelar',
                select_standard: 'Seleccionar un estándar',
                delete: 'Eliminar',
                process_not_equal: 'Para ver el seguimiento asegúrese estar dentro del proyecto: %{field}',
                status: {
                    text: 'Estado',
                    option_a: 'En inicio',
                    option_b: 'En proceso',
                    option_c: 'Terminada',
                    option_d: 'Cancelada',
                    option_e: 'Aplazada',
                    option_f: 'Atrasada'
                },
                follow_up_date: 'Fecha',
                expected_advance: 'Avance esperado',
                reported_advance: 'Avance reportado',
                milestone: 'Seguimiento semestral',
                milestone_expected: 'Porcentaje esperado de la meta',
                milestone_date: 'Fecha de entrega',
                detail: 'Detalle',
                support_type: {
                    text: 'Tipo de soporte',
                    option_a: 'Porcentaje',
                    option_b: 'Dinero en pesos',
                    option_c: 'Número entero',
                    option_d: 'Número con decimales',
                    option_e: 'Documentos nuevos',
                    option_f: 'Enlace/Url',
                    option_g: 'Sin soporte',
                    option_h: 'Repositorio de documentos',
                },
                support: 'Soporte',
                create_user: 'Cargado',
                supports: 'Soportes',
                decimals: {
                    text: 'Decimales',
                    option_a: 'Un Decimal',
                    option_b: 'Dos Decimales',
                    option_c: 'Tres Decimales',
                    option_0: '0',
                    option_1: '1',
                    option_2: '2',
                    option_3: '3'
                },
                util: {
                    detail_placeholder: 'Describa el avance logrado',
                    select_placeholder: 'Seleccione una opción',
                    accept_toast: 'Avance guardado en la actividad: %{field}',
                    milestone_not_set: 'Sin definir',
                },
            },
            edit: {
                title: 'Editar Actividad'
            }
        },
        timeline: {
            configuration: {
                title: 'Configuración de cronograma',
                subtitle: 'Configuración de las actividades del cronograma. En esta sección puedes crear las actividades que se requieran para el cronograma.<br>Una etapa es un conjunto de actividades relacionadas que se realizan en un tipo de proyecto.<br/>Una actividad es una tarea específica que contribuye al avance de una etapa.<br/>Para ello, sigue estos pasos:<ul><li>Para crear una etapa, haz clic en el botón <strong>«Añadir etapa»</strong> y escribe el nombre y la descripción de la misma.<li>Para crear una actividad, primero selecciona la etapa a la cual va a pertenecer la actividad. Haz clic en el botón <strong>«Añadir actividad»</strong> y escribe el nombre, la descripción, los objetivos y los recursos.</li></ul>Recuerda que las actividades que fueron creadas por estándar serán generadas automáticamente para el cronograma del ciclo seleccionado y se sugerirá los rangos de fechas para la realización de las mismas.',
                valid: 'Validar',
                edit: 'Editar',
                delete: 'Eliminar',
                add: 'Añadir actividad',
                start_date: 'Fecha inicio',
                end_date: 'Fecha fin',
                settlement_date: 'Fecha radicación',
                activity: 'Actividad',
                activities: 'Actividades',
                stages: 'Etapas',
                stage: 'Etapa',
                stage_label: 'Nombre de la etapa',
                manager: 'Responsable',
                action: 'Acción',
                cycle: 'Ciclo',
                process: 'Proyecto seleccionado',
                other_cycle: 'Seleccionar otro ciclo',
                save_stage: 'Guardar etapa',
                required: 'Actividad obligatoria',
                yes: 'Si',
                cancel: 'Cancelar',
                delete_valid: 'Eliminar la actividad: ',
                delete_confirmation_modal: 'Eliminar actividad',
                delete_stage_confirmation_modal: 'Eliminar etapa',
                delete_stage_confirmation_label: '¿Desea eliminar la etapa: <strong>%{stage}</strong>?',
                edit_stage: 'Editar etapa',
                remove_stage: 'Borrar etapa',
                confirm: 'Confirmar',
                save: 'Aceptar',
                description: 'Descripción',
                description_label: 'Descripción de la etapa',
                add_stage: 'Añadir etapa',
                add_activity: 'Añadir actividad',
                add_activity_button: 'Añadir actividad',
                created: 'La etapa y  sus actividades fueron creados satisfactoriamente, continue con la configuración.',
                continue: 'Continuar',
                end_cycle: 'La etapa y  sus actividades fueron creados satisfactoriamente y todas las etapas de este ciclo fueron configuradas, continue con la configuración.'
            },
            alert: {
                remove_stage_alert: 'Por seguridad, debe borrar cada actividad antes de borrar la etapa',
                delete_activity: 'Actividad eliminada.',
                sucess_delete_stage_message: 'Etapa eliminada',
                error_delete_activity: 'Error al tratar de eliminar la actividad.'
            },
            configuration_standard: {
                title: 'Configuración de plantilla del cronograma',
                subtitle: 'En esta sección de configuración de la plantilla de un cronograma, puedes crear etapas y actividades para organizar tu proyecto.<br/>Una etapa es un conjunto de actividades relacionadas que se realizan en un tipo de proyecto.<br/>Una actividad es una tarea específica que contribuye al avance de una etapa.<br/>Para ello, sigue estos pasos:<ul><li>Para crear una etapa, haz clic en el botón <strong>«Añadir etapa»</strong> y escribe el nombre y la descripción de la misma.<li>Para crear una actividad, primero selecciona la etapa a la cual va a pertenecer la actividad. Haz clic en el botón <strong>«Añadir actividad»</strong> y escribe el nombre, la descripción, los objetivos y los recursos.</li></ul>Puedes crear tantas etapas y actividades como necesites para definir la plantilla de tu proyecto.<br/>Las fechas se designarán cuando crees un proyecto a partir de esta plantilla.',
                no_process: 'La plantilla no tiene ningún proceso base asociado. Por favor, comuníquese con el administrador para solucionar el problema.'
            }
        },
        timeline_dashboard: {
            title: 'Dashboard linea del tiempo',
            subtitle: 'Aquí podrá ver la línea del tiempo y el avance de sus proyectos'
        },
        login: {
            username: 'Usuario',
            email: 'Correo',
            password: 'Contraseña',
            submit: 'Ingresar',
            forgot_password: '¿Has olvidado la contraseña?',
            rebember: 'Recuérdame',
            title: 'Fortaleciendo la calidad educativa',
            subtitle: 'Sistema de evaluación'
        },
        user_profile: {
            name_input: "Nombre",
            lastname_input: "Apellidos",
            phone_input: "Teléfono",
            email_input: "Correo Electrónico",
            success_edit_profile_alert_message: "El perfil ha sido actualizado exitosamente.",
            send_email: {
                check_input: "Habilitar envío de correos",
                checked_message: "El usuario se encuentra habilitado para el envío de correos.",
                unchecked_message: "El usuario no se encuentra habilitado para el envío de correos."
            }
        },
        error: {
            '401_title': 'Datos incorrectos',
            '401_message': 'Correo o contraseña no son correctos.',
            '500_title': 'Error del sistema',
            '500_message': 'Intente de nuevo o contacte un administrador.'
        },

        calendar_timeline_view: {
            alternative_title: 'Mi calendario',
            title: 'Cronograma',
            subtitle: 'Cronograma de actividades vistas en calendario/diagrama de Gantt',
            subscription: {
                button: 'Suscribir a calendario',
                modal_title: 'Suscripción de calendario',
                description: 'Suscríbete a tu calendario de actividades PREST en tu aplicación de calendario favorita (Google Calendar, Outlook, Apple Calendar, etc.)',
                url_label: 'URL de suscripción',
                webcal_url_label: 'URL Webcal (Suscripción con un clic)',
                webcal_url_help: 'Haz clic en esta URL en la mayoría de aplicaciones de calendario para suscribirte automáticamente',
                http_url_label: 'URL HTTP (Pegado manual)',
                http_url_help: 'Usa esta URL si webcal:// no funciona o para descarga manual',
                copy_button: 'Copiar URL',
                copied_message: 'URL copiada al portapapeles',
                instructions_title: 'Instrucciones',
                google_calendar: {
                    title: 'Google Calendar',
                    step1: '1. Haz clic en el botón "+" junto a "Otros calendarios"',
                    step2: '2. Selecciona "Desde URL"',
                    step3: '3. Pega la URL de suscripción',
                    step4: '4. ¡Listo! Se sincronizará automáticamente'
                },
                outlook: {
                    title: 'Outlook / Office 365',
                    step1: '1. Haz clic en "Agregar calendario" → "Suscribirse desde web"',
                    step2: '2. Pega la URL de suscripción',
                    step3: '3. ¡Listo!'
                },
                apple_calendar: {
                    title: 'Apple Calendar (Mac/iPhone)',
                    step1: '1. Archivo → Nueva suscripción a calendario (o Configuración → Cuentas en iPhone)',
                    step2: '2. Pega la URL de suscripción',
                    step3: '3. ¡Listo!'
                },
                note_title: 'Nota importante',
                note_text: 'Tu calendario se actualizará automáticamente cada vez que cambien tus actividades. No necesitas volver a suscribirte.',
                security_note: 'Esta URL es personal y privada. No la compartas con nadie.',
                generate_button: 'Generar nueva suscripción',
                regenerate_button: 'Regenerar suscripción',
                regenerate_confirm: '¿Estás seguro de que quieres regenerar tu suscripción? La URL actual dejará de funcionar y necesitarás actualizarla en tus aplicaciones de calendario.',
                revoke_button: 'Revocar suscripción',
                close_button: 'Cerrar',
                no_subscription_message: 'Crea una suscripción para sincronizar tus actividades automáticamente.',
                error_generating: 'Error al generar la suscripción. Intenta de nuevo.',
                error_checking: 'Error al verificar el estado de la suscripción. Intenta de nuevo.',
                success_generating: 'Suscripción generada exitosamente',
                success_revoking: 'Suscripción revocada exitosamente',
                loading: 'Cargando...'
            }
        },
        filter: {
            apply_filter: 'Aplicar filtros',
            tooltip_list: 'Vista de lista',
            tooltip_mosaic: 'Vista mosaico',
            filters: 'Filtros',
            filter_action: 'Filtrar',
            select_one_option: 'Seleccione una opción'
        },

        collaborator: {
            alternative_title: 'Colaboradores ',
            title: 'Adicionar colaborador',
            subtitle: 'Buscar o crear colaborador para el proyecto',
            user_filter_card_title: 'Buscar colaborador',
            info_card_title: 'Información del colaborador',
            role_card_title: 'Rol del colaborador',
            not_found: 'No existe el colaborador',
            no_in_contract: 'Este colaborador no está en este contrato, ¿quieres invitarlo?',
            participant_collaborator_card_title: 'Buscar colaborador por participante',

            user_filter: {
                label: 'Buscar colaborador por número de identificación o correo electrónico',
                placeholder: 'Número de identificación o correo electrónico',
                not_valid_filter: 'Solo se puede filtrar por DNI o correo electrónico válido',
                search_button: 'Buscar',
                search_participant_button: 'Buscar participante',
                load_participant_button: 'Consultar participantes',
                clear_participant_button: 'Volver a colaboradores por contrato',
                not_allowed_participant_filter: "No existe el participante dentro de la lista de participantes. Si desea buscar un perfil que no se encuentre en la lista actual, por favor realice la búsqueda en colaboradores por contrato."
            },

            dni: {
                label: 'Número de documento',
                placeholder: 'Ingrese el número de documento'
            },

            name: {
                label: 'Nombres',
                placeholder: 'Ingrese su nombre'
            },

            last_name: {
                label: 'Apellidos',
                placeholder: 'Ingrese su apellido'
            },

            email: {
                label: 'Correo electrónico',
                placeholder: 'Ingrese su correo electrónico',
                not_valid_email: 'El campo %{field} debe ser un correo electrónico válido'
            },

            phone: {
                label: 'Teléfono',
                placeholder: 'Ingrese su número de teléfono'
            },

            charge: {
                label: 'Cargo',
                placeholder: 'Ingrese su cargo'
            },

            role: 'Rol',

            button_action: {
                register: 'Registrar',
                invite: 'Invitar al contrato',
                modify: 'Modificar',
                add: 'Agregar',
                delete: 'Eliminar',
                massive_assign: 'Asignación masiva',
            },
            massive: {
                method: 'Nivel de asignación',
                met_one: 'Ciclos',
                met_two: 'Etapas',
                cycle: 'Ciclo',
                collaborator: 'Colaborador',
                assign: 'Asignar',
                assigned: 'Asignación masiva completa',
                not_selected: 'Selecciona el colaborador, su rol y al menos una actividad',
                no_cycle: 'Seleccione un ciclo, para hacer la asignación en sus etapas.'
            },
            user_registration: {
                not_found_alert: 'No se ha encontrado ningún perfil con el correo electrónico o DNI dado. Puede registrar un nuevo usuario para ese correo o DNI, o puede registrar un usuario desde la lista de participantes del SNIES. ¿Desea ver la lista de usuarios disponibles de la lista de participantes?',
                success_message: 'El perfil ha sido creado. Se ha enviado un correo al usuario %{username} para su confirmación y activación',
                already_exists_message: 'Ya existe un perfil con este correo electrónico / DNI.',
                error_message: 'Error mientras se creaba el usuario: ',
                participant_collaborator_confirmation_modal: {
                    ok_button: "Aceptar",
                    cancel_button: "Cancelar"
                }
            },
            user_modification: {
                success_message: 'Se ha actualizado el perfil del usuario'
            },
            user_collaborator_invitation: {
                success_message: 'El usuario ha sido añadido al contrato como colaborador'
            },
            contract_state: {
                activate: 'Activar',
                deactivate: 'Inactivar',
                title: 'Afiliación del colaborador al contrato',
                end_date_label: 'Fecha de finalización de afiliación',
                modal_title: ' afiliación',
                modal_activation_body: '¿Desea habilitar la afiliación del colaborador?',
                modal_deactivation_body: '¿Desea inhabilitar la afiliación del colaborador?',
                ok_button: 'Aceptar',
                cancel_button: 'Cancelar',
                update_end_date_button: 'Actualizar fecha',
                activate_success_message: 'Se ha actualizado la afiliación del usuario',
                deactivate_success_message: 'Se ha inhabilitado la afiliación del usuario'
            }
        },
        muniment_history_process: {
            title_h: 'Histórico de Documentos finales del proceso',
            title: 'Histórico de Documentos finales del proceso',
            subtitle: 'Aquí encontrara la carpeta de documentos y soportes finales los cuales sustentan los procesos de: "%{field}".',
        },
        muniment: {
            title_h: 'Documentos y soportes del proyecto',
            title: 'Documentos y soportes del proyecto',
            subtitle: 'Aquí encontrara la carpeta de documentos y soportes los cuales sustentan la creación y debido proceso del proyecto.',

            button: {
                new: 'Nuevo',
                search: 'Repositorio',
                link: 'Enlace',
                file: 'Seleccionar archivo',
                addFile: 'Agregar versión',
                return: 'Volver',
            },

            origin: {
                type: 'Relación del Documento',
                support: 'Evidencias Generales',
                link: 'Link',
                evidence: 'Evidencia',
                annex: 'Anexo',
                repository: 'Repositorio',
            },

            upload_modal: {
                title: 'Cargar documentos de soporte para el proyecto',
                input_file: {
                    placeholder: 'Elige un archivo o arrástralo y suéltalo aquí...',
                    drop_placeholder: 'Arrástra y suelta el archivo aquí...',
                    browser: 'Buscar',
                },

                label_placeholder: 'Ingrese el nombre del documento...',
                description_placeholder: 'Ingrese una descripción o nota...',
                source_placeholder: 'Ingrese la fuente del documento...',
                source_help: 'La fuente donde se obtiene u origina la información. Ejemplo: Bienestar, MEN, Etc.',
                template_header_question: '¿Es este documento una "Plantilla para encabezado"?',
                template_header_help: 'Marque esta opción si este documento sirve como plantilla de encabezado para iteraciones.',
                save_button: 'Guardar documentos'
            },

            existing_modal: {
                title: 'Asociar soportes existentes'
            },

            data: {
                action: 'Acción',
                type: 'Tipo',
                no_type: 'Falta el Tipo',
                label: 'Nombre',
                no_label: 'Falta el Nombre',
                description: 'Descripción y notas',
                no_description: 'Falta la Descripción y notas',
                source: 'Fuente',
                no_source: 'Falta la Fuente',
                version: 'Versión',
                date: 'Fecha',
                start_date: 'Fecha inicial',
                end_date: 'Fecha final',
                file: 'Archivo',
                creation_user: 'Usuario',
                change: 'Motivo del cambio',

                util: {
                    change_placeholder: 'Motivo del cambio del soporte',
                    row_iterator: ' de la fila ',
                    evidence_delete: 'La evidencia solo se puede eliminar desde el módulo de definición de evidencias.'
                },

                type_options: {
                    empty: 'Seleccione una opción...',
                    policy: 'Política (Norma)',
                    plan: 'Plan',
                    research: 'Estudio',
                    report: 'Informe',
                    process: 'Proyecto / Procedimiento',
                    other: 'Otro',
                    statistic: 'Estadístico',
                    review: 'Análisis',
                    act: 'Acta',
                    agreement: 'Acuerdo',
                    contract: 'Convenio',
                    resolution: 'Resolución',
                    annex: 'Anexo',
                    gage: 'Indicadores',
                    documental: 'Documental',
                    appreciate: 'Apreciación',
                    self_assessment_report: 'Informe de autoevaluación',
                    self_assessment_matrix: 'Matriz de autoevaluación',
                    improvement_plan: 'Plan de mejoramiento',
                    administrative_act: 'Acto administrativo',
                    master_document: 'Documento maestro',
                    improvement_plan_tracking: 'Seguimiento al plan de mejoramiento'
                }
            },

            delete_confirm_message: '¿Está seguro de borrar el registro?',

            link_modal: {
                title: 'Cargar documentos de soporte para el proyecto a través de enlaces',
                text_area_placeholder: 'Ingrese los enlaces separados por coma (,)...',
                alert_duplicate: 'Los links duplicados serán ignorados.',
                alert_info: 'Por favor, digite el nombre y la descripción después de agregar todos los enlaces.',
            },

            not_valid_alert: {
                before: 'Los siguientes enlaces: ',
                after: '; no son válidos. Por favor revisarlos antes de continuar o no serán tenidos en cuenta en el registro.'
            },

            version: {
                link: 'Enlace',
                link_placeholder: 'Ingrese un nuevo Enlace',
                validation: {
                    link: 'El campo %{field} no es valido, este debería tener al inicio https://',
                }
            },
            quantity: {
                singular: 'archivo más',
                plural: 'archivos más'
            },
            error: {
                '409_message': 'El nombre del archivo es demasiado largo. Por favor, elija un nombre más corto y vuelva a intentarlo.'
            }
        },
        matrix: {
            title: 'Configuración de matriz',
            alternative_title: 'Configuración SNIES',
            subtitle: 'Agregue y valide cada nivel de la matriz',
            add: 'Agregar',
            edit: 'Editar',
            delete: 'Borrar',
            save: 'Guardar',
            save_matrix: 'Guardar Matriz',
            cancel: 'Cancelar',
            code: 'Código',
            matrixCode: 'Código de la Matriz',
            name: 'Nombre',
            required: 'Obligatorio',
            detail: 'Detalle',
            select_other: 'Cambiar de ',
            change: 'Cambiar',
            created: 'Elementos de Matriz creados.',
            end: 'Todos los elementos de la matriz fueron creados.',
            last_weigh: 'Recuerde que al momento de guardar la estrategia no podrá editar los parámetros ya establecidos. ¿Está seguro de guardar la matriz?.',
            evidence_weigh: '¿Está seguro de guardar los grupos establecidos para la definición y cargue de evidencias?.',
            valid_save_level: 'La matriz en consulta aún no se ha guardado, para  crear nuevos elementos dentro de esta, asegúrese de validar los elementos base generados por la plantilla, guardar y posteriormente crear lo elementos extra que desee.',
            already_valid: '¿Ya validó la matriz consultada?',
            next: 'Siguiente',
            prev: 'Anterior',
            dashboard: {
                title: 'Dashboard de seguimiento para la matriz',
                subtitle: '',
                no_matrix: 'El ciclo actual no cuenta con una matriz de evidencia configurada',
                config_matrix: 'Aquí puede configurarla',
                advance: 'Avance',

                matrix: 'Matriz de evidencia configurada para este ciclo',
                weighing_initial: 'Ponderación inicial',
                weighing_final: 'Ponderación final',
                evidence: 'Definición de evidencia',
                evidence_charge: 'Carga de evidencia',
                evidence_valoration: 'Valoración',
                no_weighing_initial: 'Sin ponderación inicial',
                no_weighing_final: 'Sin ponderación final',
                no_evidence: 'Sin definición de evidencia',
                no_evidence_charge: 'Sin carga de evidencia',
                no_evidence_valoration: 'Sin valoración'
            },
            alert: {
                no_delete: 'Para eliminar el elemento "%{field}", debe eliminar primero los elementos dependientes que están vinculados a él.'
            },
            custom: {
                title: 'Configuración de plantilla de la matriz',
                subtitle: 'Aquí puedes personalizar la plantilla de la matriz de autoevaluación añadiendo, editando o eliminando los elementos que quieras. Para ello, sigue estos pasos:<br/><ul><li>Para añadir un elemento, haz clic en el botón <strong>«Agregar ...»</strong> y escribe el codigó, nombre y la descripción de la misma.</li><li>Para editar un elemento, haz clic en el botón <strong>«<icon class="fa-solid fa-pencil" ></icon>»</strong> que aparece al lado del elemento que quieres modificar.</li><li>Para eliminar un elemento, haz clic en el botón <strong>«Eliminar»</strong> que aparece al lado del elemento que quieres quitar.</li></ul>Puedes crear tantos elementos como necesites para definir la plantilla de tu matriz.',
            }
        },
        exogenous: {
            title_h: 'Fuentes Exógenas',
            title: 'Fuentes Exógenas',
            subtitle: 'Estadísticas por fuentes externas reguladoras',
            total: 'Cantidad de registros: ',
            show_all: 'Mostrar todos los exógenos',
            create: {
                title: 'Agregar fuente'
            },
            fields: {
                source: 'Fuente',
                type: 'Tipo',
                label: 'Nombre',
                detail: 'Detalle',
                date: 'Fecha',
                file: 'Archivo',
            },
            options: {
                saces: 'SACES',
                snies: 'SNIES-PERTINENCIA',
                spadies: 'SPADIES',
                scienti: 'SCIENTI',
                ole: 'OLE',
            },
            options_snies: {
                students_admitted: 'ESTUDIANTES ADMITIDOS',
                students_enrolled: 'ESTUDIANTES INSCRITOS',
                students_matriculate: 'ESTUDIANTES MATRICULADOS',
                teachers: 'DOCENTES',
                administrative: 'ADMINISTRATIVOS',
            },
            util: {
                select_placeholder: 'Seleccione una opción',
                label_placeholder: 'Nombre a visualizar',
                detail_placeholder: 'Detalle de la fuente exógena'
            },
            button: {
                new: 'Nuevo',
                suggest: 'Agregar Sugeridos',
                search: 'Repositorio',
                file: 'Seleccionar archivo',
                template: 'Descargar plantilla',
                addFile: 'Agregar Soporte',
                link: 'Enlace',
                continue: 'Culminar Tarea',
                add: 'Agregar',
                back: 'Regresar',
            },
            graph: {
                title_h: 'Gráfico de Fuentes Exógenas',
                number_records: 'Cantidad de registros: ',
                snies_adm: 'Cantidad de admitidos: ',
                back: 'Volver',
            }
        },
        repository: {
            title_h: 'Repositorio de Documentos',
            description: 'Repositorios de documentos',
            document: 'Documentos',
            folder: 'Carpetas',
            evidence: 'Documentos de Evidencias',
            add_folder: 'Nueva carpeta',
            add_document: 'Nuevo documento',
            name_folder: 'Nombre de la carpeta',
            name_document: 'Nombre del documento',
            folder_empty: 'No hay carpetas en el repositorio',
            annex: 'Anexos',
            load_document: 'Cargar de Documento',
            format_alert: '¡Alerta! Por favor, Formatos admitidos de documentos son PDF, WORD, EXCEL o POWER POINT',
            load_file: 'Cargar archivo',
            new_user: 'Invitación',
            email: 'Correo electrónico',
            load_invitation: 'Guardar Invitaciones',
            add_invitation: 'Invitar',
            email_none: 'Por favor, introduce un correo electrónico.',
            email_error: 'El formato del correo electrónico no es válido.',
            email_repeat: 'Este correo ya ha sido agregado a la lista.',
            email_add: 'Se realizo la invitacion.'
        },
        weighing: {
            title: 'Ponderación',
            subtitle: 'Bienvenidos al proceso de ponderación, un componente esencial del Sistema de Aseguramiento de la Calidad, donde cada uno de ustedes, como valiosos miembros de la comunidad académica -estudiantes, profesores, egresados, directivos, administrativos y representantes del sector productivo-, jugará un papel crucial. Les invitamos a determinar el nivel de importancia de los Factores y Características de calidad, asignando un peso específico a cada uno, en una escala de 10 a 100, donde 10 denota menor importancia y 100 la máxima. Se requiere adicionalmente que justifiquen las razones detrás de cada ponderación asignada. En los casos que el nivel de importancia que asignen los integrantes de los diferentes grupos de ponderación, presente una variación superior al 20%, será necesario analizar y llegar a consensos entre los participantes. Su colaboración es vital en este ejercicio integral de evaluación y mejora continua. ¡Agradecemos su compromiso y colaboración!',
            find: 'Buscar',
            valid_met_three: 'Al seleccionar este nivel de la matriz deberá ponderar %{count} elementos. ¿Está seguro de seleccionar este nivel de la matriz?',
            valid_met_four: 'Al seleccionar esta opción de promedio porcentual, el sistema realiza el calculo con los valores dados de los participantes de cada grupo y el resultado se asigna al elemento sujeto a la actividad en ponderación final.',
            valid_met_delete_weighing: 'El cambio de nivel de la matriz afectará los grupos asignados para la Ponderación de evidencias. Estos grupos deben ser ajustados para adaptarse al nuevo nivel de matriz seleccionado. ¿Confirmas esta acción?',
            met_one: 'Ponderación inicial.',
            met_two: 'Ponderación por niveles de importancia.',
            met_three: 'Ponderación final.',
            met_consult: 'Consultar ponderación',
            no_weigh: 'Sin Ponderar',
            weighing: 'Ponderar',
            consult: 'Consultar',
            assign_w_one: 'Asigne la ponderación inicial del %{element}',
            assign_w_two: 'Asigne un nivel de importancia entre %{minimum} y %{maximum} que determine cuán importante es el %{element} para el proyecto de autoevaluación',
            assign_w_three: 'Asigne la ponderación final del %{element}',
            w_one: 'Ponderación inicial dada por el responsable: ',
            w_two: 'Calificación promedio dada por el grupo: ',
            w_notes: 'Justificar la ponderación o nivel de importancia que se está asignando al %{element}',
            w_value: 'Nivel de importancia',
            w_decimal: 'Valor decimales',
            w_see_notes: 'Justificar la ponderación o nivel de importancia que se está asignando al %{element} dadas por el grupo',
            available_percent: 'Porcentaje disponible ',
            valid_weigh: 'Asigne un nivel de importancia a la ponderación.',
            save_weigh: 'La ponderación del %{element} de la matriz guardado correctamente.',
            end_weigh: 'La ponderación de esta matriz ha terminado.',
            last_weigh: 'Este es el último %{element} de la matriz a ponderar, al guardarlo se dará la ponderación como cerrada y no podrá editar. ¿Está seguro de terminar? Al responder “NO” puede regresar a verificar los elementos sin perder los cambios y cuando desee culminar la tarea pondere nuevamente este elemento, en caso de que ya realizará la validación responda “SI” para enviar los resultados finales.',
            save: 'Guardar',
            save_all: 'Generar la ponderación de manera automática',
            save_all_group: 'Generar la ponderación con base en la ponderación por niveles de importancia',
            saved_all: 'Generada la ponderación de manera automática',
            error_saved_all: 'Error al generar la ponderación de manera automática, intenta nuevamente.',
            confirm_save_all: 'Está seguro de generar la ponderación de manera automática, al guardarlo se dará la ponderación como cerrada y no podrá editar.',
            accept: 'Aceptar',
            yes: 'Si',
            no: 'No',
            ok: 'Entendido',
            no_matrix: 'No hay una matriz configurada para este ciclo del proyecto.',
            ext_weighing_end: 'Gracias, su ponderación asignada ya ha terminado.',
            equal: ' que equivale a ',
            without_value: 'Verifique la ponderación de los otros elementos de la matriz, ya que se completo el 100%',
            config: {
                title: 'Estrategia de ponderación',
                edit_tab: 'Editar estrategia',
                copy_tab: 'Heredar ponderación',
                group_title: 'Asignación de grupo',
                level: 'Nivel de matriz',
                method: 'Método de asignación',
                met_one: '1. Ponderación inicial asignada por el responsable de la Dirección Técnica de Planeación y Calidad.',
                met_two: '2. Ponderación asignada por el equipo de autoevaluación según la importancia de los elementos.',
                met_three: '3. Ponderación final asignada por el responsable de la Dirección del Programa Académico o de la Dirección Técnica de Planeación y Calidad.',
                met_four: '2.1. Gestionar ponderación final de acuerdo al promedio porcentual del equipo de autoevaluación',
                scale_list: 'Escala de ponderación',
                scale_weighing: 'Número de decimales',
                groups: 'Grupos asignados',
                assign_group: 'Asignar grupo',
                no_groups: 'Debe asignar al menos a un grupo la ponderación',
                fail_method: 'Error al crear el método de ponderación, intente nuevamente.',
                success_method: 'El método de ponderación fue creado.',
                term: 'Plazo',
                term_start: 'Inicio',
                term_end: 'Fin',
                group_name: 'Grupo',
                groups_list: 'Seleccione un grupo',
                objective: 'Objetivos',
                add_all: 'Seleccionar todos',
                edit_config: 'Editar estrategia de ponderación',
                see_advance: 'Ver avances de ponderación',
                advance_title: 'Avance de ponderación',
                weighing_one_advance_card_title: 'Ponderación Inicial',
                weighing_two_advance_card_title: 'Ponderación por grupo',
                weighing_three_advance_card_title: 'Ponderación Final',
                participants: 'Participantes',
                participant: 'Participante',
                repeat: 'Participante adicionado en otro grupo',
                advance: 'Avance',
                assign: 'Asignar',
                advance_total: 'Avance total',
                file: 'Cargar lista de correos de participantes',
                add_participants: 'Agregar participante',
                registration_participants: 'Registro de participantes',
                registered_participants: 'Participantes registrados',
                remove_participants: 'Remover participantes',
                not_valid_format: 'El formato de archivo es invalido, verifique que sea solo una columna con los correos y de titulo "Correos".',
                invalid_file_type: 'El archivo seleccionado no es un archivo XLSX válido.',
                file_read_error: 'Error de lectura de archivo.',
                no_file_selected: 'No se ha seleccionado ningún archivo. Por favor, selecciona un archivo.',
                missing_email: 'Falta el campo de correo electrónico en una o más filas.',
                no_group_select: 'Seleccione un grupo a asignar.',
                no_end_date: 'Seleccione una fecha final para el plazo de ponderación',
                no_participants: 'Tiene que haber mínimo un participante',
                no_targets: 'Tiene que estar seleccionado objetivo a ponderar',
                scale_list_option: {
                    scale_1: '0 a 100',
                    description_1: 'La escala se maneja de 0 a 100 con incremento de 10 en 10',
                    scale_2: '1 a 10',
                    description_2: 'La escala se maneja de 1 a 10 con incremento de 1 en 1',
                    scale_3: '0 a 10',
                    description_3: 'La escala se maneja de 0 a 10 con incremento de 1 en 1',
                    scale_4: '0 a 5',
                    description_4: 'La escala se maneja de 0 a 5 con incremento de 1 en 1'
                },
                copy_weighing: {
                    select_label: 'Heredar ponderación desde ciclo / matriz',
                    copy_button: 'Heredar ponderación',
                    origin_level_label: 'Nivel origen',
                    destiny_level_label: 'Nivel destino',
                    final_weight: 'Peso heredado',
                    confirmation_description: 'El ciclo actual recibirá los porcentajes de la ponderación final del ciclo seleccionado hasta el nivel que haya sido realizada, y será guardado como el ejercicio completado de ponderación final el cual no podrá ser editado nuevamente.',
                    confirmation_label: '¿Desea copiar la ponderación?'
                },
                weighing_two_advance_table: {
                    matrix_level: 'Nivel Matriz',
                    average: 'Peso consolidado',
                    std_dev: 'D. Estándar',
                    variance: 'Varianza',
                    var_coef: 'Coef. de Var.',
                    no_weigh: 'Sin Ponderar',
                    total_invitations: 'N. Participantes'
                }
            }
        },
        evidence: {
            support_modal: 'Carga de evidencia desde soportes',
            charge_by_support: 'Carga de evidencia desde soportes',
            matrix: 'Elementos de la matriz asignados',
            append_annex: 'Agregar anexo',
            yes: 'Si',
            no: 'No',
            valid_met_three_evidence: 'Al seleccionar este nivel de la matriz deberá cargar evidencia &count elementos. ¿Está seguro de seleccionar este nivel de la matriz?',
            valid_met_three_valoration: 'Al seleccionar este nivel de la matriz deberá valorar &count elementos. ¿Está seguro de seleccionar este nivel de la matriz?',
            valid_met_delete_evidence: 'El cambio de nivel de la matriz afectará los grupos asignados para la Definición y los Cargue de evidencias. Estos grupos deben ser ajustados para adaptarse al nuevo nivel de matriz seleccionado. ¿Deseas continuar?',
            title: 'Matriz de evidencias',
            title_evidence: 'Definición y cargue de evidencia',
            title_valoration: 'Valoración',
            valid_met_delete_valoration: 'El cambio de nivel de la matriz afectará los grupos asignados para la Valoración de evidencias. Estos grupos deben ser ajustados para adaptarse al nuevo nivel de matriz seleccionado. ¿Deseas continuar?',
            subtitle: '',
            no_matrix: 'No hay una matriz configurada para este ciclo del proyecto.',
            no_matrix_valoration: 'No hay una matriz configurada para este ciclo del proyecto o no ha configurado la carga de evidencias, verifique y vuelva cuando cumpla estos requisitos.',
            no_user_valoration: 'No hay una asignación para la valoración de evidencias.',
            no_open_valoration: 'La valoración a terminado en el tiempo asignado.',
            evidence: 'Evidencias',
            met_one: 'Definición de evidencia.',
            met_two: 'Cargue de evidencia',
            met_three: 'Valoración',
            met_four: 'Validar cargue de evidencia',
            met_consult: 'Consultar valoración',
            met_one_v: 'Definir la evidencia.',
            define_evidence: 'Evidencias definidas <span>%{size}</span>',
            define_evidence_count: 'Evidencias definidas <span>%{size} de %{total}</span>',
            met_two_v: 'Cargar la evidencia',
            charge_evidence: 'Evidencias cargadas <span>%{charge} de %{size}</span>',
            charge_validate: 'Evidencias verificadas <span>%{charge} de %{size}</span>',
            all_evidence: 'Todas las evidencias cargadas',
            met_four_v: 'Validar el cargue',
            met_three_v: 'Valorar la evidencia',
            valoration_v: 'Valorar desde %{can}',
            value_evidence: 'Evidencia valorada <span>%{charge} - %{size}</span>',
            count_evidence: 'Evidencias valoradas %{charge} de %{size}',
            no_evidence: 'Sin evidencia',
            no_evidence_define: 'Sin evidencias definidas',
            no_evidence_charge: 'Sin evidencias cargadas',
            no_evidence_check: 'Sin validar cargues',
            no_evidence_value: 'Sin evidencias valoradas',
            no_valoration: 'Sin valoración',
            no_value: 'Sin valoración',
            annex_document: 'Documentos anexados',
            valoration_next: 'No se puede realizar la valoración desde "%{matriz}". Solo se puede valorar desde %{can}.',
            met_consult_one: 'Consultar definición de evidencia.',
            met_consult_two: 'Consultar cargue de evidencia',
            consult: 'Ver evidencias',
            w_notes: 'Comentarios o recomendaciones / juicios de valor',
            w_validated: 'Comentario o recomendación para ajustes del soporte.',
            w_validated_message: 'Bitácora – Comentario número <span>%{size} registrado el %{date}</span>.',
            register_dof: 'Registro de contenido DOF',
            improvement_opportunity: 'Oportunidades de mejora',
            weakness: 'Debilidades',
            strength: 'Fortalezas',
            support_type: 'Tipo de evidencia',
            support_name: 'Filtro: nombre de la evidencia',
            support_new: 'Nuevo soporte',
            support_process: 'Soportes del Proyecto',
            support_all: 'Todas las evidencias',
            save_evidence: 'Evidencia guardada',
            save_evidence_support: 'Soporte cargado',
            save_success: 'Evidencia guardada exitosamente',
            upload_success: 'Evidencia cargada exitosamente',
            save: 'Guardar',
            saving: 'Guardando...',
            cancel: 'Cancelar',
            valid_approved: 'Soporte aprobado',
            valid_disapproved: 'Soporte desaprobado',
            valid_exit: 'Volver',
            see: 'Ver evidencia',
            no_support: 'Sin archivo',
            add: 'Crear evidencia',
            edit: 'Editar soporte',
            edit_support_button: 'Editar',
            delete_support_button: 'Eliminar',
            delete_support_label: 'Si elimina el soporte, la definición de la evidencia que haya realizado del mismo en cada nivel de la matriz también será eliminada. ¿Desea eliminar el soporte?',
            success_edit_message: 'Se ha actualizado el soporte exitosamente',
            success_delete_message: 'Se ha eliminado el soporte exitosamente',
            assign: 'Definir evidencia',
            my_supports: 'Evidencias de la matriz',
            my_supports_child: 'Evidencias de los siguientes nivel de la matriz',
            see_matrix: 'Ver detalle de la matriz',
            valid_evidence: 'Asigne al menos una evidencia',
            no_assign: 'No tiene definidas evidencias para este elemento de la matriz, antes de hacer el cargue, verifique la definición de las evidencias.',
            valid_charge: 'Cargue las evidencias',
            inherit_title: 'Evidencias de los elementos de abajo',
            inherit_question: 'Está guardando desde una característica o un factor. Esta lista reúne las evidencias de todos sus aspectos. ¿Quiere agregar todas a cada aspecto o solo las nuevas?',
            inherit_all: 'Agregar todas a cada aspecto',
            inherit_new_only: 'Solo las nuevas',
            valid_assessment: 'No se ha valorado',
            end_evidence: 'La valoración de esta matriz ha terminado.',
            last_evidence: 'Este es el ultimo elemento de la matriz al cual definir le evidencia, al guardarlo se dará la matriz como cerrada y no podrá editar. Está seguro de terminar',
            create_support: 'Crear soporte',
            charge_file: 'Cargar soporte',
            charge_new: 'Cargar nuevo archivo',
            charge_new_version: 'Cargar nueva versión de archivo',
            delete_muniment: 'Eliminar archivo',
            save_permanently: 'Guardar definitivamente',
            uploaded_by: 'Cargado por',
            support_date: 'Fecha',
            ext_evidence_end: 'Gracias, la carga de evidencia  ha terminado.',
            ext_valoration_end: 'Gracias, la valoración ha terminado.',
            assessment: 'Valoración',
            assessment_level: 'Valore el %{element} en una escala de 0 a 5',
            appreciate: 'Valorar',
            value_1_documental: 'No se cumple',
            value_2_documental: 'Se cumple insatisfactoriamente',
            value_3_documental: 'Se cumple aceptablemente',
            value_4_documental: 'Se cumple en alto grado',
            value_5_documental: 'Se cumple plenamente',
            value_1: 'No se cumple',
            value_2: 'Se cumple insatisfactoriamente',
            value_3: 'Se cumple aceptablemente',
            value_4: 'Se cumple en alto grado',
            value_5: 'Se cumple plenamente',
            value_insert: 'Ingrese un valor de 0 a 5',
            copy_evidence: {
                select_label: 'Heredar evidencias desde ciclo / matriz',
                copy_button: 'Heredar evidencias',
                origin_level_label: 'Nivel origen',
                destiny_level_label: 'Nivel destino',
                final_weight: 'Peso heredado',
                confirmation_description: 'El ciclo actual recibirá los porcentajes de la ponderación final del ciclo seleccionado hasta el nivel que haya sido realizada, y será guardado como el ejercicio completado de ponderación final el cual no podrá ser editado nuevamente.',
                confirmation_label: '¿Desea copiar la ponderación?',
                general_title: 'Herencia Generales',
                specific_title: 'Herencia Especificas',
                label_origin: 'Matriz Origen',
                label_destiny: 'Matriz Destino',
                code: 'Codigo',
                label: 'Nombre',
                matrix_evidence: 'Soporte',
                number_evidence: 'Número de Evidencias: ',
                evidence_origin: 'Evidencias Origen',
                evidence_destiny: 'Evidencias Destino',
                cancel: 'Cancelar',
                save: 'Heredar',
                success_evidence: 'Herencia de Evidencias realizada',
                error: 'Se genero un error al momento de realizar la herencia'
            },
            charge_type: {
                tab1: 'Archivo',
                tab2: 'Enlace',
            },
            config: {
                title_evidence: 'Estrategia de Definición y Carga de evidencias',
                title_valoration: 'Estrategia de valoración',
                group_title: 'Asignación de grupo',
                edit_tab: 'Editar estrategia',
                copy_tab: "Heredar definiciones",
                level: 'Nivel de matriz',
                value_charge: 'Validar cargues',
                message_value_charge: 'Asignar grupos para validar el cargue de evidencias.',
                rubrics: 'Rubricas por soporte',
                matrix_rubrics: 'Rubricas a utilizar',
                method: 'Método de definición',
                method_valoration: 'Método de valoración',
                met_one: '1. Definición de evidencias.',
                met_two: '2. Carga de evidencias.',
                met_three: '3. Valoración de evidencias',
                scale_evidence: 'Escala de valoración',
                groups_assign: 'Grupos asignados a la definición de evidencias',
                groups: 'Grupos asignados a carga de evidencias',
                group_charge: 'Grupos asignados a validar el cargue de evidencias',
                groups2: 'Grupos asignados a valoración',
                assign_group: 'Asignar grupo',
                no_groups: 'Debe asignar al menos a un grupo la estrategia de carga de evidencias',
                no_groups_valoration: 'Debe asignar al menos a un grupo la estrategia de valoración',
                fail_method: 'Error al crear la estrategia de carga de evidencias, intente nuevamente.',
                fail_method_valoration: 'Error al crear la estrategia de valoración, intente nuevamente.',
                success_method: 'La Estrategia de carga de evidencias fue creado.',
                success_method_valoration: 'La Estrategia de carga de valoración fue creado.',
                term: 'Plazo',
                term_start: 'Inicio',
                term_end: 'Fin',
                group_name: 'Grupo',
                groups_list: 'Seleccione un grupo',
                objective: 'Objetivos',
                participants: 'Participantes',
                participant: 'Participante',
                registration_participants: 'Registro de participantes',
                registered_participants: 'Participantes registrados',
                remove_participants: 'Remover participantes',
                advance: 'Avance',
                assign: 'Asignar',
                advance_total: 'Avance total',
                file: 'Cargar lista de correos de participantes',
                add_participants: 'Agregar participante',
                not_valid_format: 'El formato de archivo es invalido, verifique que sea solo una columna con los correos y de titulo "Correos".',
                no_group_select: 'Seleccione un grupo a asignar.',
                no_end_date: 'Seleccione una fecha final para el plazo de estrategia de carga de de evidencias y valoración',
                no_participants: 'Registre almenos un participante',
                no_old_participants: 'Se debe mantener a un participante registrado',
                no_targets: 'Tiene que estar seleccionado objetivo a cargar evidencias y valorar',
                no_rubrics_message: 'No tiene rubricas configuradas en el estándar del proceso actual',
                no_cycle_selected: 'No hay ciclo seleccionado. Por favor seleccione un ciclo primero.',
                see_advance: 'Ver avance de la definición y carga de evidencia',
                inheritance: 'Heredar definición',
                advance_title: 'Avance de la definición y carga de evidencia',
                see_advance_valoration: 'Ver avance de valoración',
                advance_title_valoration: 'Avance de valoración',
                specific_advance: {
                    participant_valoration: 'Valoración por participante',
                    valoration_advance_tab: 'Avance por participante',
                    level_valoration: 'Valoración por nivel',
                    valoration_graphic_advance: 'Gráfica del avance de valoración',
                    valoration_graphic_table_tab: 'Tabla',
                    valoration_graphic_table: 'Tabla de valoración actual',
                    valorated_percentage: 'Porcentaje valorado',
                    average_assessment: 'Promedio de las valoraciones',
                    valuator: 'Valorador',
                    assessment: 'Valoración'
                },
                edit_config: 'Editar estrategia de definición y carga de evidencia',
                edit_config_valoration: 'Editar estrategia de valoración',
                invalid_value: 'Valor inválido. Debe estar entre 0 y 5.',
                valoration_options: {
                    method_one: {
                        label: 'Bajo nivel de objetividad',
                        description: 'La valoración se realiza asignando una nota directamente al nivel que se está evaluando.'
                    },
                    method_two: {
                        label: 'Alto nivel de objetividad',
                        description: 'En este nivel, no se valora directamente el nivel, sino los documentos que lo componen. Estos se califican mediante una rúbrica específica para cada tipo de documento.'
                    },
                    method_three: {
                        label: 'Medio nivel de objetividad',
                        description: 'La valoración se asigna al nivel evaluado a través de una rúbrica, proporcionando una evaluación más estructurada.'
                    },
                },
            },
            valoration_rubric: {
                more_info: 'Aquí puedes encontrar mas información relacionado a la pregunta.',
                decimals_number: 'El valor del campo debe tener máximo %{decimal} decimales.',
                rubric_draft_save: 'Borrador de la rubrica almacenada.',
                rubric_draft_cancel: 'No se pudo crear el borrador.',
                rubric_draft_created: 'Rubrica ya creada, actualizar de manera general.',
                rubric_draft_error: 'Error al crear el borrador de la rubrica.'
            }
        },
        instrument: {
            title_h: 'Lista de Instrumentos',
            title: 'Instrumentos',
            subtitle: 'Lista de Instrumentos',
            show_all: 'Mostrar todos los instrumentos',
            instrument_label: 'Instrumentos',
            description_label: 'Detalle',
            instrument_code_and_title: 'Código / Titulo del instrumento',
            publication_date: 'Fecha publicación',
            close_date: 'Fecha cierre',
            popover: {
                publication_date: 'Fecha en que fue publicada la encuesta',
                close_date: 'Fecha en que fue cerrada o despublicada la encuesta',
            },
            create_instrument_option_modal: {
                title: 'Crear instrumento',
                body: 'Crear un nuevo instrumento a partir de una plantilla, o un nuevo instrumento vacío.',
                create_instrument_from_template_button: 'Crear desde plantilla',
                create_new_instrument_button: 'Crear nuevo instrumento'
            },
            create: {
                title_h: 'Crear instrumento',
                title: 'Nuevo instrumento',
            },
            update: {
                title_h: 'Editar instrumento',
                title: 'Editar instrumento'
            },
            readonly: {
                title_h: 'Ver Instrumento',
                title: 'Instrumento <b>%{instrument}</b>'
            },
            code: 'Código',
            creation_date: 'Fecha de creación',
            state: 'Estado',
            presentation_mode: 'Método de presentación',
            instrument_title: 'Título',
            description: 'Propósito del instrumento',
            instrument_cycle: 'Ciclo del instrumento',
            random: 'Presentar las preguntas de manera aleatoria',
            answer_range: 'Rango de valor para las preguntas',
            manage_sections: 'Añadir Sección',
            save_instrument_button: 'Guardar',
            publish_instrument_button: 'Publicar Instrumento',
            inivite_instrument_button: 'Invitar participantes al Instrumento',
            set_template_instrument_button: 'Asignar instrumento como plantilla',
            set_groups_sample_button: 'Muestra esperada',
            config_instrument_matrix: 'Configurar matriz',
            delete_instrument_button: 'Eliminar instrumento',
            exit_instrument_button: 'Volver',
            publish_instrument_modal: {
                title: 'Publicar instrumento',
                publication_date: 'Fecha aplicación',
                current_date_button: 'Hoy',
                end_of_day_button: 'Fin del día',
                close_date: 'Fecha cierre',
                welcome_message_label: 'Mensaje de Bienvenida',
                ferewell_message_label: 'Mensaje de Despedida',
                welcome_message: 'Bienvenido/a',
                ferewell_message: 'Gracias por su participación',
                welcome_message_placeholder: 'Mensaje de Bienvenida',
                ferewell_message_placeholder: 'Mensaje de Despedida',
                empty_message_feedback: 'El campo %{field} es obligatorio.',
                max_length_message_feedback: 'Se ha excedido el número máximo de elementos en el texto',
                ferewell_message_feedback_message: 'El campo Mensaje de Despedida es obligatorio.',
                justification: {
                    not_published: 'Apertura de instrumento.',
                    pubished: 'Actualización fecha de cierre de instrumento.',
                    reopen: 'Solicitud de reapertura de instrumento (cambio fecha de cierre): '
                },
                reopen_justification_label: 'Justificación de solicitud',
                reopen_justification_placeholder: 'Ingrese la justificación de la solicitud de reapertura del instrumento',
                publish_button: 'Publicar',
                cancel_button: 'Cancelar',
                reopen_button: 'Reabrir instrumento',
                reopen_checkbox: 'Reabrir instrumento',
                close_date_button: 'Aceptar',
                publish_dates_validation_message: 'No puede publicar el instrumento sin fecha de publicación y sin fecha de cierre.',
                publish_success_message: 'Se ha publicado el instrumento exitosamente.',
                update_close_date_success_message: 'Se ha actualizado la fecha de cierre exitosamente.',
                reopen_success_message: 'Se ha realizado la solicitud de reapertura exitosamente.',
                publish_error_message: 'Ocurrió un problema mientras se publicaba el instrumento: ',
            },
            set_template_instrument: {
                title: 'Asignar instrumento como plantillas',
                body: 'Recuerde que al habilitar este instrumento como plantilla cualquier cambio que haga sobre el mismo se verá reflejado solo en los instrumentos creados posteriormente al cambio. Adicionalmente, esta plantilla estará habilitada en los diferentes estándares usados por su institución y en caso de que dicho estándar no tenga coincidencias en los códigos de matriz y grupos objetivo, la pregunta requerirá que estos dos elementos sean configurados sobre el nuevo estándar destino. ¿Desea asignar el instrumento para su uso como plantilla?',
                body_note: 'Nota: El instrumento debe estar creado para poder asignarse como plantilla',
                ok_button: 'Aceptar',
                cancel_button: 'Cancelar'
            },
            delete_instrument_modal: {
                title: 'Eliminar instrumento',
                warning_message: 'Se eliminarán todas las secciones y preguntas asociadas al instrumento. ¿Desea eliminar el instrumento?',
                delete_button: 'Eliminar',
                cancel_button: 'Cancelar'
            },
            set_groups_sample_modal: {
                title: 'Asignar muestra esperada',
                ok_button: 'Aceptar'
            },
            config_instrument_matrix_label: 'Asociar nivel de matriz al instrumento',
            config_instrument_matrix_modal: {
                title: 'Configurar niveles de la matriz',
                iteration_matrix_card: {
                    title: 'Matriz de evidencias',
                    body: 'Seleccione los niveles de la matriz.'
                },
                cross_cutting_matrix_card: {
                    title: 'Configurar matrices transversales',
                    add_button: 'Usar matriz',
                    already_exist_warning_message: 'Ya fue añadida esta matriz para su configuración.',
                    not_selected_error_message: 'Debe seleccionar una matriz para poder ser añadida.'
                },
                typeLevels: 'Niveles de la matriz',
                ok_button: 'Aceptar',
                cancel_button: 'Cancelar'
            },
            no_config_instrument_matrix_message: 'No se ha guardado una configuración de matriz para el proyecto actual.',
            state_options: {
                optionA: 'Seleccionar un estado',
                optionB: 'Activo',
                optionC: 'Inactivo'
            },
            presentation_options: {
                optionA: 'Seleccionar un método de presentación',
                optionB: 'Permitir una única oportunidad para registrar respuestas',
                optionC: 'Permitir múltiples oportunidades para registrar respuestas'
            },
            cycle_select_options: {
                default: 'Seleccionar ciclo'
            },
            answer_range_options: {
                default: 'Seleccionar rango',
                optionA: '[%{min} - %{max}]',
                optionB: '[%{min} - %{max}]'
            },
            confirmation_alert: {
                go_instrument_section_button: 'Completar instrumento actual',
                close_button: 'Cerrar',
                success_message: 'Instrumento creado con éxito.',
                error_message: 'Ocurrió un problema mientras se creaba el instrumento:',
                dates_error_message: 'La fecha de cierre es mayor a la fecha de publicación. Por favor actualice las fechas.'
            },
            add_section: {
                create: {
                    title_h: 'Crear Sección',
                    title: 'Nueva Sección'
                },
                update: {
                    title_h: 'Editar Sección',
                    title: 'Editar Sección'
                },
                readonly: {
                    title_h: 'Ver Sección',
                    title: 'Sección <b>%{section}</b>'
                },
                not_available_creation: 'No se puede crear una sección mientras el instrumento ya se encuentre abierto dentro de la fecha de publicación.',
                code: 'Código',
                state: 'Estado',
                order: 'Orden',
                section_title: 'Título',

                user_notes: {
                    label: 'Notas para el usuario',
                    default_text: 'Notas para el usuario',
                    max_length_message_feedback: 'Se ha excedido el número máximo de elementos en el texto'
                },
                description: 'Propósito de la sección',
                buttons: {
                    save: 'Guardar',
                    add: 'Añadir preguntas',
                    delete_section: 'Eliminar sección',
                    exit: 'Volver'
                },
                delete_section_modal: {
                    title: 'Eliminar sección',
                    warning_message: 'Se eliminarán las preguntas asociadas a la sección. ¿Desea eliminar la sección?',
                    delete_button: 'Eliminar',
                    cancel_button: 'Cancelar'
                },
                state_options: {
                    optionA: 'Seleccione un estado',
                    optionB: 'Activo',
                    optionC: 'Inactivo'
                },
                change_state_modal: {
                    warning_message: '<b>Nota:</b> Si cambia el estado de la sección mientras el instrumento este publicado, la sección y sus preguntas ya no seran requeridas en el instrumento y no se podra volver a habilitar.',
                    ok_button: 'Aceptar',
                    cancel_button: 'Cancelar'
                },
                order_option: {
                    optionA: 'Seleccione el orden de la sección'
                },
                confirmation_alert: {
                    add_new_section_button: 'Nueva sección',
                    close_button: 'Cerrar',
                    success_message: 'La sección fue añadida con éxito.',
                    error_message: 'Ocurrió un problema mientras se añadida la sección al instrumento:',
                },
                add_question_validation_alert: {
                    section_data_validation_error_message: 'No se puede añadir una pregunta a una sección sin nombre.'
                }
            },
            add_question: {
                create: {
                    title_h: 'Crear Pregunta',
                    title: 'Nueva Pregunta',
                },
                update: {
                    title_h: 'Editar Pregunta',
                    title: 'Editar Pregunta',
                },
                readonly: {
                    title_h: 'Ver Pregunta',
                    title: 'Pregunta <b>%{question}</b>'
                },
                not_available_creation: 'No se puede crear una pregunta mientras el instrumento ya se encuentre abierto dentro de la fecha de publicación.',
                code: 'Código',
                state: 'Estado',
                order: 'Orden',
                section: 'Sección',
                question: 'Pregunta',
                help: 'Ayuda',
                group: 'Grupo objetivo',
                type: 'Tipo pregunta',
                no_type_allowed_description: 'No hay descripción disponible',
                default_value: 'Valor por defecto',
                is_required: 'Pregunta obligatoria',
                require_justification: 'La respuesta requiere justificación',
                answer_decimals: 'Decimales en respuestas',
                final_evaluation: 'No interfiere en la calificación final de la percepción',
                associate_matrix: {
                    label: 'Asociar / consultar niveles de matriz',
                    button: 'Asociar niveles',
                    button_subquestion: 'Asociar niveles a subpregunta',
                    not_found_matrix: 'Aún no se han configurado los niveles de la matriz para asociar.',
                    modal: {
                        parent_question_title: 'Asignar niveles de matrices',
                        child_question_title: 'Asignar niveles de matrices a subpregunta',
                        ok_button: 'Aceptar',
                        close_button: 'Cerrar'
                    }
                },
                delete_question_modal: {
                    title: 'Eliminar pregunta',
                    warning_message: 'Se eliminará la pregunta del instrumento actual. ¿Desea eliminar la pregunta?',
                    delete_button: 'Eliminar',
                    cancel_button: 'Cancelar'
                },
                change_type_modal: {
                    title: 'Cambiar tipo de pregunta',
                    warning_message: 'Actualmente la pregunta tiene asignado un tipo y opciones de respuesta. Si cambia el tipo de pregunta las opciones serán eliminadas al guardar la pregunta. ¿Desea cambiar el tipo de pregunta?',
                    accept_change_button: 'Aceptar',
                    cancel_button: 'Cancelar'
                },
                state_options: {
                    optionA: 'Seleccione el estado de la pregunta',
                    optionB: 'Activo',
                    optionC: 'Inactivo'
                },
                change_state_modal: {
                    warning_message: '<b>Nota:</b> Si cambia el estado de la pregunta mientras el instrumento este publicado, la pregunta ya no sera requerida en el instrumento y no se podrá volver a habilitar.',
                    ok_button: 'Aceptar',
                    cancel_button: 'Cancelar'
                },
                order_options: {
                    optionA: 'Orden'
                },
                section_options: {
                    optionA: 'Seleccione la sección'
                },
                type_options: {
                    optionA: 'Seleccione el tipo de pregunta'
                },
                group_all_options: 'Todos',
                group_options: {
                    optionA: 'Grupo de apoyo especializado',
                    optionB: 'Egresados',
                    optionC: 'Externos',
                    optionD: 'Directivos',
                    optionE: 'Administrativos',
                    optionF: 'Docentes',
                    optionG: 'Alumnos'
                },
                range: {
                    min: 'Rango mínimo',
                    max: 'Rango máximo',
                    step: 'Paso',
                    status: '¿Visible?',
                    decimals: 'Decimales'
                },

                bool: {
                    option: {
                        title: 'Opción %{index}',
                        label: 'Opción',
                        weight: 'Peso'
                    },
                },

                validation: {
                    greater_than: 'El valor de este campo debe ser mayor al valor del campo "%{field}".',
                    module_of: 'El valor de este campo debe ser divisor del valor del campo "%{field}".',
                    in_range: 'El valor de este campo debe estar entre %{min} y %{max}',
                    decimals_number: 'El valor del campo debe tener máximo %{decimal} decimales.'
                },

                assessment: {
                    positive: {
                        title: 'Positiva',
                        label: 'Opción',
                        default: 'Fortalezas'
                    },

                    negative: {
                        title: 'Negativa',
                        label: 'Opción',
                        default: 'Oportunidades de mejora'
                    }
                },
                save_question_button: 'Guardar pregunta',
                delete_question_button: 'Eliminar pregunta',
                go_back_question_creation_button: 'Volver',
                confirmation_alert: {
                    add_new_question_button: 'Nueva pregunta',
                    go_section_button: 'Volver a la sección',
                    close_button: 'Cerrar',
                    error_message: 'Ocurrió un problema mientras se añadida la pregunta:',
                    group_error_message: 'No se puede añadir una pregunta sin grupos objetivos.'
                },

                selection: {
                    title: 'Opciones',
                    active: '¿Activa?',
                    option: 'Opción %{index}',
                    weight: 'Peso %{index}',
                    help: 'Ayuda %{index}',
                    add_option: 'Añadir opción',
                },

                matrix: {
                    row: {
                        title: 'Filas',
                        active: '¿Activa?',
                        option: 'Fila %{index}',
                        weight: 'Peso %{index}',
                        help: 'Ayuda %{index}',
                        add_option: 'Añadir fila',
                    },
                    column: {
                        title: 'Columnas',
                        active: '¿Activa?',
                        option: 'Opción %{index}',
                        weight: 'Peso %{index}',
                        help: 'Ayuda %{index}',
                        add_option: 'Añadir columna',
                    },
                },

                audiovisual: {
                    check_message: '¿Agregar URL de recurso audiovisual?',
                    type: 'Tipo de recurso',
                    url: 'URL del recurso',
                    audio: 'Audio (Soundcloud)',
                    image: 'Imagen (jpeg, jpg, gif, png)',
                    video: 'Video (Youtube)',
                    url_validation_message: 'La URL ingresada no coincide con el formato solicitado. Por favor ingrese un valor válido.',
                    options: {
                        title: 'Opciones',
                        active: '¿Activa?',
                        type: 'Tipo %{index}',
                        url: 'URL %{index}',
                        weight: 'Peso %{index}',
                        add_option: 'Añadir opción',
                    }
                },

                policy: {
                    question: 'Pregunta de aceptación de política',
                    url: 'Dirección de política de datos de la institución',
                    info: 'Una pregunta de tipo Política de Datos siempre estará activa, será obligatoria en el instrumento, y será la primera pregunta que todos los grupos objetivos responderán antes de poder contestar el instrumento. Puede crear múltiples preguntas de política de datos para un mismo instrumento, las cuales serán mostradas al inicio.'
                },

                matrix_multiple: {
                    row: {
                        title: 'Item',
                        active: '¿Activa?',
                        question: 'Pregunta %{index}',
                        help: 'Ayuda',
                        add_row: 'Añadir item',
                        add_option: 'Opción'
                    },
                    item: {
                        active: '¿Activa?',
                        option: 'Opción %{index}',
                        weight: 'Peso %{index}',
                    }
                },

                reference_matrix: {
                    item: {
                        title: 'Opciones de respuesta',
                        active: '¿Activa?',
                        option: 'Opción %{index}',
                        weight: 'Peso %{index}',
                        help: 'Ayuda %{index}',
                        add_item: 'Añadir item',
                    },
                    question: {
                        title: 'Objetivo',
                        type: 'Tipo Objetivo',
                        year: 'Año',
                        term: 'Periodo'
                    },
                    warning_year_message: 'Advertencia: Tenga en cuenta que al aplicar la pregunta, las subpreguntas serán construidas a partir del objetivo si existe para el año y periodo ingresados. Por favor revise con cuidado los años y periodos disponibles para su selección.',
                },

                conditional: {
                    title: 'Opciones de respuesta (Grupo)',
                    active: '¿Activa?',
                    option: 'Opción %{index}',
                    weight: 'Peso %{index}',
                    help: 'Ayuda %{index}',
                    add_option: 'Añadir opción',
                },

                objective_type_options: {
                    default: 'Seleccione el objetivo',
                    optionA: 'Docentes',
                },
                objective_years_options: {
                    default: 'Seleccione el año',
                },
                objective_terms_options: {
                    default: 'Seleccione el periodo',
                },
            },
            update_group_sample: {
                update_sample: 'Actualizar muestra',
                error_message: {
                    unknown_error: 'Error desconocido',
                    request_failed: 'Error al actualizar la muestra',
                    null_data: 'No se puede actualizar la muestra con datos nulos',
                },
            },
            dashboard: {
                title: 'Instrumento Dashboard',
                length: 'Total de instumentos',
                name: 'Nombre del instrumento',
                state: 'Estado',
                date_created: 'Fecha de creación',
                date_public: 'Publicación',
                date_public_range: '(inicio-cierre)',
                faculty: 'Programa',
                reopening: 'Reapertura',
                instrument: 'Instrumento',
                public_a: 'Publicado',
                public_s: 'Sin publicar',
                yes: 'Si',
                no: 'No',
                text: 'Seleccionar... ',
                apex_chart_bar: 'Instrumentos Publicados',
                apex_chart_pie: '% de instrumentos reabiertos',
                close: 'Cerrar'
            }
        },
        instrument_preview: {
            instrument_menu_preview_button: 'Pre-visualizar',
            instrument_menu_preview_button_hover: 'Vista previa del instrumento',
            title_h: 'Vista previa',
            title: 'Vista previa del instrumento <b>%{instrument}</b>',
            not_available: 'El instrumento no tiene vista previa o no existe',
            next_section: 'Sección siguiente',
            not_available_section: 'No se han creado secciones para este instrumento',
            not_available_question: 'No se han creado preguntas para esa sección',
            groups_select_label: 'Filtrar preguntas por grupo',
            download_error: 'No se pudo descargar la vista previa del instrumento. Intente de nuevo.',
            download_no_cycle: 'Seleccione un ciclo antes de descargar la vista previa del instrumento.',
            prev_section: 'Sección anterior',
            next_question: 'Pregunta siguiente',
            prev_question: 'Pregunta anterior',
            instrument_start: 'Inicio del instrumento',
            more_info: 'Aquí puedes encontrar mas información relacionado a la pregunta.',
        },
        instrument_apply: {
            title_h: 'Aplicación de instrumento',
            no_token: 'Verifique la url para acceder a la aplicación de un instrumento.',
            not_available: 'El instrumento ya expiro o no se encuentra disponible',
            max_attempts_exceeded: 'Ya has completado esta encuesta. Tus respuestas han sido guardadas.',
            max_attempts_allowed_message: 'Está apunto de realizar un intento para la encuesta.<br/> El número máximo de intentos para resolver la encuesta es <b>%{maxAttempts}</b>. <br/> Actualmente se encuentra en el intento <b>%{currentAttempt}</b>. <br/><br/><b>Nota:</b> Si inicia con un nuevo intento las respuestas se guardarán en un nuevo grupo, y se mostrarán las ultimas respuestas que haya diligenciado por pregunta. Si continua con un intento ya iniciado de la encuesta, recuerde que solo se tendrá por terminado el intento al oprimir el botón <b>Finalizar intento</b>.',
            ok_button: 'Aceptar',
            cancel_button: 'Cancelar',
            more_info: 'Aquí puedes encontrar mas información relacionado a la pregunta.',
            end_attempt: 'Finalizar',
            next_section: 'Sección siguiente',
            prev_section: 'Sección anterior',
            next_question: 'Pregunta siguiente',
            prev_question: 'Pregunta anterior',
            no_section_pending_questions: 'No hay más preguntas pendientes por contestar en esta sección.',
            no_last_section_pending_questions: 'No tiene más preguntas pendientes por contestar.',
            dependence_label: 'Depende de: ',

            question_validation: {
                is_required: 'Debe contestar todas las opciones obligatorias de esta pregunta',
                max_length: 'Se ha excedido el numero máximo de caracteres',
                decimals_number: 'El valor del campo debe tener máximo %{decimal} decimales.',
                between: 'El valor del campo debe estar entre %{minValue} y %{maxValue} .',
            },

            data_policy_modal: {
                title: 'Aceptación política de datos',
                body: '¿Acepta las siguientes condiciones de política de datos de su institución para realizar la encuesta?:',
                see_link: 'Ver enlace',
                ok_button: 'Aceptar',
                cancel_button: 'Cancelar',
                warning_message: 'Debe aceptar todos los términos para poder diligenciar el instrumento.'
            },
            message_modal_ok_button: 'Continuar'
        },
        instrument_objective: {
            title_h: 'Configuración de grupos objetivo para un instrumento',
            subtitle: 'Asigne las personas que aplicaran el instrumento dependiendo de su grupo objetivo.',
            add: 'Agregar participante',
            assign: 'Asignar',
            email: 'Correo:',
            advance: 'Avance:',
            users: 'Usuarios',
            close_instrument: 'Instrumento cerrado',
            delete_participant: 'Participante eliminado',
            delete_participant_error: 'Error en la eliminación',
            question_delete_participant: `¿Seguro que deseas eliminar el participante?`,
            forwarding: {
                button: 'Reenviar correos',
                button_modal: 'Reenviar',
                title_modal: 'Reenviar correos',
                no_user_message_modal: 'Todos los usuarios ya contestaron el instrumento.'
            },
            tree: {
                add_all: 'Añadir todos',
                started: 'Añadir invitaciones en inicio',
                not_started: 'Añadir invitaciones sin iniciar',
                remove_all: 'Eliminar todos',
            },
            not_sent_participants_notification: {
                title: 'Algunas invitaciones no se pudieron enviar',
                body: 'Abajo se agrupan por motivo. Estos correos quedan pendientes: cuando resuelva el motivo, vuelva a hacer la asignación y solo se intentará enviar a los pendientes. También puede descargar el Excel con estos correos y volver a cargarlo.',
                summary: '{count} correo no se envió | {count} correos no se enviaron',
                summary_of_total: '{count} de {total} correos no se enviaron',
                copy_button: 'Copiar correos',
                copied_message: 'Correos copiados al portapapeles',
                copy_error_message: 'No se pudieron copiar los correos. Use la descarga en Excel.',
                download_button: 'Descargar Excel',
                reason_column: 'Motivo',
                file_name: 'correos_no_enviados',
                reasons: {
                    INVALID_FORMAT: {
                        title: 'Correo mal escrito',
                        help: 'Revise que el correo esté bien escrito (que tenga @ y un dominio válido, sin espacios).'
                    },
                    INVALID_RECIPIENT: {
                        title: 'El correo no existe',
                        help: 'El servidor de correo del destinatario indicó que esta cuenta no existe. Confirme el correo con el participante.'
                    },
                    RATE_LIMIT: {
                        title: 'El proveedor de correo pidió esperar',
                        help: 'Se enviaron muchos correos en poco tiempo y el proveedor frenó el envío de forma temporal. Espere unos minutos y vuelva a hacer la asignación.'
                    },
                    DAILY_LIMIT: {
                        title: 'Se alcanzó el límite diario de envíos',
                        help: 'La cuenta de correo configurada para el contrato llegó a su cupo de envíos del día. Vuelva a hacer la asignación mañana o solicite configurar una cuenta adicional.'
                    },
                    INVALID_CREDENTIALS: {
                        title: 'Error en la cuenta de envío',
                        help: 'El usuario o la contraseña de la cuenta de correo configurada para el contrato no son válidos. Contacte al administrador para revisar la configuración de correo.'
                    },
                    CONNECTION: {
                        title: 'No hubo conexión con el servidor de correo',
                        help: 'No se pudo conectar con el servidor de correo. Vuelva a hacer la asignación en unos minutos.'
                    },
                    GENERAL: {
                        title: 'El servidor de correo rechazó el envío',
                        help: 'Vuelva a hacer la asignación. Si el problema continúa, contacte a soporte.'
                    },
                    UNKNOWN: {
                        title: 'No se pudo confirmar el envío',
                        help: 'Vuelva a hacer la asignación. Si el problema continúa, contacte a soporte.'
                    }
                },
                ok_button: 'Aceptar'
            },
            assign_participants_confirmation: {
                title: 'Asignar participantes',
                label: 'Resumen Lista Participantes',
                body: 'Está a punto de realizar la asignación a participantes y envío de correo a los correos añadidos. Se recomienda revisar cada uno de los correos destinados. ¿Desea realizar la asignación de los participantes?',
                cancel_button: 'Volver',
                ok_button: 'Aceptar'
            },
            table_participants_api: {
                program: 'Descripción SNIES',
                groups: 'Grupo Objetivo',
                email: 'Correo',
                phone: 'Telefono',
                level: 'Nivel',
                formation: 'Nivel De Formacion',
                campus: 'Sede',
                dependency: 'Dependencia',
                type: 'Tipo de Contrato',
                name: 'Nombre',
                faculty: 'Facultad',
                academic: 'Departamento',
                charge: 'Cargo',
                per_page: 'Paginación',
                limit: 'Limite de participantes',
                clear: 'Limpiar filtros',
                cancel: 'Cancelar',
                asigne: 'Asignar',
                filter: "Filtrar",
                index_api: "No.",
                message: "Aprobar la importación de los %{value} participantes con el filtro aplicado:"
            },
            assign_participants_message: 'Se han asignado las invitaciones para los participantes ingresados',
            forwarding_participants_message: 'Se han reenviado las invitaciones para los participantes seleccionados',
            instrument_without_access_title: 'Sin acceso al instrumento',
            instrument_without_access_message: 'El instrumento al que intenta acceder no está asociado al proceso actual.',
            instrument_without_access_recommendation: 'Por favor, verifique el proceso e instrumento, e inténtelo nuevamente.',
        },
        template_instrument: {
            title: 'Plantillas disponibles',
            subtitle: 'Crear un instrumento a partir de una plantilla existente.',
            template_instrument_select: 'Obtener plantillas por:',
            template_instrument_select_option: {
                optionA: 'Todos',
                optionB: 'Institución',
                optionC: 'Públicos'
            },
            template_table: {
                preview_button: 'Pre-visualizar',
                create_button: 'Usar plantilla'
            },
            cycle_select_options: {
                default: 'Seleccionar ciclo'
            },
            create_from_template_modal: {
                title: 'Crear Instrumento',
                instrument_name_input: 'Nombre del instrumento',
                instrument_cycle: 'Ciclo',
                create_button: 'Crear',
                cancel_button: 'Cancelar'
            }
        },
        instrument_chart: {
            button: 'Mostrar Seguimiento',
            version: {
                label: 'Versión:',
                option: 'Última versión por invitación',
            },
            follow: {
                tab: 'Seguimiento',
                daily: 'Seguimiento Diario de Aplicación de la Encuesta - Finalizadas',
                actor: 'Total de resultados por actor: ',
                title_chart: 'Seguimiento por actor',
                tooltip_unit: 'aplicacion(es)',
            },
            answers: {
                tab: 'Respuestas',
                empty_title: '¡Sin resultados!',
                empty_body: 'Por el momento aún no se encuentran resultados para esta pregunta.',
                title_chart: 'Cantidad de respuestas',
                subtitle_chart: 'Respuestas',
                label_table: 'Respuesta',
                tooltip_unit: 'respuesta(s)',
            },
            export: {
                file_pdf: 'Descargar gráficas',
                file_csv: 'Descargar resultados (CSV)'
            }
        },

        target: {
            campus: 'Sede',
            faculty: 'Facultad',
            code: 'Código',
            label: 'Etiqueta',
            save: 'Guardar',
            cancel: 'Cancelar',
            description: 'Descripción',
        },

        smtp_config: {
            title: 'Configuración de SMTP',
            create: {
                title: 'Nueva configuración de SMTP',
                sub_title: 'Diligencia el siguiente formulario. Los espacios con <span style="color: red">*</span> son obligatorios'
            },
            button_config: 'Configuración Servidor %{index}',
            email: 'Correo electrónico',
            password: 'Contraseña',
            server: 'Servidor',
            port: 'Puerto',
            priority: 'Prioridad',
            size: 'Capacidad',
            ssl: 'SSL',
            tls: 'TLS',
            status: 'Activo',
            save: 'Guardar',
            delete: 'Eliminar',
            add: 'Añadir',
            edit: 'Editar',
            email_method: 'Método de Envío de Correos',
            email_method_smtp: 'Enviar mediante SMTP',
            email_method_aws: 'Enviar mediante AWS SES',
            aws_section_title: 'Configuración de AWS SES',
            aws_info_text: 'Configure las credenciales de AWS SES para enviar emails con plantillas HTML renderizadas correctamente.',
            aws_verified_email: 'Email Verificado (Opcional)',
            aws_verified_email_help: 'Dejar vacío para usar por defecto (prest.evalua@gmail.com). Debe estar verificado en AWS SES Console.',
            aws_access_key: 'AWS Access Key ID',
            aws_access_key_help: 'Clave de acceso del usuario IAM con permisos SES.',
            aws_secret_key: 'AWS Secret Access Key',
            aws_secret_key_help: 'Clave secreta del usuario IAM (se mantiene segura).',
            aws_region: 'Región AWS',
            aws_region_help: 'Región de AWS donde está configurado SES.',
            aws_credentials_info_title: 'Importante: Renderizado de HTML',
            aws_credentials_info_text: 'Las credenciales AWS son requeridas para que los emails HTML se rendericen correctamente. Sin ellas, se enviarán como texto plano vía API de Evalua.',
            aws_centralized_credentials_title: 'Credenciales AWS Centralizadas',
            aws_centralized_credentials_info: 'Las credenciales de AWS SES están configuradas de forma segura en el servidor. Solo necesitas especificar opcionalmente un email verificado en AWS SES diferente al predeterminado.',
            optional: '(opcional)',
            aws_verified_email_placeholder: 'Deja vacío para usar el email predeterminado del sistema',
            toast: {
                success: '¡La configuración de SMTP fue exitosa!',
                error: '¡Se presentó un error al momento de intentar configurar el SMTP!. Por favor contacte al administrador.'
            }
        },
        aws_metrics: {
            dashboard_title: 'Dashboard de Métricas de Correos',
            loading: 'Cargando métricas...',
            monitoring_email: 'Monitoreando correo',
            total_sent: 'Total Enviados',
            delivered: 'Entregados',
            bounced: 'Rebotados',
            complaints: 'Quejas de Spam',
            last_7_days: 'Últimos 7 días',
            last_30_days: 'Últimos 30 días',
            last_90_days: 'Últimos 90 días',
            daily_trend: 'Tendencia Diaria',
            about_metrics: 'Acerca de estas Métricas',
            metrics_description: 'Estas métricas se obtienen directamente de AWS CloudWatch y muestran el rendimiento de los correos enviados desde el email verificado configurado. Los datos pueden tener un retraso de hasta 15 minutos.',
            no_data: 'No hay datos disponibles',
            error_loading_metrics: 'Error al cargar las métricas. Por favor intente de nuevo.',
            warning_high_rates: 'Advertencia: Tasas elevadas de rebote o quejas detectadas',
            high_bounce_rate: 'La tasa de rebote es {rate}% (recomendado < 5%)',
            high_complaint_rate: 'La tasa de quejas es {rate}% (recomendado < 0.5%)',
            ses_limits_warning: 'Tasas elevadas pueden afectar tu reputación de envío en AWS SES y podrían resultar en la suspensión de tu cuenta. Por favor revisa tu lista de correos y el contenido.',
            using_global_email_info: 'Este contrato no tiene un email verificado específico configurado, por lo que está usando el email global del sistema. Para usar un email específico, configúralo en la Configuración de AWS SES.'
        },
        improvements_plan: {
            title_activity: 'Actividades Plan de Mejora',
            title: 'Plan de mejora',
            title_follow_up: 'Seguimiento de Plan de Mejora',
            subtitle: '',
            code: 'Código',
            code_alt: 'Código institucional',
            follow: 'Seguimiento',
            cycle: 'Ciclo',
            process: 'Proyecto',
            name: 'Nombre',
            budget: 'Presupuesto total',
            budget_desc_no_save: 'Este valor es informativo , en caso de no registrar este valor cuando se asignan presupuestos a las actividades o acciones este se llenará automáticamente con la suma de estos.',
            label: 'Etiqueta',
            detail: 'Detalle o Justificación',
            source: 'Fuente hallazgo',
            goal: 'Meta',
            description_goal: 'Descripción de la %{name}',
            description_campus: 'Descripción de la Sede',
            description_description: 'Descripción de la evidencia',
            description_indicator: 'Descripción del indicador',
            description_plans: 'Seleccione un %{name}',
            description_perception: 'Seleccione una %{name}',
            description: 'Evidencia',
            objectiveP: 'Objetivo estratégico',
            aspect: 'Aspectos',
            transversal: 'Transversal',
            institutions: 'Programas e instituciones',
            plan: 'Planes',
            documental: 'Soportes y evidencias',
            statistic: 'Estadísticas',
            perception: 'Percepción',
            indicator: 'Indicadores',
            exogen: 'Exógenos',
            sic: 'Sistema integrado de Calidad',
            send: 'Crear Plan de Mejora',
            update: 'Guardar cambios',
            back: 'Volver',
            target_label_name: 'Objetivo',
            target_label_code: 'SNIES',
            support_label: 'Nombre',
            perception_label: 'Instrumento',
            open_follow: 'Abierto',
            month_follow: 'Mensual',
            two_month_follow: 'Bimestral',
            three_month_follow: 'Trimestral',
            four_month_follow: 'Cuatrimestral',
            six_month_follow: 'Semestral',
            anual_follow: 'Anual',
            bianual_follow: 'Bi-Anual',
            sic_modal: 'Asignación de Sistema integrado de Calidad',
            tab1: 'Información básica',
            tab2: 'Acciones y actividades',
            tab3: 'Servicios externos',
            tab4: 'Habilitar o Deshabilitar',
            create_action: 'Crear acción',
            new_action: 'Nueva acción',
            remove_activity: 'Para deshabilitar esta acción, primero debes deshabilitar todas las actividades asociadas. No es posible deshabilitar acciones que tengan actividades asociadas.',
            delete_action: '¿Estás seguro de que deseas deshabilitar esta acción? Una vez deshabilitado, no podrá ser gestionada dentro del plan de mejora',
            reactive_action: '¿Estás seguro de que deseas habilitar esta acción? Una vez habilitada, podrá ser gestionada dentro del plan de mejora.',
            state: 'Estado',
            update_action: 'Actualizar Acción',
            execution_short_term: 'Corto plazo',
            execution_medium_term: 'Medio plazo',
            execution_long_term: 'Largo plazo',
            execution_permanent: 'Permanente',
            execution_cyclic: 'Cíclico',
            execution: 'Ejecución',
            start_date: 'Fecha inicial',
            end_date: 'Fecha final',
            lapse_date: 'Fechas',
            advance: 'Avance',
            no_actions: 'Sin Acciones',
            no_evidence_matrix: 'Hace falta la Matriz de Evidencia',
            no_message_matriz: 'Para continuar con el Plan de Mejora, es necesario implementar la Matriz de evidencia para la delimitación y estructuración de la información que se obtiene.',
            guidance_message: 'Se recomienda que primero se cree la Matriz de Evidencia.',
            success_creation_alert_message: 'Plan de Mejora añadido exitosamente.',
            success_update_alert_message: 'Plan de Mejora actualizado exitosamente',
            success_delete_alert_message: 'Plan de Mejora eliminado exitosamente',
            success_error_alert_message: 'Faltan datos por adicionar',
            action_message: {
                success_creation_alert_message: 'Acción añadida exitosamente.',
                success_update_alert_message: 'Acción actualizada exitosamente',
                success_delete_alert_message: 'Acción eliminada exitosamente',
            },
            action: 'Acción',
            edit_action: 'Editar acción',
            view_action: 'Ver acción',
            disable_action: 'Deshabilitar acción',
            enable_action: 'Habilitar acción',
            action_name: 'Nombre de la acción de mejora',
            create_activity: 'Crear actividad',
            action_filter: 'Busca nombre de acción o códigos',
            no_activities: 'Sin actividades',
            new_activity: 'Nueva actividad',
            view_activity: 'Ver actividad',
            disable_activity: 'Deshabilitar',
            enable_activity: 'Habilitar',
            matrix_level: 'Nivel de la matriz',
            circle_question: 'Indique el nivel de la matriz al cual va a crear la acciones.',
            no_recomendation: 'Sin recomendaciones',
            action_recomendation: 'Acciones recomendadas',
            create: 'Crear acción hacia',
            strength: 'la fortaleza de ',
            oportunity: 'la oportunidad de mejora de ',
            weakness: 'la debilidad de ',
            matrix: 'Matriz',
            objective: 'Grupo objetivo',
            origin: '¿Por qué?',
            type: 'Tipo de Acción',
            activity_title: 'Actividad',
            edit_activity: 'Editar actividad',
            expected_result: 'Resultado esperado',
            select_type_origin: 'Seleccione el origen de datos',
            type_origin: 'Origen de datos',
            internal_origin: 'Origen interno',
            external_origin: 'Origen externo',
            internal_origin_desc: 'Se usara los datos del resultado del proceso del sistema PREST',
            external_origin_desc: 'Se usara los datos por medio de los webservices suministrados',
            accept: 'Aceptar',
            notes: 'Notas de evaluador',
            external_col: 'Responsables',
            under_external_col: 'Escriba el nombre y cargo',
            level_col: 'Nivel responsabilidad',
            under_level_col: 'Indique si es Institucional, facultad o programa',
            message_phva: 'La acción le hace falta el tipo de actividad: ',
            messages_phva: 'La acción le hacen falta los tipos de actividad: ',
            indicator_PDI: 'Indicador PDI',
            dimension_PDI: 'Dimensión estratégica PDI',
            program: 'Programa',
            object_PDI: 'Objetivo estratégico del PDI',
            project: 'Proyecto',
            budget_PDI: 'Presupuesto',
            activity: {
                title: 'Actividades',
                subtitle: '',
                code: 'Código',
                code_alt: 'Código institución',
                action: 'Acción o grupo',
                plan: 'Plan de mejora',
                campus: 'Sede',
                what: '¿Qué? <|> What?',
                strategicP: 'Planeación estratégica',
                name: 'Nombre de actividad',
                when: '¿Cuándo? <|> When?',
                start: 'Inicio',
                end: 'Fin',
                milestone: 'Agregar Entrega / Fecha de Entrega Parcial',
                milestone_name: 'Nombre de la entrega',
                milestone_date: 'Fecha de entrega',
                milestone_expected_percentage: 'Porcentaje esperado de la meta',
                milestone_add: 'Entrega',
                other_origin: 'Otros grupos objetivo',
                where: '¿Dónde? <|> Where?',
                targets: 'Sectores Impactados (programas, facultades, sedes, institución)',
                groups: 'Impacto',
                matrix: 'Matriz de evidencias',
                who: '¿Quién? <|> Who?',
                collaborator: 'Colaboradores',
                how_much: '¿Cuánto? <|> How Much?',
                resources: 'Recursos',
                how: '¿Cómo? <|> How?',
                action_type: 'Tipo actividad',
                auto_indicator: 'Indicador',
                type_indicator: 'Tipo de Indicador',
                base_line: 'Linea base',
                indicator_option: {
                    move: 'Gestión',
                    impact: 'Impacto',
                    result: 'Resultados'
                },
                at_plan: '(P) Planear',
                at_do: '(H) Hacer',
                at_verify: '(V) Verificar',
                at_act: '(A) Actuar',
                at_improvement: 'Mejoramiento',
                at_strengthening: 'Fortalecimiento',
                at_unknown: 'Tipo desconocido',
                result: 'Resultado',
                result_kpi: 'KPI',
                result_quantity: 'Presupuesto',
                result_document: 'Documento o enlace',
                result_other: 'Otro',
                result_1: '1. Actividades de incidencia social e impacto regional',
                result_2: '2. Bienestar institucional de la comunidad educativa',
                result_3: '3. Cualificación docente',
                result_4: '4. Desarrollo físico y sostenibilidad ambiental',
                result_5: '5. Desarrollo tecnológico',
                result_6: '6. Infraestructura',
                result_7: '7. Internacionalización',
                result_8: '8. Inversión planta física',
                result_9: '9. Inversiones muebles y enseres, maquinaria y equipo y bienes bibliográficos',
                indicator_move: 'Gestion',
                indicator_impact: 'Impacto',
                indicator_result: 'Resultado',
                indicator_arch: 'Logro',
                why: '¿Por qué? <|> Why?',
                plans: 'Planes',
                quantity: 'Cifras',
                sic: 'SIC',
                indicator: 'Indicadores documentales',
                notes: 'Notas de evaluador',
                perception: 'Percepción',
                exogen: 'Fuentes Exógenas',
                other: 'Otros',
                tags: 'Tags',
                add: 'Agregar actividad',
                update: 'Actualizar actividad',
                delete: 'Eliminar actividad',
                disable_activity: 'Deshabilitar actividad',
                enable_activity: 'Habilitar actividad',
                tags_placeholder: 'Ingrese los elementos y sepárelos por coma',
                colab: 'Colaborador',
                rol: 'Rol',
                add_colab: 'Añadir Colaborador',
                update_colab: 'Editar Colaborador',
                r_type: 'Tipo recurso',
                r_detail: 'Detalle recurso',
                r_value: 'Valor unidad',
                r_scale_value: 'Escala valor',
                r_quantity: 'Cantidad',
                r_scale_quantity: 'Escala cantidad',
                r_scale: 'No. Decimales',
                r_origin: 'Origen',
                r_url: 'URL',
                add_resource: 'Añadir Recurso',
                update_resource: 'Actualizar Recurso',
                remove: 'Quitar',
                escape: 'Volver',
                follow_type: 'Tipo de seguimiento',
                url_follow: 'URL de seguimiento externo',
                internal_follow: 'Seguimiento Interno',
                external_follow: 'Seguimiento Externo',
                remove_activity: 'No es posible deshabilitar esta actividad, se tienen avances asociados a las Actividades del Plan de Mejora.',
                active_activity: 'No es posible habilitar esta actividad, primero se debe habilitar la acción que corresponde esta actividad.',
                delete_activity: '¿Estás seguro de que deseas deshabilitar esta actividad? Una vez deshabilitado, no podrá ser gestionada dentro del plan de mejora',
                reactive_activity: '¿Estás seguro de que deseas habilitar esta actividad? Una vez habilitada, podrá ser gestionada dentro del plan de mejora.',
                create: {
                    success: 'Actividad creada',
                    error: 'Error al crear la actividad'
                },
                edit: {
                    success: 'Actividad editada',
                    error: 'Error al editar la actividad'
                },
            },
            file_load: {
                load_action: 'Cargar de acciones',
                load_action_file: 'Cargar archivo de acciones',
                load_activity: 'Cargar de actividades',
                load_activity_file: 'Cargar archivo de actividades',
                advanced: 'Opciones avanzadas',
                related_activity: 'Crear actividad por defecto',
                download_format_activity: 'Descargar formato carga de actividades',
                download_format_actions: 'Descargar formato carga de acciones',
                format_alert: '¡Alerta! Por favor, evita modificar los encabezados del formato, ya que esto puede comprometer la integridad de los datos. Si tienes alguna pregunta, no dudes en contactar a un administrador para obtener asistencia.'
            },
            dashboard_improvement_plan: {
                title: 'Dashboard - Plan de Mejora',
                subtitle: 'Monitoreo integral de planes de mejoramiento por programa académico',
                pdf_button: 'PDF',
                excel_button: 'Excel',
                filter: {
                    title: 'Filtros',
                    sede: 'Sede',
                    department: 'Facultad',
                    program: 'Programa',
                    project: 'Proyecto',
                    cycle: 'Ciclo',
                    factor: 'Factor CNA-Matriz',
                    all_campuses: 'Todas las sedes',
                    all_faculties: 'Todas las facultades',
                    all_programs: 'Todos los programas',
                    all_projects: 'Todos los proyectos',
                    all_cycles: 'Todos los ciclos',
                    all_factors: 'Todos los factores'
                },
                tabs: {
                    executives: 'Vista Directivos',
                    action_progress: 'Avance por Acción',
                    responsibles: 'Responsables',
                    all_activities: 'Todas las Actividades',
                    traffic_light: 'Semáforo de Alertas'
                },
                faculty_progress: {
                    title: 'Avance por Facultad',
                    subtitle: 'Comparación de programas completados vs en progreso',
                    completed: 'Completados',
                    in_progress: 'En progreso',
                    programs: 'programas',
                    no_data: 'No hay datos de facultades disponibles para mostrar.',
                    page: 'Página',
                    of: 'de'
                },
                executives: {
                    ranking_title: 'Ranking de Programas por Avance',
                    ranking_subtitle: 'Comparativo de desempeño entre programas académicos',
                    table: {
                        position: 'Posición',
                        program: 'Programa',
                        self_assessment_progress: 'Avance Esperado',
                        general_progress: 'Avance General',
                        completed_activities: 'Actividades Completadas',
                        late_activities: 'Actividades Retrasadas'
                    },
                    total_programs: 'Total programas',
                    autoevaluation_progress: 'Avance Esperado',
                    general_progress: 'Avance General',
                    delayed_activities: 'Actividades Retrasadas',
                    early_alerts: 'Alertas Tempranas',
                    button_details: 'Ver detalles',
                    no_data: 'No hay datos para mostrar'
                },
                action_progress: {
                    program: 'Programa',
                    responsible: 'Responsable',
                    advance: 'Avance General',
                    activities: 'Actividades',
                    expected: 'Esp',
                    no_data: 'No hay acciones disponibles para mostrar.',
                    page: 'Página',
                    of: 'de',
                    unassigned: 'Sin asignar'
                },
                activities: {
                    state: 'Estado',
                    activity: 'Actividad',
                    program: 'Programa',
                    factor_cna: 'Factor CNA',
                    responsible: 'Responsable',
                    end_date: 'Fecha Fin',
                    advance: 'Avance',
                    complete: 'Completada',
                    alert: 'Alerta',
                    warning: 'Advertencia',
                    early_alert: 'Alerta Temprana',
                    waited: 'Esperado',
                    expected: 'Esperado',
                    no_record: 'Sin registro',
                    no_data: 'No hay datos',
                    page: 'Página',
                    of: 'de',
                    filters: {
                        all: 'Todas',
                        completed: 'Completadas',
                        late: 'Retrasadas',
                        warning: 'Advertencia',
                        early_alert: 'Alerta Temprana',
                        in_progress: 'En progreso'
                    },
                    table: {
                        status: 'Estado',
                        activity: 'Actividad',
                        program: 'Programa',
                        factor_cna: 'Factor CNA',
                        responsible: 'Responsable',
                        end_date: 'Fecha Fin',
                        progress: 'Avance',
                        last_update: 'Última Actualización'
                    },
                    status: {
                        completed: 'Completada',
                        late: 'Retrasada',
                        warning: 'Advertencia',
                        early_alert: 'Alerta Temprana',
                        in_progress: 'En progreso',
                        no_status: 'Sin estado'
                    }
                },
                responsibles: {
                    activity_name: 'Nombre Actividad',
                    subtitle: 'Información actual de cada actividad con el último registro de avance',
                    responsible: 'Responsable(s)',
                    last_date_register: 'Última Fecha Registro',
                    current_progress: 'Avance Actual',
                    expected_progress: 'Avance Esperado',
                    status_header: 'Estado',
                    program: 'Programa',
                    factor_cna: 'Factor CNA',
                    page: 'Página',
                    of: 'de',
                    no_record: 'Sin registro',
                    status: {
                        completed: 'Completada',
                        late: 'Retrasada',
                        warning: 'Advertencia',
                        early_alert: 'Alerta Temprana',
                        in_progress: 'En progreso',
                        no_status: 'Sin estado'
                    }
                },
                traffic_light: {
                    complete: 'Completadas',
                    caution: 'Advertencia (≤30 días)',
                    late: 'Atrasadas (>30 días)',
                    title: 'Sistema de Alertas Tempranas',
                    end: 'Actividades finalizadas al 100%',
                    description: 'Actividades con menos de 30 días para vencer o con avance menor al esperado',
                    late_label: 'Retrasadas',
                    late_description: 'Actividades que han superado su fecha límite sin completarse',
                    early_alerts: 'Alertas Tempranas',
                    defeated: 'Vencidas',
                    description_alerts: 'Se generan cuando el avance actual es menor al avance esperado para la fecha, incluso si la actividad no ha vencido. Esto permite tomar acciones correctivas a tiempo.'
                },

            },
        },

        review: {
            title: 'Evaluación final',
            sub_title: 'Por niveles de estándar',
            no_result: '¡Sin resultado!',
            dofa_button: 'Análisis DOFA',
            processing: 'Iniciando sesión DOFA...',

            popover_info: {
                average: 'Promedio',
                weight: 'Peso'
            },

            weighing: {
                see: 'Ver ponderación',
                title: 'Ponderación'
            },

            assessment: {
                title: 'Percepción',
                sub_title: 'Promedio por estamento',
                no_info: 'No se han aplicado instrumentos o no se han registrado resultados cuantificables.',
                no_groups_data_title: '¡Sin resultado por estamento!',
                no_groups_data_sub_title: 'El nivel actual no fue asignado en los instrumentos de percepción para mostrar resultados por estamento.'
            },

            evidence: {
                title: 'Documental',
                sub_title: 'Cantidad de documentos valorados por tipo',
                no_info: 'No se han valorado documentos.',
                no_document_data_title: '¡Sin resultado por tipo de documento!',
                no_document_data_sub_title: 'El nivel actual no tiene documentos asignados para mostrar resultados por tipo.'
            },

            statistical_evidence: {
                title: 'Estadístico',
                sub_title: 'Cantidad de documentos estadísticos valorados por tipo',
                no_info: 'No se han valorado documentos.',
                no_document_data_title: '¡Sin resultado por tipo de documento!',
                no_document_data_sub_title: 'El nivel actual no tiene documentos asignados para mostrar resultados por tipo.'
            },

            supports: {
                title: 'Documentos',
                sub_title: 'Lista de documentos valorados',
            },

            improvement_plan: {
                title: 'Recomendaciones para el plan de mejora',
                button: 'Ver OF'
            },

            name_graph: {
                feature_1: "Área Polar",
                feature_2: "Linea",
                feature_3: "Barras",
                feature_4: "Radio",
                feature_5: "Circular",
                feature_6: "Anillo"
            },
        },

        teacher_review: {
            title: 'Evaluación Docente',
            no_result: '¡Sin resultado!',
            config: 'Configuración de evaluación docente',
            accept: 'Aceptar',
            applicant: 'aplicación para el instrumento: ',
            instrument: 'Seleccione un instrumento',
            version: 'Seleccione una aplicación del instrumento',
            add: 'Agregar',
            remove: 'Eliminar',
            percentage: 'Porcentaje en la evaluación',
            percentage_remaining: 'máximo disponible',
            open_config: 'Abrir configuración',
            close: 'Cerrar',
            no_more_100: 'No puede tener mas de 100% en los porcentajes de evaluación'
        },
        add_standard: {
            title: '<b>Crear Nuevo Estandar</b>',
            subtitle: 'Creación de un nuevo estándar para el contrato',
            standard_name: 'Nombre estándar',
            standard_description: 'Descripción estándar',
            standard_min_target: 'Nivel Target Mínimo',
            standard_max_target: 'Nivel Target Máximo',
            standard_type: 'Tipo Estándar',
            copy_matrix_standard: {
                header: 'Configuración Matriz',
                copy_label: 'Copiar Matriz',
                default_option: 'Seleccionar estándar'
            },
            copy_timeline_standard: {
                header: 'Configuración Cronograma',
                copy_label: 'Copiar Cronograma',
            },
            custom_validation_messages: {
                not_valid_total_formula: 'La suma de los valores de la fórmula debe ser igual a 100.',
                not_valid_target_levels: 'Se debe seleccionar un Nivel Target Máximo mayor al Nivel Target Mínimo.',
            },
            success_creation_alert_message: 'Se ha creado el estándar exitosamente.',
            error_creation_alert_message: 'Ocurrió un problema mientras se creaba el estándar.',
            save_button: 'Guardar',
            back_button: 'Volver'
        },
        contract: {
            alternative_title: 'Contrato',
            section_one: {
                tab: 'Configuración y personalización de la plataforma',
                title: 'Logos y página de inicio',
                logo_url: 'Logotipo principal',
                logo_alt: 'Logotipo lateral',
                color_code: 'Color Institucional',
                icon_lateral: 'Icono lateral visible',
                url_anexa: 'URL de redirección icono lateral',
                message: 'Texto en página de inicio',
                alert_title_save: 'Guardar cambios de personalización',
                alert_message_save: 'Advertencia: Al guardar los cambios de personalización, se modificarán las opciones previas de su institución. ¿Está seguro de que desea continuar?',
                icon_logo: 'No mostrar logo inferior en email',
                accept_url_support: 'Aceptar soportes mediante URL',
            },
            section_two: {
                tab: 'Actualizar política de datos',
                title: 'Política de datos',
                policy_url: 'URL política de tratamiento de datos Institucional',
                alert_title_save: 'Actualizar política de tratamiento de datos Institucional',
                alert_message_save: '¿Desea actualizar la política de tratamiento de datos? Este cambio implicará que todos los usuarios deban aceptarla de nuevo.',
            },
            section_three: {
                tab: 'Personalización de los estándares',
                title: 'Estándares personalizados',
                standard: 'Estándar',
                status: 'Estado',
                name: 'Nombre del estándar',
                description: 'Descripción del estándar',
                appreciation: 'Apreciación',
                statistics: 'Estadístico',
                evidence: 'Documental',
                modal_reports: {
                    title: 'Vincular reportes al estándar'
                },
                system_reports: 'Reportes del sistema',
                report_standard: 'Reportes para el estándar',
                groups_appreciation: 'Públicos Objetivos Instrumentos',
                groups_evidence: 'Grupos especializados matriz',
                empty: 'No se encontraron estándares personalizados',
                add_reports: 'Vincular reportes',
                alert_title_save: 'Actualizar estándar',
                alert_message_save: 'Advertencia: Al guardar los cambios de personalización del estándar se modificarán las opciones previas. ¿Está seguro de que desea continuar?',
                objectives_cards: {
                    name: 'Grupos objetivos',
                    inputs: {
                        input_name: {
                            on_edit_label: 'Nombre del grupo objetivo',
                            to_show_label: 'Grupo objetivo',
                        },
                        input_description: {
                            on_edit_label: 'Descripción',
                            to_show_label: '',
                        },
                    },
                    no_objectives: 'No hay objetivos'
                },
                buttons: {
                    scheduler_template_button: 'Consultar y editar plantilla cronograma',
                    matrix_template_button: 'Consultar y editar Plantilla Matriz',
                    rubrics_button: 'Consultar y editar rubricas de valoración'
                }
            },
            util: {
                message_placeholder: 'Ingrese el mensaje que aparecerá en la página de inicio y la contraportada de los reportes',
                save: 'Guardar cambios',
                confirm: 'Confirmar',
                cancel: 'Cancelar',
                add_standard: 'Crear estándar',
                open_view: 'Abrir vista previa'
            }
        },
        rubrics: {
            rubric_list: {
                title: 'Rúbricas',
                subtitle: 'Lista de rúbricas por estándar',
                table: {
                    code_col: 'Código',
                    rubric_col: 'Rúbrica',
                    type_col: 'Tipo pregunta'
                },
                add_buton: 'Añadir rúbrica',
                no_edit_allowed: {
                    alert_header: 'Sin acceso a rúbricas',
                    alert_message: 'No es posible visualizar las rúbricas del estándar seleccionado.'
                }
            },
            rubric_form: {
                add_title: 'Añadir rúbrica',
                edit_title: 'Editar rúbrica',
                rubric_name: 'Nombre Rúbrica',
                help: 'Ayuda',
                question: 'Pregunta',
                status: 'Estado',
                code: 'Código',
                detail: 'Detalle',
                question_type: 'Tipo de pregunta',
                save_button: 'Guardar',
                return_button: 'Volver',
                status_options: {
                    option_A: 'Seleccione el estado',
                    option_B: 'Activo',
                    option_C: 'Inactivo'
                },
                type_default_option: 'Seleccione el tipo',
                change_type_modal: {
                    title: 'Cambiar tipo de pregunta',
                    warning_message: 'Actualmente la pregunta tiene asignado un tipo y opciones de respuesta. Si cambia el tipo de pregunta las opciones serán eliminadas al guardar la pregunta. ¿Desea cambiar el tipo de pregunta?',
                    accept_change_button: 'Aceptar',
                    cancel_button: 'Cancelar'
                },
                max_length_message_feedback: 'Se ha excedido el número máximo de elementos en el texto',
                required_all_fields_message: 'Aún existen campos obligatorios sin rellenar',
                error_loading_rubric: 'Error al cargar los datos de la rúbrica'
            }
        },
        dashboard: {
            alternative_title: 'Dashboard general',
            title: 'Dashboard general de procesos',
            subtitle: 'Aquí podrá ver el dashboard general de control de todos los procesos de su institución.',
        },

        dashboard_action: {
            main: {
                title: 'Dashboard Seguimiento de Proyectos',
                subtitle: 'Sistema de Seguimiento y Avances de Proyectos',
                comparative_mode: 'Modo Comparativo',
                configuration: 'Configuración',
                filters: 'Filtros',
                filters_labels: {
                    sede: 'Sede',
                    faculty: 'Facultad',
                    program: 'Programa',
                    cycle: 'Ciclo',
                    matrix: 'Matriz'
                },
                filter_options: {
                    all_sedes: 'Todas las sedes',
                    all_faculties: 'Todas las facultades',
                    all_programs: 'Todos los programas',
                    all_cycles: 'Todos los ciclos',
                    all_factors: 'Todos los factores'
                },
                tabs: {
                    summary: 'Resumen',
                    state: 'Estado',
                    progress: 'Avance',
                    activities: 'Matriz de Evidencia',
                    schedule: 'Cronograma'
                },
                messages: {
                    tab_changed: 'Tab cambiado',
                    error_loading_data: 'Error al obtener datos del dashboard',
                    error_loading_filters: 'Error al obtener filtros'
                }
            },
            activities: {
                title: 'Dashboard de Actividades',
                subtitle: 'Seguimiento detallado del desarrollo de actividades por categoría',
                completed_count: '{completed} de {total} completadas',
                activities_of: 'Actividades de {category}',
                responsible: 'Responsable',
                due_date: 'Vence',
                progress: 'Progreso',
                completed_by: 'Completado por {person}',
                on_date: 'el',
                tabs: {
                    weighting: 'Ponderación',
                    definition: 'Definición',
                    evidences: 'Evidencias',
                    assessment: 'Valoración'
                },
                status: {
                    completed: 'Completado',
                    in_progress: 'En progreso',
                    in_development: 'En desarrollo'
                },
                examples: {
                    activity_1: 'Definición de criterios de evaluación',
                    activity_2: 'Asignación de pesos por factor',
                    activity_3: 'Validación de ponderaciones'
                }
            },
            advance: {
                activities_progress: 'Progreso de Actividades',
                activities_progress_subtitle: 'Estado actual de las principales actividades del proceso',
                faculty_progress: 'Avance por Facultad',
                faculty_progress_subtitle: 'Comparación de programas completados vs en progreso',
                monthly_trend: 'Tendencia Mensual',
                monthly_trend_subtitle: 'Programas completados e iniciados por mes',
                process_distribution: 'Distribución por Tipo de Proceso',
                process_distribution_subtitle: 'Porcentaje de programas por tipo de proceso',
                labels: {
                    weighting: 'Ponderación',
                    definition: 'Definición',
                    evidence_upload: 'Cargue de Evidencias',
                    assessment: 'Valoración',
                    instruments_perception: 'Percepción de Instrumentos'
                },
                faculties: {
                    engineering: 'Ingeniería',
                    medicine: 'Medicina',
                    law: 'Derecho',
                    administration: 'Administración',
                    education: 'Educación'
                },
                chart_labels: {
                    completed: 'Completados',
                    in_progress: 'En progreso',
                    started: 'Iniciados'
                },
                process_types: {
                    accreditation: 'Acreditación',
                    qualified_registration: 'Registro Calificado',
                    new_registration: 'Nuevo Registro'
                },
                months: {
                    jan: 'Ene',
                    feb: 'Feb',
                    mar: 'Mar',
                    apr: 'Abr',
                    may: 'May',
                    jun: 'Jun'
                }
            },
            resume: {
                recent_programs: 'Programas Recientes',
                recent_programs_subtitle: 'Últimos programas actualizados en el sistema',
                expires: 'Vence',
                vs_previous_month: 'vs mes anterior',
                cards: {
                    active_programs: 'Programas Activos',
                    active_programs_desc: 'Total de programas en proceso',
                    completed: 'Completados',
                    completed_desc: 'Programas finalizados este mes',
                    in_progress: 'En Progreso',
                    in_progress_desc: 'Programas en desarrollo',
                    late: 'Retrasadas',
                    late_desc: 'Requieren atención inmediata'
                }
            },
            scheduler: {
                title: 'Cronograma de Actividades',
                subtitle: 'Seguimiento del avance por programa en el proceso de acreditación',
                completed_by: 'Completado por',
                total_stages: 'Etapas Totales',
                total_activities: 'Actividades Totales',
                completed: 'Completadas',
                general_progress: 'Progreso General',
                programs: 'programas',
                no_programs_in_phase: 'No hay programas en esta fase.',
                total_programs: 'Total Programas',
                phase_distribution: 'Distribución por Fase',
                current_phase: 'Fase actual',
                activities_completed: 'actividades completadas',
                no_programs: 'No hay programas registrados',
                phase_breakdown: 'Avance por Fase de Acreditación',
                phase_names: {
                    ponderacion: 'Ponderación',
                    definicion: 'Definición de Evidencias',
                    evidencias: 'Cargue de Evidencias',
                    valoracion: 'Valoración'
                },
                stages: {
                    stage_1: 'Etapa 1: Planificación y Preparación',
                    stage_2: 'Etapa 2: Recolección de Información',
                    stage_3: 'Etapa 3: Análisis y Evaluación'
                },
                status: {
                    completed: 'Completado',
                    in_progress: 'En progreso',
                    in_development: 'En desarrollo'
                },
                activities: {
                    team_formation: 'Conformación del equipo de trabajo',
                    schedule_definition: 'Definición de cronograma general',
                    team_training: 'Capacitación del equipo',
                    base_documents: 'Preparación de documentos base'
                }
            },
            state: {
                title: 'Estado de Programas',
                subtitle: 'Seguimiento detallado de fechas y procesos de acreditación',
                ranking_title: 'Ranking de Programas por Avance',
                ranking_subtitle: 'Comparación de desempeño entre programas académicos',
                export: 'Exportar',
                search_placeholder: 'Buscar programas...',
                no_data: 'No hay programas que coincidan con la búsqueda.',
                page: 'Página',
                of: 'de',
                table: {
                    program: 'Programa',
                    faculty: 'Facultad',
                    sede: 'Sede',
                    cycle: 'Ciclo',
                    development_date: 'F. Desarrollo',
                    filing_date: 'F. Radicación',
                    resolution_date: 'F. Resolución',
                    status: 'Estado',
                    progress: 'Progreso',
                    actions: 'Acciones'
                },
                modal: {
                    title: 'Detalle del Programa',
                    general_info: 'Información General',
                    dates: 'Fechas del Proceso',
                    progress: 'Estado y Avance',
                    close: 'Cerrar'
                }
            },
            matrix_progress: {
                info_banner: {
                    title: 'Progreso de la Matriz de Evidencia',
                    description: 'Visualiza el avance por programa en cada fase del proceso de autoevaluación: Ponderación, Definición, Cargue de Evidencias y Valoración.'
                },
                categories: {
                    all: 'Todos'
                },
                phases: {
                    ponderacion: 'Ponderación',
                    definicion: 'Definición',
                    evidencias: 'Evidencias',
                    valoracion: 'Valoración'
                },
                progress: 'Progreso',
                of: 'de',
                no_activities: 'No hay actividades para mostrar con los filtros seleccionados.'
            }
        },

        reports: {
            title: 'Reportes',
            subtitle: 'Generar reportes del proceso de autoevaluación para el ciclo actual.',
            success: 'Se envió la solicitud para generar el reporte.',
            filters: 'Filtros',
            iteration: 'Ciclo',
            year: {
                name: 'Año',
                message: 'Diligencie el año desde el cual se desea generar la información:',
            },
            period: {
                name: 'Periodo',
                message: 'Seleccione el periodo desde el cual se desea generar la información:',
            },

            weighing_card: {
                header: 'Ponderación'
            },

            documental_card: {
                header: 'Documentos'
            },

            format_modal: {
                title: 'Formato',
                message: 'Por favor elegir el formato para realizar la solicitud de generación del reporte.',

                excel: 'EXCEL',
                pdf: 'PDF',
                all: 'TODOS LOS FORMATOS',
                word: 'WORD'
            },

            fields: {
                request_date: 'Fecha de la petición',
                format: 'Formato',
                label: 'Reporte',
                buttons: 'Acciones'
            },

            warning_message: 'No hay reportes asociados al estándar del proceso de autoevaluación actual.',
            permissions_message: 'No tiene permisos para realizar solicitudes de reportes.'
        },

        templates: {
            title: 'Plantillas de información institucional',
            subtitle: 'Información de la institución alojada en las plantillas que se dirigen al ministerio.',

            new: {
                button: 'Crear plantilla',

                modal: {
                    title: 'Añadir una nueva plantilla',
                },
                name: 'Nombre',
                description: 'Descripción',

                card: {
                    title: 'Campos',

                    fields: {
                        name: 'Nombre',
                        description: 'Descripción'
                    }
                }
            }
        },
        templates_eva: {
            title: 'Plantillas evaluación docente',
            subtitle: 'Información de la institución alojada para la evaluación docente y cargue de información institucional de estudiantes, docentes, cursos y recursos.',

            new: {
                button: 'Crear plantilla',

                modal: {
                    title: 'Añadir una nueva plantilla',
                },
                name: 'Nombre',
                description: 'Descripción',

                card: {
                    title: 'Campos',

                    fields: {
                        name: 'Nombre',
                        description: 'Descripción'
                    }
                }
            }
        },
        notes: {
            title_h: 'Notas',
            subtitle: 'Aquí encontrara las notas de evaluación para este proyecto: &data.',
            add: 'Agregar Nota',
            create_conclusion: 'Crear nota de conclusión',
            see_conclusion: 'Ver nota de conclusión',
            no_notes: 'Sin Notas',
            meets: '¿Cumple?',
            yes: 'Si',
            no: 'No',
            observation_type: 'Tipo de observación',
            type_one: 'Reconocimiento',
            type_two: 'No conformidad',
            type_three: 'Observación',
            type_four: 'Nota Cerrada',
            type_five: 'Nota de conclusión',
            objective: 'Objetivo',
            matrix: 'Matriz',
            note: 'Nota',
            notes: 'Notas',
            creation_date: 'Fecha de creación',
            term_date: 'Fecha de plazo',
            actions: 'Acciones',
            new_note: 'Nueva nota',
            see_note: 'Ver Detalle',
            edit_note: 'Editar nota',
            close_note: 'Cerrar nota',
            save: 'Guardar',
            term: 'Plazo',
            days: 'Días',
            weeks: 'Semanas',
            months: 'Meses',
            years: 'Años',
            semesters: 'Semestres',
            weighing: 'Ponderación',
            perception: 'Percepción',
            valoration: 'Documental',
            improvement: 'Plan de mejora',
            process: 'Todo el Proyecto',
            see_notes: 'Ver notas',
            title: 'Titulo',
            level: 'Nivel de la nota',
            high_level: 'Mayor',
            low_level: 'Menor',
            activities_pm: 'Actividades del plan de mejora relacionadas',
            no_activities_pm: 'Sin actividades del plan de mejora',
            detail: 'Detalle',
            ok: 'Aceptar',
            version: 'Versión',
            versions: 'Versiones',
            created: 'La nota ha sido creada satisfactoriamente',
            updated: 'La nota se ha actualizado satisfactoriamente',
            closed: 'La nota ha sido cerrada satisfactoriamente',
            user: 'Evaluador',
            my: {
                title: 'Mis notas',
                subtitle: 'Aquí encontrara todas sus notas en todos los proyectos que evalúe.'
            }
        },
        participants: {
            load_participants: 'Cargar desde participantes',
            participants: 'Participantes',
            cancel: 'Cancelar',
            ok: 'Cargar',
            select_type: 'Selecciona un grupo de participantes a cargar',
            success: 'Se cargaran &x participantes.',
            warning: 'Se encontraron &x participantes, sin embargo los datos de los participantes no están actualizados a este año y periodo, ¿quiere continuar con la carga de participantes?',
            danger: 'No se encontraron participantes registrados en el grupo seleccionado.',

        },
        artificial_intelligence: {
            title_panel: 'Bienvenido a la sección de Agentes de IA',
            sub_title_panel: 'El espacio interactivo para potenciar la autoevaluación y fortalecer la excelencia académica.',
            reporting: 'Reportes'

        },
        chat_bot: {
            conversation: 'Conversación',
            message_placeholder: 'Escribe un mensaje...',
        },
        wrapper: {
            view_forbidden: 'Su rol no tiene acceso a PRESTV2.',
            user_not_found: 'No encontramos su usuario en PRESTV2. Contacte a su administrador.',
            project_not_active: 'Este proyecto ya no está activo y no está disponible para continuar.',
            upstream_down: 'El proyecto no está disponible para continuar en este momento. Intente de nuevo en unos minutos.',
            upstream_timeout: 'El proyecto no está disponible para continuar: no respondió a tiempo. Intente de nuevo en unos minutos.',
            session_expired: 'Su sesión de PRESTV2 terminó. Vuelva a abrir el proyecto.',
            readonly: 'Esta acción no está disponible desde Academy.',
            project_mismatch: 'Abrió otro proyecto en otra pestaña. Recargue esta para continuar con el proyecto actual.',
            no_contract: 'El proyecto no está disponible para continuar: no encontramos un contrato vigente de PRESTV2 asociado a este proyecto. Contacte al administrador de su institución.',
            route_denied: 'Esta acción no está permitida desde Academy.',
            payload_too_large: 'Lo enviado supera el tamaño máximo por carga. Si son archivos, envíelos por partes o reduzca su tamaño.',
            payload_too_large_max: 'Lo enviado supera el tope de &max MB por carga. Si son archivos, envíelos por partes o reduzca su tamaño.',
            retry: 'Reintentar',
            projects_limit_notice: 'Se muestran los 200 proyectos con fecha de fin más próxima',
            dofa_unavailable: 'El módulo DOFA no está disponible en este ambiente.',
            dofa_readonly: 'El módulo DOFA no está disponible en un proyecto en solo lectura.',
            project_readonly: 'Este proyecto ya terminó y está en solo lectura: puede consultarlo y descargar reportes y documentos, pero no crear, editar ni eliminar.',
            project_sheet: 'Ficha del proyecto',
            link_invalid: 'El enlace guardado no es una dirección web válida, así que no se abrió.',
            link_wrapper: 'Este enlace abre PRESTV2 dentro de Academy. No se abre en otra pestaña para no cerrar esta sesión.',
            kept_link: 'Déjelo vacío para conservar el enlace guardado, que dentro de Academy no se muestra. Escriba una URL solo si quiere cambiarlo.',
        },
    }
}

export default messages